{
    "common": {
        "added": {
            "label": {},
            "msg": {},
            "code": {}
        },
        "label": {
            "Webhooks": "Webhooks",
            "Delivery history": "Histórico de entregas",
            "Request ID": "ID da solicitação",
            "Status code": "Código de status",
            "Response time": "Tempo de resposta",
            "Result": "Resultado",
            "Select result": "Selecionar resultado",
            "Success": "Sucesso",
            "webhook": "webhook",
            "Create Webhook": "Criar webhook",
            "Search by webhook name": "Pesquisar por nome do webhook",
            "Show value": "Mostrar valor",
            "Connection settings": "Configurações de conexão",
            "Triggers": "Gatilhos",
            "Webhook": "Webhook",
            "Endpoint URL": "URL do endpoint",
            "Headers": "Cabeçalhos",
            "Hide value": "Ocultar valor",
            "Remove header": "Remover cabeçalho",
            "Transport format": "Formato de envio",
            "HTTP Method": "Método HTTP",
            "Recent deliveries": "Envios recentes",
            "Request body example": "Exemplo de corpo da requisição",
            "Response": "Resposta",
            "When an asset is created": "Quando um ativo é criado",
            "When an asset is updated": "Quando um ativo é atualizado",
            "When an asset is published": "Quando a URL pública de um ativo é publicada",
            "When an asset is deleted": "Quando um ativo é excluído",
            "When an asset is unpublished": "Quando a publicação da URL pública de um ativo é cancelada",
            "Asset created": "Ativo criado",
            "Asset updated": "Ativo atualizado",
            "Asset published": "URL pública do ativo publicada",
            "Asset deleted": "Ativo excluído",
            "Asset unpublished": "URL pública do ativo despublicada",
            "Views": "Visualizações",
            "Updating": "Atualizando",
            "By URL": "Por URL",
            "Usage trend": "Tendência de uso",
            "Top {{count}} URLs": "Top {{count}} URLs",
            "Top {{count}} referring domains": "Top {{count}} domínios de origem",
            "Top {{count}} countries": "Top {{count}} países",
            "{{total}} total": "{{total}} no total",
            "Published target": "Alvo publicado",
            "Last viewed": "Última visualização",
            "{{count}} published": "<0>{{count}}</0> publicado(s)",
            "As of {{hours}} hour(s) ago": "Dados de {{hours}} hora(s) atrás",
            "As of {{days}} day(s) ago": "Dados de {{days}} dia(s) atrás",
            "As of less than an hour ago": "Dados de menos de uma hora atrás",
            "Public URL statistics": "Estatísticas de URL pública",
            "Usage of {{count}} public URL(s)": "Uso de {{count}} URL(s) pública(s)",
            "Public URL statistics details": "Detalhes das estatísticas de URL pública",
            "{{active}} published, {{released}} unpublished": "<0>{{active}}</0> publicados · <1>{{released}}</1> despublicados",
            "({{active}} published, {{released}} unpublished)": "({{active}} publicados, {{released}} despublicados)",
            "left axis": "(eixo esq.)",
            "right axis": "(eixo dir.)",
            "Estimated visitors": "Visitantes estimados",
            "Data transferred": "Dados transferidos",
            "Referring domains": "Domínios de origem",
            "Countries": "Países",
            "Last {{days}} days": "Últimos {{days}} dias",
            "Gen AI": "Gen AI",
            "Dimension": "Dimensão",
            "{{from}}-{{to}} of {{count}}": "{{from}}-{{to}} de {{count}}",
            " - Total {{totalSize}}": " - Total {{totalSize}}",
            "Add Vocabulary?": "Adicionar vocabulário?",
            "Add to all": "Adicionar a todos",
            "All items cannot be deleted.": "Não é possível excluir todos os itens.",
            "Archiving...": "Arquivando...",
            "Asset to be analyzed": "Ativo a ser analisado",
            "Bucket name must be between 3 and 63 letters and start with alphabet or number with allowed special characters of -, _, and .)": "O nome do bucket deve ter entre 3 e 63 caracteres, começar com letra ou número e permitir apenas os caracteres especiais -, _ e .",
            "Choose on Organizer": "Selecionar organizador",
            "Close my jobs": "Fechar meus trabalhos",
            "Close tab menu": "Fechar menu de abas",
            "Collapse panel": "Recolher painel",
            "Copy to {{name}}": "Copiar para {{name}}",
            "Customer": "Cliente",
            "Default value": "Valor padrão",
            "Destination": "Destino",
            "Domain URL": "URL do domínio",
            "Drive": "Drive",
            "Duplicate the item?": "Duplicar o item?",
            "Empty Recoding History": "Nenhum histórico de gravação",
            "Enter Vocabulary name": "Insira o nome do vocabulário",
            "Enter after entering": "Pressione Enter após digitar",
            "Enter field description": "Insira a descrição do campo",
            "Enter prefix": "Insira o prefixo",
            "Entering Console…": "Entrando no console…",
            "Error renaming from {{item1}} to {{item2}}.": "Erro ao renomear de {{item1}} para {{item2}}.",
            "Event Triggers": "Gatilhos de evento",
            "Expand panel": "Expandir painel",
            "Failed": "Falhou",
            "Find objects by prefix": "Buscar objetos por prefixo",
            "Go to Search Results": "Ir para os resultados da busca",
            "Grouping": "Agrupamento",
            "Height": "Altura",
            "Id": "ID",
            "If you need permission, please contact your account manager.": "Se precisar de permissão, entre em contato com o gerente da sua conta.",
            "In use": "Em uso",
            "Ingested": "Ingerido",
            "Ingesting": "Ingerindo",
            "Min": "Mín",
            "Moving...": "Movendo...",
            "No requests list": "Nenhuma lista de solicitações",
            "Offline": "Offline",
            "Open tab menu": "Abrir menu de abas",
            "Other": "Outro",
            "Permission to access is required.": "É necessária permissão de acesso.",
            "Please create an organizer.": "Crie um organizador.",
            "Prefix cannot be empty": "O prefixo não pode estar vazio",
            "Prefix must begin with s3://": "O prefixo deve começar com s3://",
            "Preview Image": "Imagem de pré-visualização",
            "Progressing": "Em andamento",
            "Project name cannot be empty": "O nome do projeto não pode estar vazio",
            "Re-Approval requested": "Reaprovação solicitada",
            "Search Projects": "Buscar projetos",
            "Search by execution ID": "Buscar por ID de execução",
            "Select Language": "Selecionar idioma",
            "Select Service Type": "Selecionar tipo de serviço",
            "Select Storage": "Selecionar armazenamento",
            "Share to \"{{name}}\"": "Compartilhar com \"{{name}}\"",
            "Smiling": "Sorrindo",
            "Space ID": "ID do espaço",
            "CDN ID": "ID do CDN",
            "System management": "Gerenciamento do sistema",
            "There is no resource in video.": "Não há recursos no vídeo.",
            "There was an error creating the new folder {{item}}.": "Ocorreu um erro ao criar a nova pasta {{item}}.",
            "Total for all projects": "Total de todos os projetos",
            "Use all": "Usar todos",
            "View Files": "Ver arquivos",
            "View History": "Ver histórico",
            "Vocabularies": "Vocabulários",
            "Vocabulary Book Search Results": "Resultados da busca no vocabulário",
            "Width": "Largura",
            "You do not have permission.": "Você não tem permissão.",
            "Zoom In": "Ampliar",
            "Zoom Out": "Reduzir",
            "and": "e",
            "canceled": "cancelado",
            "complete": "concluído",
            "error": "erro",
            "group": "grupo",
            "loading...": "carregando...",
            "preview": "pré-visualização",
            "remove": "excluir",
            "requested": "solicitado",
            "user": "usuário",
            "weekly": "semanalmente",
            "{{name}} Search Results": "Resultados da busca de {{name}}",
            "READY TO DOWNLOAD": "PRONTO PARA DOWNLOAD",
            "STARTING": "INICIANDO",
            "STOPPING": "PARANDO",
            "SUBMITED": "SUBMETIDO",
            "UNKNOWN": "DESCONHECIDO",
            "AWS": "AWS",
            "Daglo": "Daglo",
            "S3 Glacier Deep Archive": "S3 Glacier Deep Archive",
            "S3 Glacier Flexible Retrieval": "S3 Glacier Flexible Retrieval",
            "Subsy": "Subsy",
            "Image zoom in": "Ampliar imagem",
            "Add Option": "Adicionar opção",
            "Labels": "Rótulos",
            "Filter labels": "Filtrar rótulos",
            "Go to details": "Ir para detalhes",
            "Select Key": "Selecionar chave",
            "Current Space": "Espaço atual",
            "Stage List": "Lista de estágios",
            "Empty Widget List": "Nenhum widget",
            "Enlarge Layout": "Ampliar layout",
            "Video Player": "Player de vídeo",
            "Copying": "Copiando",
            "Empty Published History": "Nenhum histórico de publicação",
            "Request Details": "Detalhes da solicitação",
            "Results for your Search": "Resultados da sua busca",
            "Average Confidence (%) : More than": "Confiança média (%) : Acima de",
            "Prev": "Anterior",
            "Go Detail": "Ir para detalhes",
            "By Last Created": "Por data de criação",
            "day": "dia",
            "Only Unused Files": "Apenas arquivos não utilizados",
            "Access Token": "Token de acesso",
            "Refresh Token": "Token de atualização",
            "Projects Allowed to Use": "Projetos permitidos para uso",
            "Go to error item": "Ir para item com erro",
            "Error message": "Mensagem de erro",
            "How to resolve": "Como resolver",
            "Continue editing": "Continuar editando",
            "Acknowledge and save": "Confirmar e salvar",
            "Add parallel step": "Adicionar etapa paralela",
            "WORKFLOW_QUEUED": "Na fila",
            "WORKFLOW_READY": "Pronto",
            "WORKFLOW_RUNNING": "Em execução",
            "WORKFLOW_COMPLETED": "Concluído",
            "WORKFLOW_FAILED": "Falhou",
            "WORKFLOW_EXPIRED": "Expirado",
            "Start Date": "Data de início",
            "End Date": "Data de término",
            "Duration (sec)": "Duração (seg)",
            "bucketName": "Nome do bucket",
            "prefix": "Prefixo",
            "fileUrl": "URL do arquivo",
            "extension": "Extensão",
            "extensions": "Extensões",
            "minByte": "Byte mínimo",
            "maxByte": "Byte máximo",
            "assetId": "ID do ativo",
            "mediaType": "Tipo de mídia",
            "attributions": "Atribuições",
            "tags": "Tags",
            "categories": "Categorias",
            "description": "Descrição",
            "extendedMetadata": "Metadados estendidos",
            "virtualLocation": "Localização",
            "collection": "Coleção",
            "pipelineId": "ID do pipeline",
            "videoId": "ID do vídeo",
            "promptId": "ID do prompt",
            "storageClass": "Classe de armazenamento",
            "platform": "Plataforma",
            "isCreateOriginAsset": "Salvar a fonte de origem como um ativo",
            "AI Search Mode": "Modo de busca por AI",
            "Default Metadata Template": "Modelo de Metadados Padrão",
            "Custom Header": "Cabeçalho Personalizado",
            "Grant Space Admin": "Conceder administração do espaço",
            "Grant Project Admin": "Conceder administração do projeto",
            "1st": "1º",
            "2nd": "2º",
            "3rd": "3º",
            "4th": "4º",
            "5th": "5º",
            "6th": "6º",
            "- Total {{totalSize}}": "- Total {{totalSize}}",
            "{{count}} views": "{{count}} por página",
            "{{name}} files": "{{name}} arquivos",
            "{{name}} ID": "ID de {{name}}",
            "{{name}} inquiry": "Consulta de {{name}}",
            "{{name}} overview": "Visão geral de {{name}}",
            "New": "Novo",
            "24 hours": "24 horas",
            "24/7": "24/7",
            "Accept": "Aceitar",
            "Account": "Conta",
            "Action": "Ação",
            "Actions": "Ações",
            "Active": "Ativo",
            "ACTIVE": "ATIVO",
            "ACTIVE / INACTIVE TOGGLE": "ALTERNAR ATIVO / INATIVO",
            "Add": "Adicionar",
            "Add {{name}}": "Adicionar {{name}}",
            "Add a category": "Adicionar uma categoria",
            "Add caption": "Adicionar legenda",
            "Add faces": "Adicionar rostos",
            "Add files": "Adicionar arquivos",
            "Add image": "Adicionar imagem",
            "Add images": "Adicionar imagens",
            "Add lineup": "Adicionar lineup",
            "Add roles": "Adicionar funções",
            "Add teams": "Adicionar equipes",
            "Add users": "Adicionar usuários",
            "Add posters": "Adicionar pôsteres",
            "Admin": "Administrador",
            "Administration": "Administração",
            "Advanced search": "Busca avançada",
            "ALL": "TODOS",
            "All event type": "Todos os tipos de evento",
            "All ingest type": "Todos os tipos de ingestão",
            "All language": "Todos os idiomas",
            "All media type": "Todos os tipos de mídia",
            "All media types": "Todos os tipos de mídia",
            "All pipeline": "Todos os pipelines",
            "All project": "Todos os projetos",
            "All source": "Todas as origens",
            "All state": "Todos os estados",
            "All status": "Todos os status",
            "All type": "Todos os tipos",
            "All types": "Todos os tipos",
            "Allowed special characters": "Caracteres especiais permitidos",
            "Alternative name": "Nome alternativo",
            "Alternative names": "Nomes alternativos",
            "Amount": "Quantidade",
            "Amount : {{amount}}": "Quantidade: {{amount}}",
            "Analyzed": "Analisado",
            "Analyzing": "Analisando",
            "Anywhere": "Em qualquer lugar",
            "Appears to be happy": "Parece estar feliz",
            "Appears to be male": "Parece ser do sexo masculino",
            "Apply": "Aplicar",
            "Approval": "Aprovação",
            "Approval in progress": "Aprovação em andamento",
            "Approval request": "Solicitação de aprovação",
            "Approval requested": "Aprovação solicitada",
            "Approval status": "Status de aprovação",
            "Approve": "Aprovar",
            "Approve whitelist": "Aprovar lista de permissões",
            "Approved": "Aprovado",
            "Approved whitelist": "Lista de permissões aprovada",
            "Asset": "Ativo",
            "Asset ID": "ID do ativo",
            "Asset name": "Nome do ativo",
            "Assets": "Ativos",
            "Assets {{name}}": "Ativos {{name}}",
            "Attribution": "Atribuição",
            "Attributions": "Atribuições",
            "Audio": "Áudio",
            "Audio settings": "Configurações de áudio",
            "Audit logs": "Logs de auditoria",
            "Audit-Logs": "Logs de auditoria",
            "Authority": "Autoridade",
            "Auto Start/Stop": "Início/Parada automático",
            "Automated Workflow": "Fluxo de trabalho automatizado",
            "AWS medialive channel": "Canal AWS MediaLive",
            "AWS medialive input": "Entrada AWS MediaLive",
            "Base video": "Vídeo base",
            "Blank time": "Tempo em branco",
            "Cancel": "Cancelar",
            "CANCELED": "CANCELADO",
            "Cannot delete the stream": "Não é possível excluir o stream",
            "Image": "Imagem",
            "Caption": "Legenda",
            "Caption label": "Rótulo de legenda",
            "Captions": "Legendas",
            "Categories": "Categorias",
            "Categories selected": "Categorias selecionadas",
            "Category": "Categoria",
            "Category description": "Descrição da categoria",
            "Category group": "Grupo de categorias",
            "Category group description": "Descrição do grupo de categorias",
            "Category group name": "Nome do grupo de categorias",
            "Category groups": "Grupos de categorias",
            "Celebrity recognition": "Reconhecimento de celebridades",
            "Channel": "Canal",
            "Channel description": "Descrição do canal",
            "Channel ID": "ID do canal",
            "Channel Logo": "Logo do Canal",
            "Channel overview": "Visão geral do canal",
            "Channel state of non-scheduled time": "Estado do canal fora do horário programado",
            "Channels": "Canais",
            "Chapter": "Capítulo",
            "Choose on schedules": "Escolher por programações",
            "Choose on stream": "Escolher por stream",
            "Choose on streams": "Escolher por streams",
            "Client ID": "ID do cliente",
            "Client IP": "IP do cliente",
            "Client secret": "Segredo do cliente",
            "Client useragent": "User agent do cliente",
            "Clone": "Clonar",
            "Close": "Fechar",
            "Cloud": "Nuvem",
            "Cloud inquiry": "Consulta na nuvem",
            "CloudPlex Media": "CloudPlex Media",
            "CloudPlex Media subtitle editor": "Editor de legendas CloudPlex Media",
            "CMS": "CMS",
            "Code": "Código",
            "COMPLETE": "CONCLUÍDO",
            "Completed": "Concluído",
            "Conditions": "Condições",
            "Confidence": "Confiança",
            "Configuration": "Configuração",
            "Constraints": "Restrições",
            "Content moderation": "Moderação de conteúdo",
            "Contents": "Conteúdos",
            "Contents duration": "Duração do conteúdo",
            "Copy": "Copiar",
            "Copyright": "Direitos autorais",
            "Correct status": "Status correto",
            "Create": "Criar",
            "Create {{name}}": "Criar {{name}}",
            "Create {{name}} asset": "Criar ativo {{name}}",
            "Create MP4 asset": "Criar ativo de VÍDEO",
            "Create MP3 asset": "Criar ativo de ÁUDIO",
            "Create IMAGE asset": "Criar ativo de IMAGEM",
            "Create CAPTION asset": "Criar ativo de LEGENDA",
            "Created": "Criado",
            "Creator": "Criador",
            "Execution History": "Histórico de execução",
            "Execution Result": "Resultado da execução",
            "Flow Detail Information": "Informações detalhadas do fluxo",
            "Created by": "Criado por",
            "Creating": "Criando",
            "CSV Export": "Exportar CSV",
            "Cumulative viewers": "Espectadores acumulados",
            "Cumulative views": "Visualizações acumuladas",
            "Cumulative viewing time": "Tempo de visualização acumulado",
            "Current time": "Hora atual",
            "Current viewers": "Espectadores atuais",
            "Currently online": "Atualmente online",
            "Custom fields": "Campos personalizados",
            "Cycle": "Ciclo",
            "Dailys": "Diários",
            "Dashboard": "Dashboard",
            "Date": "Data",
            "Date picker": "Seletor de data",
            "Date format": "Formato de data",
            "Day": "Dia",
            "Days": "Dias",
            "Default": "Padrão",
            "Delete": "Excluir",
            "Delete all": "Excluir tudo",
            "Deleted": "Excluído",
            "Deleted output asset retention": "Retenção de ativo de saída excluído",
            "Description": "Descrição",
            "Desktop": "Desktop",
            "Destination A": "Destino A",
            "Destination B": "Destino B",
            "Detach": "Desanexar",
            "Detach {{name}}": "Desanexar {{name}}",
            "Detail": "Detalhe",
            "Direct": "Direto",
            "Direct input": "Entrada direta",
            "Disable": "Desabilitar",
            "Down": "Baixo",
            "Download": "Download",
            "Download apps": "Download de aplicativos",
            "Download filtered list": "Baixar lista filtrada",
            "Download full list": "Baixar lista completa",
            "DRAFT": "Rascunho",
            "Draft": "Rascunho",
            "DUAL": "DUPLO",
            "Dual": "Duplo",
            "Dubbing": "Dublagem",
            "MultipleAudios": "Múltiplos áudios",
            "Duration": "Duração",
            "Edit": "Editar",
            "Email": "E-mail",
            "Embed code": "Código de incorporação",
            "Employee Sign in": "Acesso de funcionário LX Hausys",
            "Empty": "Vazio",
            "Empty {{name}}": "Não há {{name}}",
            "Every {{interval}} days": "A cada {{interval}} dias",
            "Enable": "Habilitar",
            "Encoding profile": "Perfil de codificação",
            "End": "Fim",
            "End date": "Data de término",
            "End now": "Encerrar agora",
            "End time": "Hora de término",
            "Endpoint": "Endpoint",
            "Endpoints": "Endpoints",
            "Error": "Erro",
            "ERROR": "ERRO",
            "Etc": "Etc.",
            "Event": "Evento",
            "EVENT": "EVENTO",
            "Event triggers": "Gatilhos de evento",
            "Event type": "Tipo de evento",
            "EventTrigger": "Gatilho de evento",
            "EventTrigger description": "Descrição do gatilho de evento",
            "EventTrigger name": "Nome do gatilho de evento",
            "EventTriggers": "Gatilhos de evento",
            "Every": "Todo(a)",
            "Expired": "Expirado",
            "Expired at": "Expirado em",
            "Expired date": "Data de expiração",
            "Face": "Rosto",
            "Face anlaysis": "Análise de rosto",
            "Face index": "Índice de rosto",
            "Face search": "Busca de rosto",
            "Facebook": "Facebook",
            "Faces": "Rostos",
            "Faces selected": "Rostos selecionados",
            "Field type search": "Busca por tipo de campo",
            "Field {{count}}": "Campo {{count}}",
            "File": "Arquivo",
            "File name": "Nome do arquivo",
            "File source": "Origem do arquivo",
            "Files": "Arquivos",
            "Folder name": "Nome da pasta",
            "Folder search": "Busca de pasta",
            "Follow default values": "Seguir valores padrão",
            "Force inheritance": "Forçar herança",
            "Fri": "Sex",
            "Friday": "Sexta-feira",
            "General": "Geral",
            "Go to schedule": "Ir para programação",
            "Grand additional roles": "Conceder funções adicionais",
            "Grant all permissions": "Conceder todas as permissões",
            "Grant project access": "Conceder acesso ao projeto",
            "Granted": "Concedido",
            "Granted roles": "Funções concedidas",
            "Hide": "Ocultar",
            "High": "Alto",
            "Highest": "Mais alto",
            "Hub scope": "Todos os projetos",
            "Hyper Browser": "Hyper Browser",
            "ID": "ID",
            "Idle": "Ocioso",
            "IMAGE": "IMAGEM",
            "Image setting": "Configuração de imagem",
            "Image sources": "Origens de imagem",
            "Images selected": "Imagens selecionadas",
            "Inactive": "Inativo",
            "Index": "Índice",
            "Indexing": "Indexando",
            "Indexed": "Indexado",
            "Index file": "Arquivo de índice",
            "Individual settings": "Configurações individuais",
            "Ingest type": "Tipo de ingestão",
            "Ingest": "Ingestão",
            "INGEST": "INGESTÃO",
            "INGESTED": "INGERIDO",
            "INGESTING": "INGERINDO",
            "Inherit": "Herdar",
            "Input {{index}}": "Entrada {{index}}",
            "Input asset auto delete": "Exclusão automática de ativo de entrada",
            "Input detail": "Detalhe da entrada",
            "Input path": "Caminho de entrada",
            "Input storage": "Armazenamento de entrada",
            "Input storage path": "Caminho do armazenamento de entrada",
            "Inputs": "Entradas",
            "Instagram": "Instagram",
            "Interval": "Intervalo",
            "IP range": "Faixa de IP",
            "Job": "Tarefa",
            "Job {{name}}": "Tarefa {{name}}",
            "Job ID": "ID da tarefa",
            "Job overview": "Visão geral da tarefa",
            "Jobs": "Tarefas",
            "Key": "Chave",
            "Kind": "Tipo",
            "Label": "Rótulo",
            "Label detection": "Detecção de rótulo",
            "Language": "Idioma",
            "Last access": "Último acesso",
            "Last accessed at": "Último acesso em",
            "Leave": "Sair",
            "Leave comment": "Deixar comentário",
            "Linear": "Linear",
            "LINEAR": "LINEAR",
            "Lineup": "Lineup",
            "Lineup copy": "Cópia de lineup",
            "Lineup count": "Contagem de lineup",
            "Lineup detail": "Detalhe de lineup",
            "Lineup name": "Nome do lineup",
            "List": "Lista",
            "Listing": "Listagem",
            "Schedules": "Programações",
            "SCHEDULES": "PROGRAMAÇÕES",
            "Schedules detail": "Detalhe das programações",
            "Schedules ID": "ID das programações",
            "Schedules overview": "Visão geral das programações",
            "Live": "Ao vivo",
            "Live player URL": "URL do player ao vivo",
            "Loading...": "Carregando...",
            "Local": "Local",
            "Local file": "Arquivo local",
            "Logo": "Logotipo",
            "Looks like a face": "Parece um rosto",
            "Loop": "Loop",
            "Loop to fill lineup duration": "Loop para preencher duração do lineup",
            "Low": "Baixo",
            "Lowest": "Mais baixo",
            "Main": "Principal",
            "Mark in": "Marcar entrada",
            "Mark in~out": "Marcar entrada~saída",
            "Mark out": "Marcar saída",
            "Max": "Máx",
            "Maximum object size": "Tamanho máximo do objeto",
            "Maximum schedule amount": "Quantidade máxima de programações",
            "Media": "Mídia",
            "Media service": "Serviço de mídia",
            "Media service inquiry": "Consulta de serviço de mídia",
            "Media type": "Tipo de mídia",
            "Medium": "Médio",
            "Megazone ID": "ID da Megazone",
            "Members": "Membros",
            "Metadata": "Metadados",
            "Metadata description": "Descrição dos metadados",
            "Metadata name": "Nome dos metadados",
            "Metadata schema description": "Descrição do esquema de metadados",
            "Mon": "Seg",
            "Monday": "Segunda-feira",
            "Month": "Mês",
            "Months": "Meses",
            "More than 50%": "Mais de 50%",
            "MP4": "MP4",
            "Multi Audio": "Multi Áudio",
            "My jobs": "Minhas tarefas",
            "Name": "Nome",
            "Name / ID": "Nome / ID",
            "Name constraints": "Restrições de nome",
            "Never": "Nunca",
            "No": "Não",
            "No options": "Sem opções",
            "No {{name}}": "Sem {{name}}",
            "No asset contents": "Sem conteúdo de ativo",
            "No asset searched.": "Nenhum ativo encontrado.",
            "No category searched": "Nenhuma categoria encontrada",
            "None": "Nenhum",
            "Not copy to": "Não copiar para",
            "Not deleted": "Não excluído",
            "Not found": "Não encontrado",
            "NOT_READY": "NOT_READY",
            "Now": "Agora",
            "Number": "Número",
            "Off": "Desligado",
            "On": "Ligado",
            "OR": "OU",
            "Origin": "Origem",
            "Origins": "Origens",
            "Output": "Saída",
            "Outputs": "Saídas",
            "Output {{index}}": "Saída {{index}}",
            "Output path": "Caminho de saída",
            "Output preview": "Pré-visualização de saída",
            "Output storage": "Armazenamento de saída",
            "Output storage path": "Caminho do armazenamento de saída",
            "Overview": "Visão geral",
            "Owner": "Proprietário",
            "Path": "Caminho",
            "Parent device": "Dispositivo pai",
            "Parent region": "Região pai",
            "Payload": "Carga útil",
            "Pending ingesting": "Ingestão pendente",
            "Pending transcoding": "Transcodificação pendente",
            "People": "Pessoas",
            "People description": "Descrição de pessoas",
            "Period": "Período",
            "Period setting": "Configuração de período",
            "Permissions": "Permissões",
            "Pipeline": "Pipeline",
            "Pipeline {{name}}": "Pipeline {{name}}",
            "Player": "Player",
            "Please create a schedules.": "Por favor, crie uma programação.",
            "Please create a stream.": "Por favor, crie um stream.",
            "Poster": "Poster",
            "Posters": "Posters",
            "Prefix": "Prefixo",
            "Preview": "Pré-visualização",
            "Preview button": "Botão de pré-visualização",
            "Preview in browser URL": "URL de pré-visualização no navegador",
            "Priority": "Prioridade",
            "Privacy policy": "Política de privacidade",
            "Private": "Privado",
            "Profile": "Perfil",
            "Profile {{name}}": "Perfil {{name}}",
            "Program": "Programa",
            "Program duration": "Duração do programa",
            "Programes count": "Contagem de programas",
            "Programs": "Programas",
            "PENDING": "Em andamento",
            "PROGRESSING": "EM ANDAMENTO",
            "Project": "Projeto",
            "Project description": "Descrição do projeto",
            "Project ID": "ID do projeto",
            "Project in use": "Projeto em uso",
            "Project manager": "Gerente de projeto",
            "Project name": "Nome do projeto",
            "Project Name / ID": "Nome do projeto / ID",
            "Project overview": "Visão geral do projeto",
            "Project settings": "Configurações do projeto",
            "Projects": "Projetos",
            "Projects in use": "Projetos em uso",
            "Provider": "Provedor",
            "Provider / Service": "Provedor / Serviço",
            "Public": "Público",
            "Publish": "Publicar",
            "QR": "QR",
            "Quick search": "Busca rápida",
            "Range": "Intervalo",
            "READY": "PRONTO",
            "Reanalysis": "Reanálise",
            "Retry AI search indexing": "Tentar novamente a indexação da busca por IA",
            "Retry indexing": "Tentar novamente a indexação",
            "Reason": "Motivo",
            "Reason for approval requested": "Motivo da aprovação solicitada",
            "Reason for reclaimed": "Motivo da recuperação",
            "Reason for rejected": "Motivo da rejeição",
            "Reason for request": "Motivo da solicitação",
            "Reason for response": "Motivo da resposta",
            "Reason for return requested": "Motivo da solicitação de devolução",
            "Reclaim": "Recuperar",
            "Reclaim in progress": "Recuperação em andamento",
            "Reclaimed": "Recuperado",
            "Recorded": "Gravado",
            "Redirect URL": "URL de redirecionamento",
            "Redundancy level": "Nível de redundância",
            "Reference": "Referência",
            "Refresh": "Atualizar",
            "Refresh token": "Token de atualização",
            "Reject": "Rejeitar",
            "Rejected": "Rejeitado",
            "Related {{pascalK}}": "{{pascalK}} relacionado(s)",
            "Remaining time": "Tempo restante",
            "Remote": "Remoto",
            "Remote file": "Arquivo remoto",
            "Remove": "Excluir",
            "Rendition": "Rendição",
            "Renditions": "Rendições",
            "Repeat": "Repetir",
            "Request": "Solicitação",
            "Request approval": "Solicitar aprovação",
            "Request body": "Corpo da solicitação",
            "Request cancel": "Cancelar solicitação",
            "Request return": "Solicitar devolução",
            "Reset": "Redefinir",
            "Resolution": "Resolução",
            "Resource": "Recurso",
            "Response body": "Corpo da resposta",
            "Restore to default": "Restaurar padrão",
            "Retry": "Tentar novamente",
            "Return": "Retornar",
            "Return cancel": "Cancelar devolução",
            "Return in progress": "Devolução em andamento",
            "Return request": "Solicitação de devolução",
            "Return requested": "Devolução solicitada",
            "Returned": "Devolvido",
            "Role description": "Descrição da função",
            "Role name": "Nome da função",
            "Role overview": "Visão geral da função",
            "Role": "Função",
            "Roles": "Funções",
            "rules": "regras",
            "Running": "Em execução",
            "S3://~": "S3://~",
            "Sat": "Sáb",
            "Saturday": "Sábado",
            "Save": "Salvar",
            "Save origin asset": "Salvar ativo de origem",
            "Schedule": "Agendamento",
            "Schedule {{index}}": "Agendamento {{index}}",
            "Schedule repeat": "Repetição de agendamento",
            "Scheduled lineups": "Programações agendadas",
            "Scheduled time": "Horário agendado",
            "Scope": "Escopo",
            "Search": "Buscar",
            "Search assets name": "Buscar nome de ativos",
            "Search by workflow name": "Buscar por nome de workflow",
            "Search program name": "Buscar nome do programa",
            "Search team name": "Buscar nome da equipe",
            "Search videos name": "Buscar nome de vídeos",
            "Security": "Segurança",
            "Select": "Selecionar",
            "Select {{name}}": "Selecionar {{name}}",
            "Select a file": "Selecionar um arquivo",
            "Select a one {{type}} file": "Selecionar um arquivo {{type}}",
            "Select a one caption file.": "Selecione um arquivo de legenda.",
            "Select assets": "Selecionar ativos",
            "Select categories": "Selecionar categorias",
            "Select category": "Selecionar categoria",
            "Select event type": "Selecionar tipo de evento",
            "Select files": "Selecionar arquivos",
            "Select folder": "Selecionar pasta",
            "Select kind": "Selecionar tipo",
            "Select language": "Selecionar idioma",
            "Select one MP4 file": "Selecionar um arquivo MP4",
            "Select pipeline": "Selecionar pipeline",
            "Select roles to grant": "Selecionar funções a conceder",
            "Select whitelist": "Selecionar whitelist",
            "Select...": "Selecionar...",
            "Selected {{name}}": "{{name}} selecionado",
            "Separate by newlines": "Separar por quebras de linha",
            "Service": "Serviço",
            "Set": "Definir",
            "Set as default": "Definir como padrão",
            "Set as primary": "Definir como principal",
            "Settings": "Configurações",
            "Show all": "Mostrar todos",
            "Show more": "Mostrar mais",
            "Sign in": "Entrar",
            "Sign in with Megazone Accounts": "Entrar com Megazone Accounts",
            "Single": "Único",
            "Single IP": "IP único",
            "Size": "Tamanho",
            "smiling": "sorrindo",
            "Source": "Fonte",
            "Source A": "Fonte A",
            "Source B": "Fonte B",
            "Source end behavior": "Comportamento ao fim da fonte",
            "Sources": "Fontes",
            "Specifications": "Especificações",
            "Stage": "Estágio",
            "Stage scope": "Escopo do estágio",
            "Project scope": "Escopo do projeto",
            "Start": "Iniciar",
            "Space": "Espaço",
            "Start {{name}}": "Iniciar {{name}}",
            "Start analysis": "Iniciar análise",
            "Start date": "Data de início",
            "Start indexing": "Iniciar indexação",
            "Start time": "Hora de início",
            "Start~End": "Início~Fim",
            "Started": "Iniciado",
            "Starting": "Iniciando",
            "State": "Estado",
            "Statistics": "Estatísticas",
            "Status": "Status",
            "Stop": "Parar",
            "Stopped": "Parado",
            "Stopping": "Parando",
            "Storage path": "Caminho de armazenamento",
            "Stream": "Stream",
            "STREAM": "STREAM",
            "Stream ID": "ID do Stream",
            "Streams": "Streams",
            "Submit": "Enviar",
            "SUBMITTED": "SUBMETIDO",
            "Submitted": "Submetido",
            "Subtitle": "Legenda",
            "Sun": "Dom",
            "Sunday": "Domingo",
            "Supported file formats": "Formatos de arquivo suportados",
            "Supported inputs": "Entradas suportadas",
            "Supported URL patterns": "Padrões de URL suportados",
            "Supported URLs": "URLs suportadas",
            "Synchronization": "Sincronização",
            "table": "tabela",
            "Tag": "Tag",
            "Tags": "Tags",
            "Target ID": "ID de destino",
            "Target resource": "Recurso de destino",
            "Team": "Equipe",
            "Team ID": "ID da equipe",
            "Team overview": "Visão geral da equipe",
            "Teams": "Equipes",
            "Terms & Conditions": "Termos e Condições",
            "Text": "Texto",
            "Text area": "Área de texto",
            "Text field": "Campo de texto",
            "There is no Stream to select.": "Não há Stream para selecionar.",
            "This {{name}}": "Este {{name}}",
            "Thumbnails": "Miniaturas",
            "THUMBNAILS": "MINIATURAS",
            "Thur": "Qui",
            "Thursday": "Quinta-feira",
            "Time": "Hora",
            "Timestamp": "Timestamp",
            "Timezone": "Fuso horário",
            "Title": "Título",
            "Today": "Hoje",
            "Total": "Total",
            "Total {{name}}": "Total {{name}}",
            "Total <strong className=\\\"emphasis\\\">{{elementsLength}}</strong>": "Total <0>{{elementsLength}}</0>",
            "Total <0>{{elementsLength}}</0>": "Total <0>{{elementsLength}}</0>",
            "Total time": "Tempo total",
            "Transcode": "Transcodificar",
            "Transcode profile": "Perfil de transcodificação",
            "Transcoded": "Transcodificado",
            "Transcoder Job ID": "ID da tarefa de transcodificação",
            "Transcoding": "Transcodificando",
            "Transcoding canceled": "Transcodificação cancelada",
            "Transcoding complete": "Transcodificação concluída",
            "Transcoding error": "Erro de transcodificação",
            "Transcoding failed": "Transcodificação falhou",
            "Transcoding time": "Tempo de transcodificação",
            "Tree": "Árvore",
            "Tue": "Ter",
            "Tuesday": "Terça-feira",
            "Twitch": "Twitch",
            "Twitter": "Twitter",
            "Type": "Tipo",
            "Undefined": "Indefinido",
            "Unique": "Único",
            "Unknown": "Desconhecido",
            "(Unknown)": "(Desconhecido)",
            "Unscheduled time": "Horário não agendado",
            "Unset default": "Remover padrão",
            "Up": "Acima",
            "Update file": "Atualizar arquivo",
            "Updated": "Atualizado",
            "Updated at": "Atualizado em",
            "Updated by": "Atualizado por",
            "Updating...": "Atualizando...",
            "Upload": "Upload",
            "Upload {{status}}.": "Upload {{status}}.",
            "Upload rules": "Regras de Upload",
            "Uploading": "Enviando",
            "UPLOADING": "ENVIANDO",
            "URL": "URL",
            "User ID": "ID do usuário",
            "User information": "Informações do usuário",
            "User name": "Nome do usuário",
            "User overview": "Visão geral do usuário",
            "User username": "Nome de usuário do usuário",
            "Username": "Nome de usuário",
            "Users": "Usuários",
            "Value": "Valor",
            "Video": "Vídeo",
            "Video ID": "ID do vídeo",
            "Video AI": "Video AI",
            "Video setting": "Configuração de vídeo",
            "Videos": "Vídeos",
            "View analytics data": "Ver dados analíticos",
            "View more": "Ver mais",
            "VOD player URL": "URL do player VOD",
            "Warning": "Aviso",
            "Wearing glasses": "Usando óculos",
            "Wed": "Qua",
            "Wednesday": "Quarta-feira",
            "Week": "Semana",
            "Weekly": "Semanalmente",
            "Weeks": "Semanas",
            "Welcome": "Bem-vindo",
            "Whitelist": "Whitelist",
            "Whitelist rules": "Regras de whitelist",
            "Whitelist to request": "Whitelist para solicitação",
            "Workflow": "Workflow",
            "Workflow Name": "Nome do Workflow",
            "workflow": "workflow",
            "Years old": "Anos de idade",
            "Yes": "Sim",
            "Youtube": "Youtube",
            "Youtube syndication": "Sindicalização do Youtube",
            "Every months on": "Todo mês no",
            "PREPARING": "PREPARANDO",
            "Restrict bucket access": "Restringir acesso ao bucket",
            "Active on creation": "Ativo na criação",
            "ACTIVATING": "ATIVANDO",
            "INACTIVATING": "INATIVANDO",
            "Archive": "Arquivar",
            "Archving...": "Arquivando...",
            "Folder path": "Caminho da pasta",
            "No assets folder": "Nenhuma pasta de ativos",
            "Restoring...": "Restaurando...",
            "Search in folder": "Buscar na pasta",
            "Root": "Raiz",
            "Search results": "Resultados da busca",
            "Restoring": "Restaurando",
            "Archiving": "Arquivando",
            "days": "dias",
            "Achived Assets": "Ativos arquivados",
            "Archived": "Arquivado",
            "Empty Archived": "Não há itens arquivados",
            "Archived by": "Arquivado por",
            "Archived Period": "Período arquivado",
            "Archived Assets": "Ativos arquivados",
            "Restored": "Restaurado",
            "Archive ID": "ID de arquivo",
            "Auto Categorization": "Categorização automática",
            "Site access": "Acesso ao site",
            "Console": "Console",
            "File meta": "Metadados do arquivo",
            "Operator": "Operador",
            "Contains": "Contém",
            "Duration range": "Intervalo de duração",
            "Date range": "Intervalo de datas",
            "Greater than": "Maior que",
            "Less than": "Menor que",
            "OverWrite": "Sobrescrever",
            "Overwrite": "Sobrescrever",
            "Skip": "Ignorar",
            "OK": "OK",
            "Source name": "Nome da fonte",
            "Partial {{type}} to completed.": "{{type}} parcial concluído.",
            "Folder Upload": "Upload de pasta",
            "Files Upload": "Upload de arquivos",
            "New Folder": "Nova Pasta",
            "Upload Files": "Upload de Arquivos",
            "References": "Referências",
            "사용자 설정 위젯": "Widget de Preferência do Usuário",
            "팀 설정 위젯": "Widget de Preferência do Grupo de Usuários",
            "프로젝트 설정 위젯": "Widget de Preferência do Projeto",
            "전체 기간": "Período Inteiro",
            "빠른 지정": "Seleção rápida",
            "사용자 지정": "Personalizado pelo Usuário",
            "이번주": "Esta semana",
            "이번달": "Este mês",
            "올해": "Este ano",
            "지난 15분": "Últimos 15 min.",
            "지난 30분": "Últimos 30 min.",
            "지난 1시간": "Última 1 hora",
            "지난 4시간": "Últimas 4 horas",
            "선택됨": "Selecionado",
            "에 업데이트됨": "Atualizado em",
            "위젯 설정": "Preferência de Widget",
            "선택된 위젯": "Widget Selecionado",
            "프로젝트 설정으로 적용": "Salvar como preferência do projeto",
            "선 그래프": "Gráfico de Linhas",
            "바 그래프": "Gráfico de Barras",
            "동영상": "Vídeo",
            "시청자 수": "Visualizador único",
            "시청 횟수": "Visualização",
            "디바이스별 시청자 수 (기간)": "Visualizador por dispositivo (Período)",
            "디바이스별 시청자 수 (백분율)": "Visualizador por dispositivo (%)",
            "현재 시청자 수": "Visualizador Simultâneo",
            "누적 시청자 수": "Total de Visualizadores",
            "누적 시청 횟수": "Total de Visualizações",
            "누적 시청 시간": "Tempo total de reprodução",
            "상위 지역": "Mais assistido em (Região)",
            "상위 디바이스": "Mais assistido em (Dispositivo)",
            "VIDEOS": "VÍDEOS",
            "VIEWERS": "Visualizador único",
            "WATCH_COUNT": "Visualização",
            "DEVICE_VIEWERS_ON_TERM": "Visualizador por dispositivo (Período)",
            "DEVICE_VIEWERS_ON_PERCENTAGE": "Visualizador por dispositivo (%)",
            "COUNTRY_VIEWERS_ON_TERM": "Visualizador por País (Período)",
            "COUNTRY_VIEWERS_ON_PERCENTAGE": "Visualizador por País (%)",
            "REGION_VIEWERS_ON_TERM": "Visualizador por Região (Período)",
            "REGION_VIEWERS_ON_PERCENTAGE": "Visualizador por Região (%)",
            "CITY_VIEWERS_ON_TERM": "Visualizador por cidade (Período)",
            "CITY_VIEWERS_ON_PERCENTAGE": "Visualizador por cidade (%)",
            "VIEWERS_PROGRESS": "Visualizador por linha do tempo",
            "Restore": "Restaurar",
            "New folder": "Nova pasta",
            "Folder": "Pasta",
            "Search in {{name}}": "Buscar em {{name}}",
            "{{name}} View": "Visualização de {{name}}",
            "Hierarchy": "Hierarquia",
            "{{name}} Search": "Busca de {{name}}",
            "Confirm": "Confirmar",
            "All lineups": "Todas as programações",
            "Repeat lineups": "Programações repetidas",
            "All Copy to": "Copiar tudo para",
            "Date to All copy to": "Data para copiar tudo para",
            "Daily Copy": "Cópia diária",
            "Check date to all copy to": "Verificar data para copiar tudo para",
            "Available": "Disponível",
            "No assets category": "Sem categoria de ativos",
            "No videos folder": "Sem pasta de vídeos",
            "No videos category": "Sem categoria de vídeos",
            "No channels category": "Sem categoria de canais",
            "Create Auto Captions": "Criar Legendas Automáticas",
            "Creating Auto Caption": "Criando Legenda Automática",
            "Create Auto Caption": "Criar Legenda Automática",
            "Default Language": "Idioma Padrão",
            "Last login": "Último Login",
            "Change view": "Alterar visualização",
            "Of": "De",
            "All approval status": "Todos os status de aprovação",
            "Action rules": "Regras de ação",
            "Delete Constraints": "Restrições de exclusão",
            "Copy to Constraints": "Restrições de cópia para",
            "Published History": "Histórico de publicação",
            "Channel Name": "Nome do Canal",
            "Accounts": "Contas",
            "Account settings": "Configurações da conta",
            "Add Accounts": "Adicionar Contas",
            "URL for Posting": "URL para publicação",
            "Kakaotalk": "Kakaotalk",
            "Select Accounts": "Selecionar Contas",
            "Go to": "Ir para",
            "Expired date :": "Data de expiração :",
            "Timeshift": "Timeshift",
            "Sec": "seg",
            "DeleteFaceIndex": "Desindexar Rosto",
            "ModifyFaceIndex": "Modificar Índice de Rostos",
            "EditFaces": "Editar Rostos",
            "FaceToIndex": "Rosto para Indexar",
            "FaceToUnindex": "Rosto para Desindexar",
            "FacesIndexed": "Rostos Indexados",
            "StorageClass": "Classe de Armazenamento",
            "Last Modified": "Última Modificação",
            "Objects": "Objetos",
            "View More": "Ver Mais",
            "No buckets folder": "Sem pasta de buckets",
            "Access": "Acesso",
            "Manage": "Gerenciar",
            "Source Buckets": "Buckets de Origem",
            "Bucket": "Bucket",
            "Custom": "Personalizado",
            "Header": "Cabeçalho",
            "Setting": "Configuração",
            "Theme": "Tema",
            "White": "Branco",
            "Black": "Preto",
            "CI": "Logotipo",
            "BG": "Plano de fundo",
            "Color": "Cor",
            "Text button": "Botão de Texto",
            "Quick Select": "Seleção Rápida",
            "User": "Usuário",
            "Language Settings": "Configurações de Idioma",
            "Specific Language": "Idioma Específico",
            "Auto Language": "Idioma Automático",
            "Extension": "Extensão",
            "All extensions": "Todas as extensões",
            "Create FILE asset": "Criar ativo de ARQUIVO",
            "Go analysis": "Ir para análise",
            "Copy to": "Copiar para",
            "Move": "Mover",
            "All Storage Class": "Todas as classes de armazenamento",
            "Standard": "Standard",
            "Reduced Redundancy": "Reduced Redundancy",
            "Stanard-IA": "Standard-IA",
            "One Zone-IA": "One Zone-IA",
            "Intelligent Tiering": "Intelligent Tiering",
            "Glacier": "Glacier",
            "Deep Archive": "Deep Archive",
            "Outposts": "Outposts",
            "Meeting": "Reunião",
            "Rooms": "Salas",
            "Recent Schedule": "Agendamentos Recentes",
            "out of {{total}}": "de {{total}}",
            "Channel Overview": "Visão Geral do Canal",
            "Basic": "Básico",
            "Lock": "Bloquear",
            "people": "pessoas",
            "Disabled": "Desativado",
            "Create Channel": "Criar Canal",
            "Meetings": "Reuniões",
            "Unlock": "Desbloquear",
            "Locked": "Bloqueado",
            "All": "Todos",
            "Megazone Accounts": "Contas Megazone",
            "Megazone Login": "Login Megazone",
            "Sign in with Megazone Login": "Entrar com Login Megazone",
            "or": "ou",
            "Analyze by timestamp": "Analisar por Timestamp",
            "Usage Time": "Tempo de Uso",
            "Music": "Música",
            "Photo": "Foto",
            "Audio Sources": "Fontes de Áudio",
            "Album Images": "Imagens do Álbum",
            "Teaser Images": "Imagens de Teaser",
            "Music Videos": "Videoclipes",
            "Teaser Videos": "Vídeos de Teaser",
            "Live Videos": "Vídeos ao Vivo",
            "Music Description": "Descrição da Música",
            "No musics category": "Sem categoria de músicas",
            "INACTIVE": "INATIVO",
            "Update {{name}}": "Atualizar {{name}}",
            "{{name}} Description": "Descrição de {{name}}",
            "Share": "Compartilhar",
            "Shared Box": "Caixa Compartilhada",
            "Share Box": "Caixa Compartilhada",
            "Shared Date": "Data de Compartilhamento",
            "Share to me": "Compartilhado comigo",
            "Share by me": "Compartilhado por mim",
            "Add to Shared Box": "Adicionar à Caixa Compartilhada",
            "Remove from Share Box": "Remover da Caixa Compartilhada",
            "Shared {{name}}": "{{name}} Compartilhado",
            "Share Management": "Gerenciamento de Compartilhamento",
            "Shared with Me": "Compartilhado Comigo",
            "Requested to Share": "Solicitado para Compartilhar",
            "Requester": "Solicitante",
            "Requested": "Solicitado",
            "Review Request": "Revisar Solicitação",
            "Review Access Request": "Revisar Solicitação de Acesso",
            "Please add {{name1}} and {{name2}}.": "Por favor, adicione {{name1}} e {{name2}}.",
            "Phone Number": "Número de Telefone",
            "Asset Sharer": "Compartilhador de Ativos",
            "Quick": "Rápido",
            "Advanced": "Avançado",
            "Show": "Mostrar",
            "{{view}} Search fields": "Campos de busca {{view}}",
            "Search for assets by all projects.": "Buscar ativos em todos os projetos.",
            "<0>{{count}}</0> Results for your Search": "<0>{{count}}</0> Resultados para sua Busca",
            "Management": "Gerenciamento",
            "Assets to be shared": "Ativos a serem compartilhados",
            "Please add {{name}}.": "Por favor, adicione {{name}}.",
            "Image Viewer": "Visualizador de Imagens",
            "Images Viewer": "Visualizador de Imagens",
            "Result of <0>{{name}}</0>": "Resultado de <0>{{name}}</0>",
            "Download Link": "Link de Download",
            "Elements": "Elementos",
            "This download link URL is only available for one week from now.": "Este URL de link de Download está disponível apenas por uma semana a partir de agora.",
            "Preparing download link URL": "Preparando URL de link de Download",
            "No Images List": "Sem lista de imagens",
            "File Meta": "Metadados do Arquivo",
            "Operation": "Operação",
            "Versions": "Versões",
            "Version": "Versão",
            "My Activity": "Minha Atividade",
            "Current Version": "Versão Atual",
            "Share Management Rules": "Regras de Gerenciamento de Compartilhamento",
            "Users and groups belonging to the project for the selected asset are excluded from sharing.": "Usuários e grupos pertencentes ao projeto do ativo selecionado estão excluídos do compartilhamento.",
            "Search for assets in this project.": "Buscar ativos neste projeto.",
            "Recent People": "Pessoas Recentes",
            "Recent Music": "Músicas Recentes",
            "Recent Photos": "Fotos Recentes",
            "Recent Photo": "Foto Recente",
            "Reason for sharing request (Optional)": "Motivo da solicitação de compartilhamento (Opcional)",
            "Request Access": "Solicitar Acesso",
            "Display Name": "Nome de Exibição",
            "Department": "Departamento",
            "results": "resultados",
            "Sharer": "Compartilhador",
            "Shared": "Compartilhado",
            "Last Login": "Último Login",
            "Spec": "Especificação",
            "Asset’s Project": "Projeto do Ativo",
            "All Projects": "Todos os Projetos",
            "All Users": "Todos os usuários",
            "Only mine": "Somente meus",
            "Rename": "Renomear",
            "Moving": "Movendo",
            "Copying to": "Copiando para",
            "Deleting": "Excluindo",
            "Renaming": "Renomeando",
            "{{type}} completed.": "{{type}} concluído.",
            "Partial {{type}} completed.": "{{type}} parcialmente concluído.",
            "{{type}} canceled.": "{{type}} cancelado.",
            "{{type}} error.": "Erro em {{type}}.",
            "Overwrite or skip file": "Substituir ou ignorar arquivo",
            "Pending {{type}}...": "{{type}} pendente...",
            "Ask": "Perguntar",
            "Always Overwrite": "Sempre Substituir",
            "Always Skips": "Sempre Ignorar",
            "Handling in case of duplicate files": "Como lidar com arquivos duplicados",
            "Apply to all": "Aplicar a todos",
            "Shares": "Compartilhamentos",
            "Accessible Projects": "Projetos Acessíveis",
            "Recent Videos": "Vídeos Recentes",
            "Recent Assets Shared with Me": "Ativos Recentes Compartilhados Comigo",
            "Search all assets": "Buscar todos os Ativos",
            "Search assets": "Buscar ativos",
            "Add Users and Teams": "Adicionar Usuários e Equipes",
            "Project Settings": "Configurações do Projeto",
            "Back to Console": "Voltar ao Console",
            "No related assets": "Nenhum ativo relacionado",
            "No reference": "Nenhuma referência",
            "My Assets": "Meus Ativos",
            "Group": "Grupo",
            "Group ID": "ID do Grupo",
            "Groups": "Grupos",
            "No Groups": "Nenhum Grupo",
            "Add groups": "Adicionar grupos",
            "Add Users and Groups": "Adicionar Usuários e Grupos",
            "Enter Users and Groups": "Inserir Usuários e Grupos",
            "Assets shared with the group are not deleted": "Ativos compartilhados com o grupo não são excluídos",
            "Group overview": "Visão geral do Grupo",
            "Selected files": "Arquivos selecionados",
            "Create by Transcoding": "Criar por Transcodificação",
            "Create as Assets": "Criar como Ativos",
            "ItemSet for Metadata": "Conjunto de itens para metadados",
            "ItemSet": "Conjunto de itens",
            "Items": "Itens",
            "Multiple": "Múltiplo",
            "Storage": "Armazenamento",
            "CaptionSync": "Sincronização de legendas",
            "Fast": "Rápido",
            "Slow": "Lento",
            "No Time Change": "Sem Alteração de Hora",
            "Time Control": "Controle de Hora",
            "No captions": "Sem legendas",
            "Edit Captions": "Editar Legendas",
            "sec": "seg",
            "Interactive Video": "Vídeo Interativo",
            "Interactive Videos": "Vídeos Interativos",
            "Open Chatting": "Chat Aberto",
            "Group Chatting": "Chat em Grupo",
            "Add Attendees": "Adicionar Participantes",
            "Recording": "Gravando",
            "Ending Video": "Vídeo de Encerramento",
            "msec": "mseg",
            "Enter Email Address": "Inserir Endereço de e-mail",
            "Intro Video URL": "URL do Vídeo de Introdução",
            "Ending Video URL": "URL do Vídeo de Encerramento",
            "Empty Recording History": "Nenhum histórico de gravação",
            "Recording History": "Histórico de Gravações",
            "Recording Time": "Hora de Gravação",
            "Intro Videos": "Vídeos de Introdução",
            "Ending Videos": "Vídeos de Encerramento",
            "No Schedule": "Sem Agenda",
            "Input file upload error": "Erro no Upload do arquivo de entrada",
            "Input file preprocessing error": "Erro no pré-processamento do arquivo de entrada",
            "MediaConvert transcoding error": "Erro de transcodificação no MediaConvert",
            "Input file post processing error": "Erro no pós-processamento do arquivo de entrada",
            "Console first entry screen": "Tela inicial do Console",
            "Add attendees to join the Group Chatting": "Adicionar participantes para entrar no Chat em Grupo",
            "Add attendees": "Adicionar participantes",
            "Schedule Name": "Nome da Agenda",
            "Schedule Time": "Hora da Agenda",
            "Channel type": "Tipo de canal",
            "Video latency": "Latência de vídeo",
            "Playback authorization": "Autorização de reprodução",
            "Standard latency": "Latência padrão",
            "Ultra-low latency": "Latência ultrabaixa",
            "Amazon IVS": "Amazon IVS",
            "Amazon Chime": "Amazon Chime",
            "Playback": "Reprodução",
            "Recordings": "Gravações",
            "Recorded Videos": "Vídeos Gravados",
            "Event Time": "Hora do Evento",
            "Storage Path": "Caminho de Armazenamento",
            "Change after channel creation": "Alterar após a criação do canal",
            "Create Assets on creation": "Criar Ativos na criação",
            "Manage Access": "Gerenciar Acesso",
            "Search with subcategories": "Buscar com subcategorias",
            "Service Provider": "Provedor de Serviços",
            "Sync complete": "Sincronização concluída",
            "Sync failed": "Falha na sincronização",
            "Synchronizing": "Sincronizando",
            "Sync refresh": "Atualizar sincronização",
            "Projects Allowed To Use": "Projetos com Permissão de Uso",
            "SPACE ADMINISTRATION": "ADMINISTRAÇÃO DO ESPAÇO",
            "CloudPlex Delivery": "CloudPlex Delivery",
            "CloudPlex Start": "CloudPlex Start",
            "Switch to Admin": "Mudar para Admin",
            "Add User": "Adicionar Usuário",
            "UserName": "Nome de Usuário",
            "Last Access": "Último Acesso",
            "Add teaser images": "Adicionar Imagens Teaser",
            "out of": "de ",
            "Indexed Faces": " Rostos Indexados",
            "Products": "Produtos",
            "Customer Service": "Atendimento ao Cliente",
            "Invitation Pending": "Convite Pendente",
            "Has Space Access": "Tem Acesso ao Espaço",
            "No Space Access": "Sem Acesso ao Espaço",
            "Member": "Membro",
            "Trusted": "Confiável",
            "No role": "Sem função",
            "Revoke space access": "Revogar acesso ao espaço",
            "Last Name": "Sobrenome",
            "First Name": "Nome",
            "Phone number": "Número de telefone",
            "Company": "Empresa",
            "Position": "Cargo",
            "’s Detail": "Detalhes de",
            "Has access on Space": "Tem acesso ao Espaço",
            "Administrator": "Administrador",
            "Any role": "Qualquer função",
            "Last Activity": "Última Atividade",
            "Grant space access": "Conceder acesso ao espaço",
            "Remove user": "Excluir usuário",
            "Add {{number}} users": "Adicionar {{number}} usuários",
            "Add user": "Adicionar usuário",
            "Add attribute": "Adicionar atributo",
            "Next": "Próximo",
            "Photos": "Fotos",
            "Zoom in": "Ampliar",
            "Zoom out": "Reduzir",
            "Previous": "Anterior",
            "Compressing": "Comprimindo",
            "Ready to {{type}}": "Pronto para {{type}}",
            "Select Files": "Selecionar Arquivos",
            "Edit Default Metadata": "Editar Metadados Padrão",
            "Edit and Create Assets": "Editar e Criar Ativos",
            "Create assets": "Criar ativos",
            "create assets": "criar ativos",
            "Create Assets": "Criar Ativos",
            "assets": "ativos",
            "Asset creation": "Criação de Ativo",
            "Create Assets Bulk": "Criar Ativos em Lote",
            "Selected Files": "Arquivos Selecionados",
            "Edit Metadata": "Editar Metadados",
            "APPLY ALL OVER Options": "APLICAR TODAS AS OPÇÕES",
            "Apply All Over": "Aplicar a Todos",
            "Set as Options": "Definir como Opções",
            "Asset Name Alias": "Alias do Nome do Ativo",
            "Choose Bulk Operation": "Escolher Operação em Lote",
            "Asset Type": "Tipo de Ativo",
            "Asset Composition Type": "Tipo de Composição do Ativo",
            "Set to Default": "Definir como Padrão",
            "Preparing {{type}}...": "Preparando {{type}}...",
            "Add Files to Bulk": "Adicionar Arquivos ao Lote",
            "Choose Files": "Escolher Arquivos",
            "A total of <0> {{number}} </0> files can be added.": "Um total de <0> {{number}} </0> arquivos pode ser adicionado.",
            "Add All": "Adicionar Todos",
            "If a file is changed or deleted from the storage list": "Se um arquivo for alterado ou excluído da lista de armazenamento",
            "Asset Composition Types": "Tipos de Composição do Ativo",
            "Auto-apply language & labels": "Aplicar idioma e rótulos automaticamente",
            "Ex": "Ex.",
            "Single Asset": "Ativo Único",
            "Multiple Asset": "Múltiplos Ativos",
            "Filters": "Filtros",
            "Add Assets": "Adicionar Ativos",
            "No Files": "Nenhum Arquivo",
            "Caption Type Asset Creation Rules": "Regras de Criação de Ativo do Tipo Legenda",
            "Language & Label": "Idioma e Rótulo",
            "If there is a language code after the file name (_)": "Se houver um código de idioma após o nome do arquivo (_)",
            "If there is no language code after the file name (_)": "Se não houver código de idioma após o nome do arquivo (_)",
            "Add <0> {{number}} </0> file(s)": "Adicionar <0> {{number}} </0> arquivo(s)",
            "Ready": "Pronto",
            "In Progress": "Em Andamento",
            "FAILED": "Falhou",
            "NOT_SUPPORTED": "Não suportado",
            "PARTIAL_COMPLETED": "Parcialmente concluído",
            "Video and image content analysis": "Análise de conteúdo de vídeo e imagem",
            "Metadata analysis": "Análise de metadados",
            "AI search mode indexing": "Indexação do modo de busca por IA",
            "AI search indexing status": "Status da indexação da busca por IA",
            "AI search mode": "Modo de busca por IA",
            "Indexing status": "Status de indexação",
            "Request to Create Assets": "Solicitar Criação de Ativos",
            "In Order of Accuracy": "Em Ordem de Precisão",
            "Latest Order": "Ordem mais Recente",
            "Only Mine": "Somente Meus",
            "Other then Mine": "Exceto os Meus",
            "Detailed Filter": "Filtro Detalhado",
            "Storage Class": "Classe de Armazenamento",
            "Search for storage and assets by all projects.": "Buscar armazenamento e ativos em todos os projetos.",
            "Please enter your search term": "Insira seu termo de busca",
            "Please check the search term you entered again.": "Verifique novamente o termo de busca inserido.",
            "All Buckets": "Todos os Buckets",
            "Only My Buckets": "Somente Meus Buckets",
            "Other Buckets": "Outros Buckets",
            "Only My Projects": "Somente Meus Projetos",
            "Other Projects": "Outros Projetos",
            "No results were found for your search.": "Nenhum resultado encontrado para sua busca.",
            "Please re-enter your search term.": "Por favor, insira novamente seu termo de busca.",
            "Please enter your search term.": "Por favor, insira seu termo de busca.",
            "Select Bucket": "Selecionar Bucket",
            "Choose the bucket you want to use.": "Escolha o bucket que deseja usar.",
            "Current Project": "Projeto Atual",
            "Accessible": "Acessível",
            "Not Accessible": "Não Acessível",
            "Current": "Atual",
            "Project other than this one": "Outro projeto além deste",
            "Use of features based on access": "Uso de recursos com base no acesso",
            "All functions available": "Todas as funções disponíveis",
            "All functions unavailable": "Todas as funções indisponíveis",
            "Partial functions unavailable": "Algumas funções indisponíveis",
            "Folder path to check": "Caminho da pasta a verificar",
            "Current project": "Projeto atual",
            "Switch Project": "Mudar Projeto",
            "Project to switch to": "Projeto para o qual mudar",
            "Add users and teams to share": "Adicionar usuários e equipes para compartilhar",
            "Link Setting": "Configuração de Link",
            "Password": "Senha",
            "Link": "Link",
            "download link URL": "URL do link de Download",
            "Download Period": "Período de Download",
            "Number of Downloads": "Número de Downloads",
            "Files to share": "Arquivos para compartilhar",
            "The files to download are ready.": "Os arquivos para Download estão prontos.",
            "The number of password errors has been exceeded.": "O número de erros de senha foi excedido.",
            "The download period of times has expired.": "O período de Download expirou.",
            "The download number of times has expired.": "O número de Downloads expirou.",
            "The page not found.": "Página não encontrada.",
            "Enter your Password": "Insira sua Senha",
            "Show Password": "Mostrar Senha",
            "Enter {{name}}": "Inserir {{name}}",
            "Done": "Concluído",
            "Enter Name": "Inserir Nome",
            "Share Link": "Link de Compartilhamento",
            "Share Request": "Solicitação de Compartilhamento",
            "Choose One Approver": "Escolher Um Aprovador",
            "File to request": "Arquivo para solicitar",
            "Send request": "Enviar solicitação",
            "Expires At": "Expira em",
            "History of my request to share": "Histórico das minhas solicitações de compartilhamento",
            "History of requests to share": "Histórico de solicitações de compartilhamento",
            "Previous Request": "Solicitação Anterior",
            "Linked Requests": "Solicitações Vinculadas",
            "Shared History": "Histórico de Compartilhamento",
            "Permission": "Permissão",
            "Reason for Approval (Optional)": "Motivo da Aprovação (Opcional)",
            "Reason for Reject (Optional)": "Motivo da Rejeição (Opcional)",
            "Select User": "Selecionar Usuário",
            "Canceled": "Cancelado",
            "Shared by me": "Compartilhado por mim",
            "Shared with me": "Compartilhado comigo",
            "Shared with": "Compartilhado com",
            "Revoke": "Revogar",
            "Revoked": "Revogado",
            "Revoke access": "Revogar acesso",
            "Revoke link": "Revogar",
            "File to be shared": "Arquivo a ser compartilhado",
            "By last shared": "Por último compartilhado",
            "By last modified": "Por última modificação",
            "By name": "Por nome",
            "By type": "Por tipo",
            "Removed": "Excluído",
            "Manage shared with": "Gerenciar compartilhado com",
            "Send email with password": "Enviar e-mail com senha",
            "Include": "Incluir",
            "Not Include": "Não incluir",
            "Request expired": "Solicitação expirada",
            "Shared by": "Compartilhado por",
            "Share Expires Date": "Data de Expiração do Compartilhamento",
            "Create Videos": "Criar Vídeos",
            "Create People": "Criar Pessoas",
            "Create Music": "Criar Música",
            "Create Photo": "Criar Foto",
            "Folder Path": "Caminho da Pasta",
            "Select Folder Path": "Selecionar Caminho da Pasta",
            "Folder View": "Visualização de Pasta",
            "Category View": "Visualização por Categoria",
            "View All": "Ver Tudo",
            "Zendesk Widget": "Widget Zendesk",
            "Widget": "Widget",
            "Widget Settings": "Configurações do Widget",
            "Zendesk Settings": "Configurações do Zendesk",
            "Zendesk Domain": "Domínio Zendesk",
            "API Token": "Token de API",
            "Locale": "Localidade",
            "Page URL": "URL da Página",
            "Show API Token": "Mostrar Token de API",
            "Section ID": "ID da Seção",
            "Topic ID": "ID do Tópico",
            "Minimum Image Size": "Tamanho Mínimo da Imagem",
            "Metadata Template": "Modelo de Metadados",
            "Name Prefix": "Prefixo de Nome",
            "Metadata Preset": "Predefinição de Metadados",
            "Metadata Name Prefix": "Prefixo de Nome dos Metadados",
            "Metadata Template Name": "Nome do Modelo de Metadados",
            "Metadata Template Description": "Descrição do Modelo de Metadados",
            "Select Metadata Template": "Selecionar Modelo de Metadados",
            "Asset Name Prefix": "Prefixo de Nome do Ativo",
            "Folder Path Option": "Opção de Caminho da Pasta",
            "Save assets to the top-level path on the drive": "Salvar ativos no caminho raiz do drive",
            "Save assets according to the storage folder path": "Salvar ativos conforme o caminho da pasta de armazenamento",
            "Save assets to the selected folder": "Salvar ativos na pasta selecionada",
            "Asset to share": "Ativo a ser compartilhado",
            "Message": "Mensagem",
            "Message (Optional)": "Mensagem (Opcional)",
            "Send": "Enviar",
            "Add Users": "Adicionar Usuários",
            "Pending changes": "Alterações pendentes",
            "Access Updated": "Acesso Atualizado",
            "<0> {{number}} </0> days": "<0> {{number}} </0> dias",
            "<0/> times": "<0/> vezes",
            "Search Category Group": "Buscar Grupo de Categoria",
            "Discard": "Descartar",
            "In Use": "Em Uso",
            "Not Used": "Não Utilizado",
            "No Assets Folders": "Nenhuma Pasta de Ativos",
            "Select Category Group": "Selecionar Grupo de Categoria",
            "File to share": "Arquivo para compartilhar",
            "Clear All": "Limpar Tudo",
            "Grouping View mode": "Modo de visualização por agrupamento",
            "View All mode": "Modo Ver Tudo",
            "Archived ID": "ID Arquivado",
            "Requested At": "Solicitado",
            "Subject": "Assunto",
            "Approval Status": "Status de Aprovação",
            "Status Updated": "Status Atualizado",
            "Shared History Action": "Ação",
            "Approver": "Aprovador",
            "Sharehistory": "Histórico de Compartilhamento",
            "Sharebox": "Caixa Compartilhada",
            "Internal Share": "Compartilhamento Interno",
            "External Share": "Compartilhamento Externo",
            "asset creation": "criação de ativo",
            "Creating asset...": "criando ativo...",
            "No {{type}} Categories": "Nenhuma Categoria de {{type}}",
            "Delete the asset?": "Excluir o ativo?",
            "Apply All": "Aplicar Tudo",
            "Delete the item?": "Excluir o item?",
            "Move the item?": "Mover o item?",
            "Move these items?": "Mover estes itens?",
            "Location": "Localização",
            "Specify Here": "Especificar Aqui",
            "Dimensions": "Dimensões",
            "Asset Created": "Ativo Criado",
            "History of my internal share requests": "Histórico das minhas solicitações de compartilhamento interno",
            "History of internal sharing requests to me": "Histórico de solicitações de compartilhamento interno para mim",
            "History of my external sharing": "Histórico dos meus compartilhamentos externos",
            "No list": "Nenhuma lista",
            "Restore the item?": "Restaurar o item?",
            "Change Restore Option": "Alterar Opção de Restauração",
            "Users shared with": "Usuários com quem foi compartilhado",
            "Status of ready": "Status de pronto",
            "Expiration Date": "Data de Expiração",
            "Mail Language Settings": "Configurações de Idioma do E-mail",
            "Items Shared": "Itens Compartilhados",
            "Histories": "Históricos",
            "Shared Histories": "Históricos de Compartilhamento",
            "Search owner": "Buscar proprietário",
            "Search extension": "Buscar extensão",
            "Search type": "Buscar tipo",
            "Search filter": "Buscar filtro",
            "Search status": "Buscar status",
            "History of external share": "Histórico de compartilhamento externo",
            "Calulating...": "Calculando...",
            "Asset Details": "Detalhes_do_Ativo",
            "Asset Search Results": "Resultados da Busca de Ativos",
            "API Endpoint": "Endpoint de API",
            "USED": "EM USO",
            "UNUSED": "NÃO UTILIZADO",
            "Archive after adding assets": "Arquivar após adicionar ativos",
            "Moving to CloudPlex Assets": "Movendo para CloudPlex Assets",
            "Download All": "Baixar tudo",
            "Starred": "Favoritos",
            "Hi, {{name}}": "Olá, {{name}}",
            "Switch to": "Alternar para",
            "Add to Starred": "Adicionar aos Favoritos",
            "Remove from Starred": "Remover dos Favoritos",
            "Column Settings": "Configurações de Colunas",
            "Sort in descending order": "Ordenar em ordem decrescente",
            "Sort in ascending order": "Ordenar em ordem crescente",
            "Project Name": "Nome do Projeto",
            "Project Lead": "Responsável pelo Projeto",
            "Sort by": "Ordenar por",
            "by name": "por nome",
            "by most recent": "por mais recente",
            "by update": "por atualização",
            "Last Updated": "Última Atualização",
            "Hide all": "Ocultar tudo",
            "CPA_ARCHIVED": "ARQUIVADO",
            "CPA_ARCHIVING": "ARQUIVANDO",
            "CPA_RESTORING": "RESTAURANDO",
            "CPA_ERROR": "ERRO",
            "PUBLIC": "PÚBLICO",
            "PRIVATE": "PRIVADO",
            "Add Project": "Adicionar Projeto",
            "Grid Layout": "Layout em Grade",
            "List Layout": "Layout em Lista",
            "Lead": "Responsável",
            "View all Projects": "Ver todos os Projetos",
            "Project unassigned": "Projeto não atribuído",
            "Replace Asset": "Substituir Ativo",
            "Set lockout for other users": "Definir bloqueio para outros usuários",
            "locked by": "bloqueado por",
            "Me": "Eu",
            "Locked by": "Bloqueado por",
            "locked by '{{name}}({{username}})'": "bloqueado por '{{name}}({{username}})'",
            "locked by 'Me'": "bloqueado por 'Mim'",
            "Automatic Bucket Lock Options": "Opções de Bloqueio Automático do Bucket",
            "Auto-Lock Enabled": "Bloqueio Automático Ativado",
            "Size of files Option": "Opção de Tamanho dos Arquivos",
            "Size of files": "Tamanho dos arquivos",
            "Number of files": "Número de arquivos",
            "Number of files Option": "Opção de Número de Arquivos",
            "Default Archive Option": "Opção de Arquivamento Padrão",
            "Allow customization when archiving": "Permitir personalização ao arquivar",
            "Default Restore Options": "Opções de Restauração Padrão",
            "Archive Option": "Opção de Arquivamento",
            "Restore Option": "Opção de Restauração",
            "Back to Project": "Voltar ao Projeto",
            "Archive the item?": "Arquivar o item?",
            "Archive items?": "Arquivar itens?",
            "Restore items?": "Restaurar itens?",
            "files": "arquivos",
            "CPD Integrations": "Integrações CPD",
            "Credentials Information": "Informações de Credenciais",
            "CloudPlex Delivery Information": "Informações do CloudPlex Delivery",
            "Switch Admin": "Alternar Administrador",
            "Space List": "Lista de Espaços",
            "App Download": "Download do App",
            "REQUEST_ARCHIVE": "Solicitação de arquivamento",
            "REQUEST_RESTORE": "Solicitação de restauração",
            "ARCHIVE_ERROR": "Erro de arquivamento",
            "RESTORE_ERROR": "Erro de restauração",
            "RESTORED": "Restaurado",
            "ARCHIVING": "Arquivando",
            "ARCHIVED": "Arquivado",
            "RESTORING": "Restaurando",
            "Add Collection": "Adicionar Coleção",
            "Collections": "Coleções",
            "Assets Count": "Contagem de Ativos",
            "Collection Details": "Detalhes da Coleção",
            "Collection ID": "ID da Coleção",
            "Linked Collections": "Coleções Vinculadas",
            "All Media Types": "Todos os Tipos de Mídia",
            "Specify the folder location?": "Especificar o local da pasta?",
            "Select assets through search": "Selecionar ativos por busca",
            "Select assets in a specific folder?": "Selecionar ativos em uma pasta específica?",
            "Select assets in a specific folder": "Selecionar ativos em uma pasta específica",
            "Selected Assets": "Ativos Selecionados",
            "max": "máx",
            "Also include assets from subfolders": "Incluir também ativos das subpastas",
            "Only assets in that folder are selected": "Apenas os ativos dessa pasta são selecionados",
            "Selected a Folder": "Pasta Selecionada",
            "Selected Collections": "Coleções Selecionadas",
            "Add assets?": "Adicionar ativos?",
            "Collections Search Results": "Resultados da Busca de Coleções",
            "Enter ID": "Inserir ID",
            "Enter the creator": "Inserir o criador",
            "Enter the person who modified it": "Inserir a pessoa que modificou",
            "Enter name": "Inserir nome",
            "Collection": "Coleção",
            "Specify the collection?": "Especificar a coleção?",
            "Assets to be created can be managed by applying them to a specific collection.": "Os ativos a serem criados podem ser gerenciados aplicando-os a uma coleção específica.",
            "Specify the folder where the assets will be located. If not specified, it will be saved in the top path.": "Especifique a pasta onde os ativos serão localizados. Se não especificado, será salvo no caminho raiz.",
            "Duplicate": "Duplicar",
            "Add Fields": "Adicionar Campos",
            "Metadata Fields": "Campos de Metadados",
            "Reference Fields": "Campos de Referência",
            "Hidden": "Oculto",
            "Fields": "Campos",
            "Enter default text": "Inserir texto padrão",
            "Enter default number": "Inserir número padrão",
            "Required": "Obrigatório",
            "Create Content Schema": "Criar Esquema de Conteúdo",
            "Content Schemas": "Esquemas de Conteúdo",
            "Details": "Detalhes",
            "Search for the project name.": "Buscar pelo nome do projeto.",
            "Fields Search": "Busca de Campos",
            "No Metadata Fields yet.": "Nenhum Campo de Metadados ainda.",
            "No Reference Fields yet.": "Nenhum Campo de Referência ainda.",
            "Custom Fields": "Campos Personalizados",
            "No {{isReference}} Fields yet.": "Nenhum Campo {{isReference}} ainda.",
            "Enter field name": "Inserir nome do campo",
            " {{name}}": " {{name}}",
            " '{{name}}' and <emp>{{count}}</emp> others": " '{{name}}' e <emp>{{count}}</emp> outros",
            "Select type": "Selecionar tipo",
            "Select status": "Selecionar status",
            "Remove the item?": "Excluir o item?",
            "Remove items?": "Excluir itens?",
            "Delete items?": "Excluir itens?",
            "Archiving asset...": "arquivando ativo...",
            "Restoring asset...": "restaurando ativo...",
            "Create {{schemaName}}": "Criar {{schemaName}}",
            "Selected Image": "Imagem Selecionada",
            "Selected {{referenceType}}": "{{referenceType}} Selecionado",
            "Enter text": "Inserir texto",
            "Enter number": "Inserir número",
            "No {{name}} yet.": "Ainda não há {{name}}.",
            "Enter description": "Inserir descrição",
            "Engine to Use": "Motor a usar",
            "Service Type": "Tipo de serviço",
            "Auto Language (<Strong>{{n}}</Strong>/max. {{max}})": "Idioma automático (<Strong>{{n}}</Strong>/máx. {{max}})",
            "Vocabulary Book": "Dicionário de vocabulário",
            "Select Vocabulary Book": "Selecionar dicionário de vocabulário",
            "Not Selected": "Não selecionado",
            "Select Default Language": "Selecionar idioma padrão",
            "Go to vocabulary book": "Ir para o dicionário de vocabulário",
            "Speaker Classification": "Classificação de falante",
            "Enter Label": "Inserir rótulo",
            "Enter Asset name": "Inserir nome do Ativo",
            "Sounds Like": "Soa como",
            "Display As": "Exibir como",
            "Add Vocabulary": "Adicionar vocabulário",
            "Enter Display As": "Inserir Exibir como",
            "Enter Sounds Like (Enter after typing)": "Inserir Soa como (pressione Enter após digitar)",
            "Credentials": "Credenciais",
            "Engines": "Motores",
            "Available in Auto Captions.": "Disponível em Legendas automáticas.",
            "Before input": "Antes da entrada",
            "Typing": "Digitando",
            "Editing": "Editando",
            "Input complete": "Entrada concluída",
            "Assets > Video Asset Detail > Related Assets": "Ativos > Detalhes do Ativo de Vídeo > Ativos relacionados",
            "Contents > Videos Detail > Captions > Auto Captions": "Conteúdo > Detalhes de Vídeos > Legendas > Legendas automáticas",
            "Additional informations": "Informações adicionais",
            "Auto caption": "Legenda automática",
            "Console Default Language": "Idioma padrão do Console",
            "List Default Layout": "Layout padrão da lista",
            "Additional AI analysis": "Análise adicional",
            "View timestamps": "Ver timestamps",
            "Start AI analysis": "Iniciar análise de IA",
            "AI analysis completed": "Análise de IA concluída",
            "AI Analysis": "Análise de IA",
            "Added to Check timestamp": "Adicionado a 'Verificar timestamp'",
            "Removed from Check timestamp": "Removido de 'Verificar timestamp'",
            "Removed from Metadata tags": "Removido de 'Tags de Metadados'",
            "Added to Metadata tags": "Adicionado a 'Tags de Metadados'",
            "Engine": "Motor",
            "Summary analysis result": "Resultado resumido da análise",
            "Original analysis result": "Resultado original da análise",
            "Top 10 most exposed labels": "Top 10 rótulos mais expostos",
            "Exposure Point (First / Last)": "Ponto de exposição (Primeiro / Último)",
            "Label detection in Video": "Detecção de rótulos no vídeo",
            "Recognize Faces in Video": "Reconhecer rostos no vídeo",
            "Recognize Celebrity in Video": "Reconhecer celebridades no vídeo",
            "Content Moderation in Video": "Moderação de conteúdo no vídeo",
            "Video transcription": "Transcrição de vídeo",
            "Long audio transcription": "Transcrição de áudio longo",
            "Annotate Scenes in Video": "Anotar cenas no vídeo",
            "Recognize Texts in Video": "Reconhecer textos no vídeo",
            "Avg. Confidence (%)": "Confiança média (%)",
            "Timestamp - Start": "Timestamp - Início",
            "Timestamp - End": "Timestamp - Fim",
            "Analysis result {{number}}": "Resultado da análise {{number}}",
            "Auto Detected": "Detectado automaticamente",
            "Check timestamp for each label": "Verificar timestamp de cada rótulo",
            "View Details": "Ver detalhes",
            "Fold": "Recolher",
            "Expand": "Expandir",
            "point of initial exposure": "ponto de exposição inicial",
            "last exposure point": "último ponto de exposição",
            "Update Asset": "Atualizar Ativo",
            "Reply to thread": "Responder à thread",
            "Edit message": "Editar mensagem",
            "Add reaction": "Adicionar reação",
            "Delete message": "Excluir mensagem",
            "{{commentCount}} replies": "{{commentCount}} respostas",
            "See all replies": "Ver todas as respostas",
            "replies": "respostas",
            "Thread": "Thread",
            "Reply": "Responder",
            "Replied to :": "Em resposta a :",
            "Please enter your message.": "Por favor, insira sua mensagem.",
            "Yesterday": "Ontem",
            "member of comment": "membro do comentário",
            "Change name": "Alterar nome",
            "Private comment name (maximum <0>{{count}}</0> characters)": "Nome do comentário privado (máximo <0>{{count}}</0> caracteres)",
            "Add member": "Adicionar membro",
            "Delete private comment": "Excluir comentário privado",
            "All public": "Todos públicos",
            "member": "membro",
            "Check": "Verificar",
            "Private comment name": "Nome do comentário privado",
            "Comments where I was mentioned": "Comentários onde fui mencionado",
            "Comments written by me": "Comentários escritos por mim",
            "Comments in threads I belong to": "Comentários em threads dos quais faço parte",
            "Reply to my comment": "Resposta ao meu comentário",
            "My Comments": "Meus Comentários",
            "Waiting for invitation": "Aguardando convite",
            "User invitation": "Convite de usuário",
            "Would you like to invite users?": "Deseja convidar usuários?",
            "Invite": "Convidar",
            "Accessible project": "Projeto acessível",
            "Invitation date": "Data do convite",
            "Pending Invitation": "Convite pendente",
            "User waiting to be invited": "Usuário aguardando convite",
            "Projects you want to allow access to": "Projetos aos quais deseja permitir acesso",
            "Create Roles": "Criar Funções",
            "Manual settings": "Configurações manuais",
            "Auto settings": "Configurações automáticas",
            "ROLES_Read": "Permissão de leitura",
            "ROLES_Edit": "Permissão de edição",
            "ROLES_Archive": "Permissão de arquivamento",
            "ROLES_Download": "Permissão de Download",
            "ROLES_Internal": "Permissão de compartilhamento interno",
            "ROLES_External": "Permissão de compartilhamento interno・externo",
            "ROLES_Publish": "Permissão de publicação",
            "ROLES_Internal Request": "Permissão de solicitação interna",
            "Custom Metadata": "Metadados personalizados",
            "Select Content Schema": "Selecionar esquema de conteúdo",
            "Search by content schema name.": "Buscar por nome do esquema de conteúdo.",
            "Selected schema": "Esquema selecionado",
            "Accessed": "Acessado",
            "CreatedAt": "Criado",
            "Add Users or Groups": "Adicionar Usuários ou Grupos",
            "Share Settings": "Configurações de compartilhamento",
            "Add to Added Users": "Adicionar aos usuários adicionados",
            "Maximum": "Máximo",
            "times": "vezes",
            "Current location": "Localização atual",
            "Where to clone": "Para onde clonar",
            "Save to top path": "Salvar no caminho raiz",
            "Parent folder": "Pasta pai",
            "Parent folder location": "Localização da pasta pai",
            "Select file": "Selecionar arquivo",
            "Unapply": "Desfazer aplicação",
            "Undo add": "Desfazer adição",
            "Clear": "Limpar",
            "Choose one custom data.": "Escolha um dado personalizado.",
            "Folder Duplication": "Duplicação de pasta",
            "Duplication target folder": "Pasta de destino da duplicação",
            "Asset to be duplicated": "Ativo a ser duplicado",
            "Request share": "Solicitar compartilhamento",
            "Share link": "Link de compartilhamento",
            "Downloader Permission Settings": "Configurações de permissão do Download",
            "Sharing Period": "Período de compartilhamento",
            "Related Assets": "Ativos relacionados",
            "Linked Assets": "Ativos vinculados",
            "Remove Asset": "Excluir Ativo",
            "Add Linked Assets?": "Adicionar Ativos vinculados?",
            "Menu Display": "Exibição do menu",
            "info": "informações",
            "Specify Folder Location": "Especificar localização da pasta",
            "Select by Recent Location": "Selecionar por localização recente",
            "Create a private comment": "Criar um comentário privado",
            "Open comment window": "Abrir janela de comentários",
            "Close comment window": "Fechar janela de comentários",
            "Specify Collection": "Especificar Coleção",
            "Moving to CloudPlex Media…": "Movendo para CloudPlex Media…",
            "edited": "editado",
            "Uploading files": "Fazendo Upload de arquivos",
            "Cancel Upload": "Cancelar Upload",
            "Attach Files": "Anexar arquivos",
            "Mention": "Mencionar",
            "Attach Emoji": "Anexar emoji",
            "Files cannot be attached.": "Não é possível anexar arquivos.",
            "Asset Duplication": "Duplicação de Ativo",
            "Please search by folder name": "Busque pelo nome da pasta",
            "Added Users": "Usuários adicionados",
            "Custom Content": "Conteúdo personalizado",
            "Storages": "Armazenamentos",
            "Custom Contents": "Conteúdos personalizados",
            "All categories": "Todas as categorias",
            "Default Custom Metadata": "Metadados personalizados padrão",
            "Default View Mode": "Modo de visualização padrão",
            "List view": "Visualização em lista",
            "Folder view": "Visualização em pasta",
            "Category view": "Visualização em categoria",
            "Select default metadata template": "Selecionar modelo de metadados padrão",
            "Select default custom metadata": "Selecionar metadados personalizados padrão",
            "Please enter a message for your request (Optional)": "Insira uma mensagem para sua solicitação (Opcional)",
            "Enter name or email": "Inserir nome ou e-mail",
            "Duplicate this role?": "Duplicar esta função?",
            "Change Name": "Alterar Nome",
            "Enter required values": "Inserir valores obrigatórios",
            "Select Custom Metadata": "Selecionar Metadados personalizados",
            "Select custom metadata": "Selecionar metadados personalizados",
            "Duplicate within a subfolder": "Duplicar dentro de uma subpasta",
            "Duplication target assets": "Ativos de destino da duplicação",
            "Asset to be copied": "Ativo a ser copiado",
            "Create assets from all files individually": "Criar ativos de todos os arquivos individualmente",
            "Creating image and caption files as one asset": "Criar imagem e arquivos de legenda como um único ativo",
            "Please select files to add": "Selecione os arquivos a adicionar",
            "Select all files": "Selecionar todos os arquivos",
            "InteractiveVideos": "Vídeos interativos",
            "and <emp>{{count}}</emp> others": "e mais <emp>{{count}}</emp>",
            "Asset Bulk Create": "Criação em massa de Ativos",
            "An error occurred while preparing the asset for {{type}}.": "Ocorreu um erro ao preparar o ativo para {{type}}.",
            "Transcode in progress": "Transcodificação em andamento",
            "Transcode has been cancelled.": "A transcodificação foi cancelada.",
            "Transcode completed.": "Transcodificação concluída.",
            "An error occurred while transcoding.": "Ocorreu um erro durante a transcodificação.",
            "Asset Duplicate": "Duplicar Ativo",
            "Asset Jobs": "Tarefas do Ativo",
            "Source Jobs": "Tarefas da fonte",
            "Change Menu Name": "Alterar nome do menu",
            "Default menu name": "Nome padrão do menu",
            "Menu name to change": "Nome do menu a alterar",
            "Apply as default menu name": "Aplicar como nome padrão do menu",
            "History of share link": "Histórico de link de compartilhamento",
            "Select collections in a specific folder?": "Selecionar coleções em uma pasta específica?",
            "Delete Group": "Excluir Grupo",
            "COPY_ASSETS": "Duplicar Ativos",
            "UPLOAD_ASSET": "Criar Ativo",
            "CREATE_ASSETS": "Criação em massa de Ativos",
            "UPLOAD": "Upload de arquivos",
            "ASSET_DOWNLOAD": "Download de Ativo",
            "STORAGE_DOWNLOAD": "Download de armazenamento",
            "Create Asset": "Criar Ativo",
            "Asset Download": "Download de Ativo",
            "Storage Download": "Download de armazenamento",
            "TRANSCODE": "Transcodificar",
            "COPY": "Copiar",
            "RENAME": "Renomear",
            "REMOVE": "Excluir",
            "DELETE": "Excluir",
            "Replication location": "Local de replicação",
            "existing location": "local existente",
            "Copy assets": "Copiar ativos",
            "Drag files here": "Arraste arquivos aqui",
            "Browse": "procurar",
            "drop your files to upload": "solte seus arquivos para fazer Upload",
            "Downloader": "Download",
            "Viewer": "Visualizador",
            "Adjust": "Ajustar",
            "Back to list": "Voltar à lista",
            "Back to comments": "Voltar aos comentários",
            "View private comments": "Ver comentários privados",
            "Close private comments": "Fechar comentários privados",
            "Select project": "Selecionar projeto",
            "Role settings": "Configurações de função",
            "All projects": "Todos os projetos",
            "Comments": "Comentários",
            "Folders": "Pastas",
            "Integrated Search": "Busca integrada",
            "Users & Groups": "Usuários e Grupos",
            "Project In Use": "Projeto em uso",
            "Manage Account": "Gerenciar conta",
            "Log out": "Sair",
            "Sub menu": "Submenu",
            "Storage files": "Arquivos de armazenamento",
            "Please enter a description of the asset.": "Insira uma descrição do ativo.",
            "Create Role": "Criar Função",
            "Create Workflow": "Criar Workflow",
            "Comment": "Comentário",
            "Specific": "Específico",
            "Go to space list": "Ir para a lista de espaços",
            "Bold": "Negrito",
            "Underline": "Sublinhado",
            "Strikethrough": "Tachado",
            "Share request": "Solicitação de compartilhamento",
            "contents": "conteúdos",
            "collections": "coleções",
            "preview images": "imagens de pré-visualização",
            "Add {{name}}?": "Adicionar {{name}}?",
            "User invited to group": "Usuário convidado para o grupo",
            "Space Admin": "Administrador do Espaço",
            "Project Admin": "Administrador do Projeto",
            "Recent Assets Shared To Me": "Ativos Recentes Compartilhados Comigo",
            "Recent Assets": "Ativos Recentes",
            "archive assets": "arquivar ativos",
            "ARCHIVE_ASSETS": "Arquivo de Ativos",
            "An error occurred while preparing {{type}}.": "Ocorreu um erro ao preparar {{type}}.",
            "Preparing {{type}}": "Preparando {{type}}",
            "{{type}} in progress": "{{type}} em andamento",
            "Metadata Export": "Exportação de Metadados",
            "Completed At": "Concluído Em",
            "PROCESSING": "PROCESSANDO",
            "search options": "opções de busca",
            "Export": "Exportar",
            "Asset creation period": "Período de criação do ativo",
            "COMPLETED": "CONCLUÍDO",
            "Created At": "Criado Em",
            "Updated At": "Atualizado Em",
            "Project count": "Quantidade de projetos",
            "Additional items": "Itens adicionais",
            "Make": "Criar",
            "Export metadata": "Exportar metadados",
            "Name setting": "Configuração de nome",
            "Selected projects": "Projetos selecionados",
            "Asset creation date": "Data de criação do ativo",
            "Directly assigned": "Atribuído diretamente",
            "Create Collection": "Criar Coleção",
            "Select scope": "Selecionar escopo",
            "METADATA_DOWNLOAD": "Download de Metadados",
            "Metadata download": "Download de metadados",
            "Vocabulary": "Vocabulário",
            "Assets Name": "Nome dos Ativos",
            "Assets ID": "ID dos Ativos",
            "Preview Settings": "Configurações de Pré-visualização",
            "Assets to share": "Ativos para compartilhar",
            "Collections to share": "Coleções para compartilhar",
            "Folder to share": "Pasta para compartilhar",
            "Archive assets": "Arquivar ativos",
            "COLLECTION_DOWNLOAD": "Download de coleção",
            "collection download": "Download de coleção",
            "Event occurrence date and time": "Data e hora de ocorrência do evento",
            "Domain": "Domínio",
            "Admin Audit Logs": "Logs de Auditoria do Administrador",
            "Audit log details": "Detalhes do log de auditoria",
            "User Agent": "Agente de usuário",
            "Select domain": "Selecionar domínio",
            "Select action": "Selecionar ação",
            "Select requestedBy": "Selecionar usuário",
            "Publishing options": "Opções de publicação",
            "Player ControlBar Control": "Controle da Barra de Controle do Player",
            "Start the Player Fullscreen": "Iniciar Player em Tela Cheia",
            "Continue after Stopping the Player": "Continuar após Pausar o Player",
            "Video Download": "Download de Vídeo",
            "Embed code options": "Opções de código de incorporação",
            "Player Width": "Largura do Player",
            "Auto Play": "Reprodução Automática",
            "Loop Play": "Reprodução em Loop",
            "Play directly with the player within the web page": "Reproduzir diretamente com o player na página web",
            "Copied": "Copiado",
            "Add Vocabulary Book": "Adicionar Livro de Vocabulário",
            "Vocabulary Book ID": "ID do Livro de Vocabulário",
            "Shrink": "Recolher",
            "Example": "Exemplo",
            "1024px or 100%": "1024px ou 100%",
            "Publishing": "Publicando",
            "Reclaiming": "Recuperando",
            "Published": "Publicado",
            "Unpublished": "Despublicado",
            "Enter ResourceId": "Inserir ID do recurso",
            "Enter ThreadResourceId": "Inserir ID do recurso",
            "Select projects": "Selecionar projetos",
            "ResourceId": "ID do Recurso",
            "ThreadResourceId": "ID do Recurso",
            "Select user": "Selecionar usuário",
            "Report collection period": "Período de coleta do relatório",
            "Whether to send mail": "Enviar e-mail",
            "SEND": "ENVIAR",
            "NOT SEND": "NÃO ENVIAR",
            "Targets and actions": "Alvos e ações",
            "Email recipients": "Destinatários do e-mail",
            "Sending cycle": "Ciclo de envio",
            "REPORT_Create": "Criar",
            "REPORT_Delete": "Excluir",
            "Reports": "Relatórios",
            "{{value}} people": "{{value}} pessoas",
            "Total asset count": "Total de ativos",
            "Total asset size": "Tamanho total dos ativos",
            "{{period}} {{condition}} tasks": "Tarefas {{period}} {{condition}}",
            "A week ago": "Uma semana atrás",
            "tasks": "tarefas",
            "{{period}} total": "Total de {{period}}",
            "Top <emp>10</emp> projects by {{period}} tasks": "Top <emp>10</emp> projetos por tarefas de {{period}}",
            "Table": "Tabela",
            "Chart": "Gráfico",
            "{{period}} task count": "Quantidade de tarefas de {{period}}",
            "PM": "PM",
            "AM": "AM",
            "{{hour}}:{{minute}} {{period}}": "{{hour}}:{{minute}} {{period}}",
            "Pipeline during video creation": "Pipeline durante a criação de vídeo",
            "Resource ID": "ID do Recurso",
            "Video editing": "Edição de vídeo",
            "Video image capture": "Captura de imagem de vídeo",
            "Pan": "Pan",
            "Zoom": "Zoom",
            "Cut": "Cortar",
            "Pull start marker": "Arrastar marcador de início",
            "Pull end marker": "Arrastar marcador de fim",
            "Video name": "Nome do vídeo",
            "Create a video": "Criar um vídeo",
            "Create an edited video": "Criar um vídeo editado",
            "Edit and save images": "Editar e salvar imagens",
            "Save as asset": "Salvar como ativo",
            "Current video time": "Tempo atual do vídeo",
            "Aspect custom": "Personalizado",
            "Scale": "Escala",
            "Coordinate": "Coordenada",
            "Incision": "Incisão",
            "frame {{id}}": "frame {{id}}",
            "Image size": "Tamanho da imagem",
            "Folder location": "Local da pasta",
            "Get instant download": "Obter download imediato",
            "Auto-archive status": "Status de arquivamento automático",
            "Auto-archive enabled": "Arquivamento automático ativado",
            "Auto-archive schedule date": "Data programada de arquivamento automático",
            "Automatic storage date after asset creation": "Data de armazenamento automático após criação do ativo",
            "Prefix before asset name": "Prefixo antes do nome do ativo",
            "days later": "dias depois",
            "or more": "ou mais",
            "days left": "dias restantes",
            "Select content in a specific folder?": "Selecionar conteúdo em uma pasta específica?",
            "Failure reason": "Motivo da falha",
            "Unsupported reason": "Motivo da falta de suporte",
            "Field description": "Descrição do campo",
            "Field default value": "Valor padrão do campo",
            "Enter field link": "Inserir link do campo",
            "Add link": "Adicionar link",
            "Add group": "Adicionar grupo",
            "Enter your name": "Insira seu nome",
            "Preparing to share": "Preparando para compartilhar",
            "Send again": "Enviar novamente",
            "Cancel invitation": "Cancelar convite",
            "Total file size": "Tamanho total do arquivo",
            "Total Usage": "Uso Total",
            "Project Settings > Settings > Menu (e.g. Assets) > Category Groups": "Configurações do Projeto > Configurações > Menu (ex.: Ativos) > Grupos de Categorias",
            "Setting location": "Local de configuração",
            "Category group settings": "Configurações de grupo de categorias",
            "Please select a custom metadata preset.": "Selecione um preset de metadados personalizados.",
            "Load custom metadata schema": "Carregar esquema de metadados personalizados",
            "Load Metadata": "Carregar Metadados",
            "PROJECT_RESOURCES_DOWNLOAD": "Download dos Recursos do Projeto",
            "Project resources download": "Download dos Recursos do Projeto",
            "Statistics period": "Período estatístico",
            "Weekly change": "Variação semanal",
            "Weekly Asset Count": "Atualizações semanais de ativos",
            "Weekly File Size": "Uso semanal de arquivos",
            "Asset count": "Quantidade de ativos",
            "Comment Room Option": "Opção de Sala de Comentários",
            "Project Comment": "Comentário do Projeto",
            "preview image": "imagem de pré-visualização",
            "Activity History": "Histórico de Atividades",
            "Activity": "Atividade",
            "Select location": "Selecionar local",
            "item selected": "item selecionado",
            "Include subfolders": "Incluir subpastas",
            "Thumbnail": "Miniatura",
            "Maintain image proportions": "Preencher para ajustar ao contêiner",
            "Crop": "Recortar",
            "Create asset": "Criar ativo",
            "Menu": "Menu",
            "Cusom settings": "Configurações personalizadas",
            "Submenu": "Submenu",
            "Add menu": "Adicionar menu",
            "Add submenu": "Adicionar submenu",
            "Library": "Biblioteca",
            "Menu item settings": "Configurações de item de menu",
            "Menu name": "Nome do menu",
            "Add assets from folder": "Adicionar ativos da pasta",
            "Downloads": "Downloads",
            "Select menu": "Selecionar menu",
            "Default settings": "Configurações padrão",
            "Custom settings": "Configurações personalizadas",
            "First entry screen": "Tela de entrada inicial",
            "First entry screen(Create page)": "Tela de entrada inicial (Página de criação)",
            "Edit menu": "Editar",
            "role_Copy": "Copiar",
            "Shared At": "Compartilhado Em",
            "VIDEO": "Vídeo",
            "AUDIO": "Áudio",
            "PEOPLE": "Pessoas",
            "TEXT": "Texto",
            "FILE": "Arquivo",
            "Select media type": "Selecionar tipo de mídia",
            "Widget Preference": "Preferência de Widget",
            "LastName/FirstName": "Sobrenome/Nome",
            "Site access permission": "Permissão de acesso ao site",
            "Person in charge": "Responsável",
            "Request date": "Data da solicitação",
            "Request I made": "Solicitações que fiz",
            "Request received": "Solicitações recebidas",
            "Inquiry history": "Histórico de consultas",
            "In Review": "Em Revisão",
            "Respond": "Responder",
            "Attachment": "Anexo",
            "Request download": "Solicitar download",
            "Setting download permissions": "Definir permissões de download",
            "Unlimited": "Ilimitado",
            "Unstarred": "Sem estrela",
            "Selected Categories": "Categorias Selecionadas",
            "Select requester": "Selecionar solicitante",
            "Select person in charge": "Selecionar responsável",
            "Common": "Comum",
            "Download permission": "Permissão de download",
            "Not assigned": "Não atribuído",
            "Attached file": "Arquivo anexado",
            "Shared users": "Usuários compartilhados",
            "Shared management": "Gerenciamento de compartilhamento",
            "Share expiration date": "Data de expiração do compartilhamento",
            "Number of downloads remaining": "Número de downloads restantes",
            "Share date": "Data de compartilhamento",
            "Asset Create": "Criar Ativo",
            "Asset Archive": "Arquivo de Ativos",
            "COMMENT_ATTACHMENT_DOWNLOAD": "Download de Anexo de Comentário",
            "Metadata Download": "Download de Metadados",
            "Comment Attachment Download": "Download de Anexo de Comentário",
            "My Jobs": "Minhas Tarefas",
            "Requests": "Solicitações",
            "Upload from My PC": "Upload do Meu PC",
            "Upload from cloud": "Upload da nuvem",
            "To Start Page": "Para a Página Inicial",
            "Go to previous page": "Ir para a página anterior",
            "Go to first page": "Ir para a primeira página",
            "Go to next page": "Ir para a próxima página",
            "Go to last page": "Ir para a última página",
            "Go to page {{page}}": "Ir para a página {{page}}",
            "Go to start-ellipsis page": "Ir para as páginas anteriores",
            "Go to end-ellipsis page": "Ir para as próximas páginas",
            "Open": "Abrir",
            "REQUEST_ATTACHMENT_DOWNLOAD": "Download de Anexo da Solicitação",
            "Request Attachment Download": "Download de Anexo da Solicitação",
            "Partial": "Parcial",
            "Request attachment download": "Download de anexo da solicitação",
            "Reverse sort direction": "Inverter direção de ordenação",
            "Selected Attachment": "Anexo Selecionado",
            "No Channel Categories": "Sem Categorias de Canal",
            "Search Engine": "Motor de Busca",
            "Create caption asset": "Criar ativo de legenda",
            "Create video asset": "Criar ativo de vídeo",
            "Create audio asset": "Criar ativo de áudio",
            "Create image asset": "Criar ativo de imagem",
            "Create file asset": "Criar ativo de arquivo",
            "Caption asset": "Ativo de legenda",
            "Video asset": "Ativo de vídeo",
            "Audio asset": "Ativo de áudio",
            "Image asset": "Ativo de imagem",
            "File asset": "Ativo de arquivo",
            "Caption kind": "Tipo de legenda",
            "Caption language": "Idioma da legenda",
            "Create Event Triggers": "Criar Gatilhos de Evento",
            "Task": "Tarefa",
            "TRIGGER": "GATILHO",
            "CHOICE": "ESCOLHA",
            "TASK": "TAREFA",
            "Input Path": "Caminho de Entrada",
            "Options": "Opções",
            "Enter key": "Inserir chave",
            "Enter value": "Inserir valor",
            "Auto Language ({{n}}/max. {{max}})": "Idioma Automático ({{n}}/máx. {{max}})",
            "Add Task": "Adicionar Tarefa",
            "Keep original folder structure": "Manter estrutura de pasta original",
            "AI Analysis Settings": "Configurações de Análise de IA",
            "Transcribe": "Transcrever",
            "STT": "STT",
            "Video annotation": "Anotação de vídeo",
            "OCR": "OCR",
            "Vocabulary book": "Caderno de vocabulário",
            "Speaker classification": "Classificação de locutor",
            "Asset creation options": "Opções de criação de Ativo",
            "Create per file": "Criar por arquivo",
            "Create as a batch": "Criar como lote",
            "Create collection": "Criar Coleção",
            "Invited user": "Usuário convidado",
            "Space admin permission": "Permissão de administrador do espaço",
            "Grant space admin": "Conceder administrador do espaço",
            "Please search by name": "Pesquise pelo nome",
            "Grant site access": "Conceder acesso ao site",
            "Admin permission": "Permissão de administrador",
            "Select admin": "Selecionar administrador",
            "Grant project admin": "Conceder administrador do projeto",
            "Bucket Settings": "Configurações de Bucket",
            "Essential": "Essencial",
            "AWS Account Connection": "Conexão de Conta AWS",
            "Create Project": "Criar Projeto",
            "Use Service Account": "Usar Conta de Serviço",
            "Connect External Account": "Conectar Conta Externa",
            "Region Settings": "Configurações de Região",
            "AWS Account Connection Guide": "Guia de Conexão de Conta AWS",
            "Create IAM Permission": "Criar Permissão IAM",
            "Copy code": "Copiar código",
            "Create IAM Role": "Criar Função IAM",
            "View Connection Guide": "Ver Guia de Conexão",
            "Group Access Management": "Gerenciamento de Acesso de Grupo",
            "User Access Management": "Gerenciamento de Acesso de Usuário",
            "Change Owner": "Alterar Proprietário",
            "Change": "Alterar",
            "Not locked": "Não bloqueado",
            "Locked state": "Estado bloqueado",
            "Region": "Região",
            "AWS account connection": "Conexão de conta AWS",
            "Retrieving analysis results...": "Recuperando resultados de análise...",
            "AI Auto Tagging": "Auto Tagging por IA",
            "Use": "Usar",
            "Don't Use": "Não usar",
            "Min. Confidence": "Confiança mínima",
            "API Key": "Chave de API",
            "Summary": "Resumo",
            "Usage Dashboard": "Dashboard de Uso",
            "Unique accessed users": "Usuários únicos acessados",
            "Transcoding jobs": "Tarefas de transcodificação",
            "Total assets": "Total de Ativos",
            "Metadata registration rate": "Taxa de registro de Metadados",
            "AI jobs": "Tarefas de IA",
            "A month ago": "Um mês atrás",
            "Usage Trend": "Tendência de Uso",
            "Asset count and storage usage by {{target}}": "Contagem de Ativos e uso de armazenamento por {{target}}",
            "AI jobs by service type": "Tarefas de IA por tipo de serviço",
            "AI jobs by engine": "Tarefas de IA por motor",
            "Assets by media type": "Ativos por tipo de mídia",
            "Daily asset creation count": "Contagem diária de criação de Ativos",
            "All customers": "Todos os clientes",
            "Segment detection": "Detecção de segmento",
            "Text detection": "Detecção de texto",
            "Translate": "Traduzir",
            "{{target}} detail data": "Dados detalhados de {{target}}",
            "File size": "Tamanho do arquivo",
            "Customer name": "Nome do cliente",
            "customer": "cliente",
            "project": "projeto",
            "Grant role": "Conceder função",
            "Loading Data...": "Carregando dados...",
            "MimeType": "Tipo MIME",
            "Inviter": "Convidante",
            "Mark as read": "Marcar como lido",
            "Mark as unread": "Marcar como não lido",
            "Mark all as read": "Marcar todos como lidos",
            "Notifications": "Notificações",
            "Show only unread items": "Mostrar apenas itens não lidos",
            "Subtitle generation basic settings": "Configurações básicas de geração de legenda",
            "Auto-delete input bucket": "Excluir automaticamente bucket de entrada",
            "Try again": "Tentar novamente",
            "Ask a new question": "Fazer uma nova pergunta",
            "New Task": "Nova Tarefa",
            "Tasks": "Tarefas",
            "Go Back": "Voltar",
            "Create Shortform": "Criar Shortform",
            "AI WorkSpace Preset": "Predefinição de AI WorkSpace",
            "Active presets": "Predefinições ativas",
            "Creation location": "Local de criação",
            "Create Prompt Presets": "Criar Predefinições de Prompt",
            "Prompt": "Prompt",
            "Response format": "Formato de resposta",
            "Timeline for editing": "Linha do tempo para edição",
            "AI Workspace": "AI Workspace",
            "Unsupported video file format": "Formato de arquivo de vídeo não suportado",
            "Name ascending order": "Nome em ordem crescente",
            "Name descending order": "Nome em ordem decrescente",
            "Expiration date": "Data de expiração",
            "Save Tags": "Salvar Tags",
            "Deleted after {{day}} day(s)": "Excluído após {{day}} dia(s)",
            "Single type": "Tipo único",
            "Chat type": "Tipo chat",
            "Save description immediately": "Salvar descrição imediatamente",
            "Save Description": "Salvar descrição",
            "Start ingest": "Iniciar ingestão",
            "End ingest": "Encerrar ingestão",
            "Start transcoding": "Iniciar transcodificação",
            "End transcoding": "Encerrar transcodificação",
            "Copy description": "Copiar",
            "Whether transcoded assets are exposed": "Se os Ativos transcodificados são expostos",
            "Create original quality video only": "Criar somente vídeo de qualidade original",
            "Automatically activated": "Ativado automaticamente",
            "Publish to YouTube": "Publicar no YouTube",
            "Create and manage video URL": "Criar e gerenciar URL de vídeo",
            "Published channels": "Canais publicados",
            "Delete URL": "Excluir URL",
            "Create URL": "Criar URL",
            "You can create a URL for video sharing.": "Você pode criar uma URL para compartilhamento de vídeo.",
            "Creating video URL": "Criando URL de vídeo",
            "MODAL_Publishing": "Publicação",
            "Selected": "Selecionado",
            "audit logs": "logs de auditoria",
            "Select description": "Selecionar ação",
            "List View Settings": "Configurações de Visualização em Lista",
            "User Preference Widget": "Widget de Preferência do Usuário",
            "User Group Preference Widget": "Widget de Preferência de Grupo de Usuários",
            "Project Preference Widget": "Widget de Preferência do Projeto",
            "Entire Period": "Período Inteiro",
            "This Week": "Esta Semana",
            "This Month": "Este Mês",
            "This Year": "Este Ano",
            "Last 15 Minutes": "Últimos 15 Minutos",
            "Last 30 Minutes": "Últimos 30 Minutos",
            "Last 1 Hour": "Última 1 Hora",
            "Last 4 Hours": "Últimas 4 Horas",
            "Apply with Project Settings": "Aplicar com Configurações do Projeto",
            "Line Chart": "Gráfico de Linha",
            "Bar Chart": "Gráfico de Barras",
            "Notice": "Aviso",
            "Cancel Update": "Cancelar Atualização",
            "Widget Type": "Tipo de Widget",
            "Wide Type": "Tipo Amplo",
            "Default Dashboard Exposure": "Exposição Padrão do Dashboard",
            "Widget Exposure Settings": "Configurações de Exposição do Widget",
            "Not Entered": "Não Inserido",
            "Show Search Options": "Mostrar Opções de Busca",
            "Project Settings > Settings > Menu (e.g. Asset) > Category Group": "Configurações do Projeto > Configurações > Menu (ex.: Ativo) > Grupo de Categoria",
            "Date to automatically retain assets after creation or restoration": "Data para reter Ativos automaticamente após criação ou restauração",
            "Category Group": "Grupo de Categoria",
            "Asset name 1": "Nome do Ativo 1",
            "Empty notifications": "Nenhuma notificação",
            "Unread only": "Somente não lidos",
            "Read only": "Somente lidos",
            "Mixed read/unread": "Mistos lidos/não lidos",
            "All comment types mixed": "Todos os tipos de Comentário mistos",
            "All domains mixed": "Todos os domínios mistos",
            "All asset media types mixed": "Todos os tipos de mídia de Ativo mistos",
            "Turn off test mode": "Desativar modo de teste",
            "Turn on test mode": "Ativar modo de teste",
            "Select a preset": "Selecionar uma predefinição",
            "Recommended": "Recomendado",
            "More": "Mais",
            "Hide Presets": "Ocultar Predefinições",
            "See More Presets": "Ver Mais Predefinições",
            "Duplicate {{name}}": "Duplicar {{name}}",
            "Schedule ID": "ID de Agendamento",
            "Enter Owner": "Inserir Proprietário",
            "24 hour operation": "Operação 24 horas",
            "CAPTION": "LEGENDA",
            "Search all Assets": "Buscar todos os Ativos",
            "Add Content Schema": "Adicionar Esquema de Conteúdo",
            "Add {{schemaName}}": "Adicionar {{schemaName}}",
            "Enter Sounds Like": "Inserir Sons Como",
            "There are no analysis results for {{name}}.": "Não há resultados de análise para {{name}}.",
            "Change menu name": "Alterar nome do menu",
            "Delete group": "Excluir grupo",
            "Recent Assets Shared to Me": "Ativos Recentes Compartilhados Comigo",
            "Empty Data": "Não há dados",
            "Users and teams belonging to the project for the selected asset are excluded from sharing.": "Usuários e equipes pertencentes ao projeto do Ativo selecionado estão excluídos do compartilhamento.",
            "Recoding": "Recodificação",
            "share": "compartilhar",
            "Information": "Informações",
            "No permission": "Sem permissão",
            "MOVE": "MOVER",
            "metadata export": "exportação de Metadados",
            "Collection Download": "Download de Coleção",
            "Selected {{referenceType}}s": "{{referenceType}}s selecionado(s)",
            "Source Upload": "Upload de Origem",
            "This operation was not entirely successful.": "Esta operação não foi totalmente bem-sucedida.",
            "View": "Visualizar",
            "Unable to use AI-Workspace": "Não é possível usar AI-Workspace",
            "Read Only": "Somente Leitura",
            "Switch": "Alternar",
            "Switching": "Alternando",
            "S3_OBJECT_CREATED": "Quando um arquivo é carregado",
            "ASSET_CREATED": "Quando um Ativo é criado",
            "FILTER_BY_FILE_EXTENSION": "Filtrar por extensão de arquivo",
            "FILTER_BY_FILE_SIZE": "Filtrar por tamanho de arquivo",
            "FILTER_BY_ASSET_MEDIA_TYPE": "Filtrar por tipo de mídia do Ativo",
            "FILTER_BY_ASSET_SIZE": "Filtrar por tamanho do Ativo",
            "ATTACH_ASSET_METADATA": "Anexar Metadados",
            "CREATE_ASSET": "Criar Ativo",
            "CREATE_VIDEO": "Criar vídeo",
            "SUBMIT_AI_WORKSPACE_SINGLE_TYPE_JOB": "Enviar tarefa de AI Workspace",
            "ARCHIVE_ASSET": "Arquivar Ativo",
            "PUBLISH_VIDEO": "Publicar vídeo",
            "File URL": "URL do Arquivo",
            "File Extension": "Extensão do Arquivo",
            "File Size": "Tamanho do Arquivo",
            "Asset Media Type": "Tipo de Mídia do Ativo",
            "Asset Size": "Tamanho do Ativo",
            "Condition": "Condição",
            "Flow Edit": "Editar Flow",
            "Flow Details": "Detalhes do Flow",
            "Auto": "Automático",
            "Manual": "Manual",
            "Select a step": "Selecionar uma etapa",
            "clippings": "Recortes",
            "accountId": "ID da Conta",
            "AiWorkspaceJob SingleTypeJob Output": "Saída da Tarefa AI Workspace",
            "AI Mode": "Modo IA",
            "AI Mode OFF": "Modo IA DESATIVADO",
            "Ask anything": "Pergunte qualquer coisa",
            "Hi, this is AI search mode": "Olá, este é o modo de busca por IA",
            "Describe a scene or feature in the video you are looking for!": "Descreva uma cena ou característica do vídeo que você está procurando!",
            "AI Search Preset Recently modified videos": "Vídeos modificados recentemente",
            "AI Search Preset Golden sunset on the beach": "Pôr do sol dourado na praia",
            "AI Search Preset People in a meeting at the office": "Pessoas em reunião no escritório",
            "AI Search Preset Cinematic mood videos": "Vídeos com clima cinemático",
            "AI Search Preset City night view by drone": "Vista noturna da cidade por drone",
            "AI Search Preset Children smiling brightly": "Crianças sorrindo alegremente",
            "View indexing status": "Ver status de indexação",
            "AI Analysis Plan and Usage": "Plano e Uso de Análise de IA",
            "Ai-billing": "Plano e Uso de Análise de IA",
            "Current subscription": "Assinatura atual",
            "No active subscription": "Nenhuma assinatura ativa",
            "Concurrent sessions": "Sessões simultâneas",
            "Fees and usage": "Taxas e uso",
            "Fees": "Taxas",
            "Usage": "Uso",
            "Aggregating": "Agregando",
            "Settled": "Liquidado",
            "Total so far": "Total até agora",
            "Settled total": "Total liquidado",
            "Period subtotal": "Subtotal do período",
            "Cumulative usage": "Uso acumulado",
            "Year option {{year}}": "{{year}}",
            "Month option {{month}}": "{{month}}",
            "Pay-as-you-go": "Pagamento por uso",
            "No change": "Sem alteração",
            "vs. last month": "vs. mês anterior",
            "min": "min",
            "AI applied": "IA aplicada",
            "Apply all": "Aplicar tudo",
            "Cancel setting": "Cancelar definição",
            "Custom metadata": "Metadados personalizados",
            "Differs from preset schema": "Difere do esquema da predefinição",
            "Not extracted": "Não extraído",
            "Replace": "Substituir",
            "Replace with preset schema": "Substituir pelo esquema da predefinição",
            "Revert to existing schema": "Reverter para o esquema existente",
            "Same as preset schema": "Igual ao esquema da predefinição",
            "Save custom metadata directly": "Salvar metadados personalizados diretamente",
            "Set preset schema": "Definir o esquema da predefinição",
            "Save metadata": "Salvar metadados",
            "Add publish": "Adicionar publicação",
            "Back to manage": "Voltar ao gerenciamento",
            "Copy public URL": "Copiar URL pública",
            "Last published": "Última publicação",
            "Manage public URL": "Gerenciar URL pública",
            "Open public URL": "Abrir URL pública",
            "Open URL": "Abrir URL",
            "Publish ({{count}})": "Publicar ({{count}})",
            "Publish and manage public URL": "Publicar e gerenciar URL pública",
            "Publish public URL": "Publicar URL pública",
            "Publish target": "Destino da publicação",
            "Unpublish": "Cancelar publicação",
            "Unpublish ({{count}})": "Cancelar publicação ({{count}})",
            "{{count}} files": "{{count}} arquivos",
            "English (en-US)": "Inglês (en-US)",
            "Korean (ko-KR)": "Coreano (ko-KR)",
            "Related Videos": "Vídeos relacionados",
            "and <emp>{{count}}</emp> others' shared": "e outros <emp>{{count}}</emp> compartilhados",
            "(<emp>{{count}}</emp> days left)": "(<emp>{{count}}</emp> dias restantes)",
            "Info": "Informações",
            "Filter": "Filtro",
            "Create Highlights": "Criar destaques",
            "Create Description": "Criar descrição",
            "Remove all Shares": "Remover todos os compartilhamentos",
            "Create date": "Data de criação",
            "Complete date": "Data de conclusão",
            "Start Failure": "Falha ao iniciar",
            "Recording Started": "A gravação foi iniciada",
            "Upload Cancel": "Cancelar upload",
            "Select Content in a specific folder?": "Deseja selecionar o conteúdo de uma pasta específica?",
            "Template preview": "Visualização do modelo",
            "Terms and Conditions": "Termos e Condições",
            "toggle password visibility": "alternar visibilidade da senha",
            "{{type}} Asset Name": "Nome do ativo {{type}}",
            "Enter {{type}} Asset Name": "Insira o nome do ativo {{type}}",
            "' shared": "' compartilhado",
            "Minimap": "Minimapa",
            "Go back": "Voltar",
            "Use service account": "Usar conta de serviço",
            "{{names}} and {{restCount}} more": "{{names}} e mais {{restCount}}",
            "Proxy video": "Vídeo proxy",
            "Proxy video status": "Status da extração do proxy",
            "Auto generate proxy video": "Gerar vídeo proxy automaticamente",
            "Proxy video ready": "Proxy pronto",
            "Extracting proxy video": "Extraindo proxy",
            "Proxy extraction failed": "Falha na extração do proxy",
            "Best match": "Melhor correspondência",
            "AI Search": "Busca por IA",
            "{{count}} errors": "{{count}} erros",
            "View by country and referrer": "Ver por país e origem",
            "Countries (this URL)": "Países (esta URL)",
            "Referring domains (this URL)": "Domínios de origem (esta URL)",
            "persons": "pessoas",
            "and {{count}} more": "e mais {{count}}",
            "All URLs": "Todas as URLs",
            "All unpublished": "Todas não publicadas",
            "View all URLs": "Ver todas as URLs",
            "Search URL": "Buscar URL",
            "Share of total": "Participação",
            "Country": "País",
            "CF address": "Endereço CF"
        },
        "msg": {
            "A webhook sends asset event data to an external endpoint whenever a selected trigger occurs.": "Um webhook envia os dados do evento do ativo para um endpoint externo sempre que o gatilho selecionado ocorre.",
            "Deliveries appear here once a selected trigger occurs.": "As entregas aparecem aqui quando um gatilho selecionado ocorre.",
            "\"{{name}}\" will be deleted forever and you won't be able to restore it.": "\"{{name}}\" será excluído permanentemente e não poderá ser restaurado.",
            "Are you sure you want to delete this webhook?": "Tem certeza de que deseja excluir este webhook?",
            "The webhook has been activated.": "O webhook foi ativado.",
            "The webhook has been deactivated. Events will no longer be sent.": "O webhook foi desativado. Os eventos não serão mais enviados.",
            "Please select at least one trigger.": "Selecione pelo menos um gatilho.",
            "Please enter a valid URL.": "Insira uma URL válida.",
            "The URL is too long.": "A URL é muito longa.",
            "Internal addresses (private, loopback, or link-local) cannot be used.": "Endereços internos (privados, loopback ou link-local) não podem ser usados.",
            "We recommend using https.": "Recomendamos usar https.",
            "https://example.com/webhooks": "https://example.com/webhooks",
            "Add request headers such as an authorization token if needed.": "Adicione cabeçalhos de requisição, como um token de autorização, se necessário.",
            "Key is required.": "A chave é obrigatória.",
            "Key must be unique.": "A chave deve ser única.",
            "Only letters, numbers, and hyphens are allowed.": "Somente letras, números e hifens são permitidos.",
            "This header cannot be used.": "Este cabeçalho não pode ser usado.",
            "Line breaks are not allowed.": "Quebras de linha não são permitidas.",
            "Headers can be up to {{maxLength}} characters in total. (currently {{length}})": "Os cabeçalhos podem ter no máximo {{maxLength}} caracteres no total. (atualmente {{length}})",
            "HTTP method is fixed to POST and cannot be changed.": "O método HTTP é fixo em POST e não pode ser alterado.",
            "The request body is determined automatically by the system based on the trigger and cannot be edited.": "O corpo da requisição é definido automaticamente pelo sistema com base no gatilho e não pode ser editado.",
            "Select a trigger to preview the request body.": "Selecione um gatilho para visualizar o corpo da requisição.",
            "How many times the asset was opened through its public URL. Downloads and on-screen views are counted together, and for video, starting playback counts as one - watching to the end is not measured. If there is no access for 30 minutes after the first view, the next view is counted separately.": "Quantas vezes o ativo foi aberto pela URL pública. Downloads e visualizações na tela são contados juntos e, para vídeo, iniciar a reprodução conta como uma - assistir até o fim não é medido. Se não houver acesso por 30 minutos após a primeira visualização, a próxima é contada separadamente.",
            "Total data sent out through this asset's public URLs. Opening the same file again adds to it.": "Total de dados enviados pelas URLs públicas deste ativo. Abrir o mesmo arquivo novamente aumenta esse valor.",
            "An estimate, not a headcount. Several people in one company may count as one, and one person switching devices may count as several.": "É uma estimativa, não uma contagem de pessoas. Várias pessoas de uma mesma empresa podem contar como uma, e uma pessoa que troca de dispositivo pode contar como várias.",
            "The site the visitor came from right before opening this URL. Whether the asset was actually embedded in that page or reached by a link is not distinguished. Entries with no value are grouped as Unknown.": "O site onde o visitante estava logo antes de abrir esta URL. Não é possível distinguir se o ativo estava incorporado naquela página ou se foi acessado por um link. Entradas sem valor são agrupadas como Desconhecido.",
            "Could not load statistics": "Não foi possível carregar as estatísticas",
            "Could not update. Showing the previous result.": "Não foi possível atualizar. Exibindo o resultado anterior.",
            "Data is aggregated hourly, not in real time.": "Os dados são agregados a cada hora, não em tempo real.",
            "Aggregated hourly, so the most recent views may not be here yet. Do not decide whether a URL is still in use from this column alone.": "Agregado a cada hora, portanto as visualizações mais recentes podem ainda não aparecer. Não decida se uma URL continua em uso apenas por esta coluna.",
            "The country the viewer was in.": "O país em que o espectador estava.",
            "CDN logs are not real-time, so today and yesterday are still filling in. Downloads and on-screen views are counted together, and referring domains do not distinguish embedded pages from link clicks.": "Os logs da CDN não são em tempo real, portanto hoje e ontem ainda estão sendo preenchidos. Downloads e visualizações na tela são contados juntos, e os domínios de origem não distinguem páginas incorporadas de cliques em links.",
            "Please try again in a moment.": "Tente novamente em instantes.",
            "No views recorded yet": "Nenhuma visualização registrada ainda",
            "Views appear here once someone opens the asset through its public URL.": "As visualizações aparecem aqui quando alguém abre o ativo pela URL pública.",
            "'{{item}}' has been added.": "'{{item}}' foi adicionado.",
            "'{{name}}' AI analysis has begun.": "A análise de IA de '{{name}}' foi iniciada.",
            "'{{name}}' has been added.": "'{{name}}' foi adicionado.",
            "AI Caption task failed.": "A tarefa de legenda por IA falhou.",
            "Access has Expired": "O acesso expirou",
            "An error has occurred": "Ocorreu um erro",
            "An error occured while changing Custom Metadata {type}": "Ocorreu um erro ao alterar {type} de metadados personalizados",
            "An error occured while changing collection name": "Ocorreu um erro ao alterar o nome da coleção",
            "An error occured while changing collection {{type}}": "Ocorreu um erro ao alterar {{type}} da coleção",
            "An error occured while changing custom content {{type}}": "Ocorreu um erro ao alterar {{type}} do conteúdo personalizado",
            "An organizer can be selected.": "É possível selecionar um organizador.",
            "Assets must only be in DRM-free MP4 video type.": "Os ativos devem estar apenas no formato de vídeo MP4 sem DRM.",
            "Collection '{{name}}' has been created.": "A coleção '{{name}}' foi criada.",
            "Content schema '{{name}}' has been duplicated.": "O esquema de conteúdo '{{name}}' foi duplicado.",
            "Creating video URL.": "Criando a URL do vídeo.",
            "Creation of new Metadata Export {{item}} is completed.": "A criação da nova exportação de metadados {{item}} foi concluída.",
            "Detach {{name}}": "Desanexar {{name}}",
            "Download request failed": "A solicitação de download falhou",
            "Enter your name": "Insira seu nome",
            "Error adding collection '{{name}}'. {{line}} Please refresh the page and try again.": "Erro ao adicionar a coleção '{{name}}'. {{line}} Atualize a página e tente novamente.",
            "Expired date :": "Data de expiração :",
            "Face collection is not registered. Please contact to admin.": "A coleção de rostos não está registrada. Entre em contato com o administrador.",
            "Failed to configure AI analysis trigger.": "Falha ao configurar o gatilho de análise por IA.",
            "Failed to move.": "Falha ao mover.",
            "File is empty.": "O arquivo está vazio.",
            "Group '{{name}}' has been added.": "O grupo '{{name}}' foi adicionado.",
            "I agree to the above terms and conditions": "Concordo com os termos e condições acima",
            "If you apply a different category group, those items can be found under ‘<NotClassified>Categories Not Classified into Assets</NotClassified>’ in the category view.": "Se você aplicar um grupo de categorias diferente, esses itens poderão ser encontrados em ‘<NotClassified>Categorias não classificadas em Ativos</NotClassified>’ na visualização de categorias.",
            "If you delete <0>{{name}}</0>,  will also be removed from reference and you won't be able to revert this.<1/>Are you sure you want to delete?": "Se você excluir <0>{{name}}</0>, ele também será removido da referência e não será possível reverter.<1/>Tem certeza de que deseja excluir?",
            "If you delete <0>{{name}}</0>, you won't be able to revert this.<1/>Are you sure you want to delete?": "Se você excluir <0>{{name}}</0>, não será possível reverter.<1/>Tem certeza de que deseja excluir?",
            "If you have issues with Space approval, please contact Megazone Cloud. ": "Se tiver problemas com a aprovação do Espaço, entre em contato com a Megazone Cloud. ",
            "Korean can not contain numbers.": "O coreano não pode conter números.",
            "Please enter title": "Insira o título",
            "Please search by collection name": "Busque pelo nome da coleção",
            "Please uncheck the items you wish to leave and try to delete them.": "Desmarque os itens que deseja manter e tente excluí-los.",
            "Saving of changes to '{{tab}}' failed. - {{error}}": "Falha ao salvar as alterações em '{{tab}}'. - {{error}}",
            "Shortform creation has been requested.": "A criação do Shortform foi solicitada.",
            "Since this is a category group that is not used in {{name}}s, you can check the created {{name}} in 'categories not classified in {{name}}s'.": "Como este é um grupo de categorias que não é usado em {{name}}s, você pode verificar o {{name}} criado em 'categorias não classificadas em {{name}}s'.",
            "The Key field be up to {{tag}} characters long.": "O campo Chave pode ter até {{tag}} caracteres.",
            "The Lineup Name field be up to {{name}} characters long.": "O campo Nome do lineup pode ter até {{name}} caracteres.",
            "The Value field be up to {{tag}} characters long.": "O campo Valor pode ter até {{tag}} caracteres.",
            "The caption of the program can be edited in the caption of the <0> {{number}} </0> ": "A legenda do programa pode ser editada na legenda do <0> {{number}} </0> ",
            "The language of the captions to be applied to the video must not be duplicated.": "O idioma das legendas a serem aplicadas ao vídeo não pode ser duplicado.",
            "There is already a {{target}} with the same email. Please change it to a different email.": "Já existe um(a) {{target}} com o mesmo e-mail. Altere para um e-mail diferente.",
            "There is no Organizers to select.": "Não há organizadores para selecionar.",
            "There is no file to retry.": "Não há arquivos para tentar novamente.",
            "There was an error sharing asset {{item}}": "Ocorreu um erro ao compartilhar o ativo {{item}}",
            "This field can be at least {{minByte}} bytes.": "Este campo deve ter no mínimo {{minByte}} bytes.",
            "This field can be at least {{minLength}} characters.": "Este campo deve ter no mínimo {{minLength}} caracteres.",
            "This field must be in email address format.": "Este campo deve estar no formato de endereço de e-mail.",
            "This listings has updated information.<0/>Please refresh and try again. Do you want to refresh now?": "Esta listagem tem informações atualizadas.<0/>Atualize e tente novamente. Deseja atualizar agora?",
            "Try another search to find an vocabulary.": "Tente outra busca para encontrar um vocabulário.",
            "User invitation has been completed.": "O convite do usuário foi concluído.",
            "Video '{{name}}' has been requested.": "O vídeo '{{name}}' foi solicitado.",
            "Videos must only be in DRM-free MP4 video type among the sources.": "Entre as fontes, os vídeos devem estar apenas no formato de vídeo MP4 sem DRM.",
            "Words to display - Enter Korean, English, numbers, spaces, and special characters (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?) You can.": "Palavras a exibir - Você pode inserir coreano, inglês, números, espaços e caracteres especiais (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?).",
            "Words to display - You can enter English, numbers, spaces, and special characters (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?) there is.": "Palavras a exibir - Você pode inserir inglês, números, espaços e caracteres especiais (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?).",
            "You can create a URL for video sharing.": "Você pode criar uma URL para compartilhamento de vídeo.",
            "You can enter up to 30 whitelist rules.": "Você pode inserir até 30 regras de whitelist.",
            "You can see all your current assets. You can find the asset you are looking for using the search option.": "Você pode ver todos os seus ativos atuais. Use a opção de busca para encontrar o ativo que procura.",
            "You cannot upload files to this list.": "Não é possível enviar arquivos para esta lista.",
            "You must leave at least one entry in your vocabulary book.": "Você deve manter pelo menos uma entrada no seu vocabulário.",
            "You will receive an email letting you know that <0/>  the asset has been shared with you.": "Você receberá um e-mail informando que <0/>  o ativo foi compartilhado com você.",
            "Your folder name is too long including parent folders, you can shorten the folder name and try again.": "O nome da sua pasta é muito longo incluindo as pastas superiores. Encurte o nome da pasta e tente novamente.",
            "{{resourceName}} '{{name}}' has been updated.": "{{resourceName}} '{{name}}' foi atualizado.",
            "{{schemaName}} '{{name}}' has been created.": "{{schemaName}} '{{name}}' foi criado.",
            "No labels": "Nenhum rótulo",
            "This user does not exist.": "Este usuário não existe.",
            "No Sharer.": "Nenhum compartilhador.",
            "No Users.": "Nenhum usuário.",
            "No Groups.": "Nenhum grupo.",
            "Please manage your assets by adding the new folder.": "Adicione uma nova pasta para gerenciar seus ativos.",
            "The video list is missing.": "A lista de vídeos não existe.",
            "Delete completely from Music": "Excluir permanentemente de Música",
            "You have selected <0>{{count}}</0> other than <1>{{name}}</1>": "Você selecionou <0>{{count}}</0> além de <1>{{name}}</1>",
            "Remove from category <0>{{name}}</0> only": "Remover apenas da categoria <0>{{name}}</0>",
            "You won’t be able to revert this.": "Não será possível reverter.",
            "If you delete <0>{{name}}</0>, it will also be removed from <0>Reference</0> and you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "Se você excluir <0>{{name}}</0>, ele também será removido de <0>Referência</0> e não será possível reverter.<1/>Tem certeza de que deseja excluir <0>{{name}}</0>?",
            "If you delete <0>{{count}}</0> other than <0>{{name}}</0>, it will also be removed from <0>Reference</0> and you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "Se você excluir <0>{{count}}</0> além de <0>{{name}}</0>, também será removido de <0>Referência</0> e não será possível reverter.<1/>Tem certeza de que deseja excluir <0>{{name}}</0>?",
            "{{verb}} <0>{{count}}</0> files from <1>{{path}}</1> to <2>{{to}}</2>": "{{verb}} <0>{{count}}</0> arquivos de <1>{{path}}</1> para <2>{{to}}</2>",
            "An item with the name <0>{{name}}</0> is already in this location.<1/>Do you want to overwrite it with the target file?": "Um item com o nome <0>{{name}}</0> já existe neste local.<1/>Deseja sobrescrevê-lo com o arquivo de destino?",
            "Delete completely from Photo": "Excluir permanentemente de Foto",
            "Upload Failed.": "Falha no upload.",
            "Upload failed.": "Falha no upload.",
            "<0>{{date}} (24 hours) </0> schedule is complete, or there is not enough<br />blank time than video duration.<br />If you want to add a schedule, please manual schedule it.": "A programação de <0>{{date}} (24 horas) </0> está completa ou não há tempo livre suficiente<br />em relação à duração do vídeo.<br />Se quiser adicionar uma programação, faça-a manualmente.",
            "{{count}} fields auto-filled": "{{count}} campos preenchidos automaticamente",
            "The current workflow can be saved as a draft, but some connection structures are invalid, which may cause issues when running.": "O fluxo de trabalho atual pode ser salvo como rascunho, mas algumas estruturas de conexão são inválidas, o que pode causar problemas ao executar.",
            "You can save the current workflow, but saving your changes will cancel <0>{{queuedCount}} queued executions</0>.": "Você pode salvar o fluxo de trabalho atual, mas salvar suas alterações cancelará <0>{{queuedCount}} execuções em fila</0>.",
            "The current workflow has items that need to be resolved and cannot be saved. Please fix the items below and save again.": "O fluxo de trabalho atual possui itens que precisam ser resolvidos e não pode ser salvo.\nCorrija os itens abaixo e salve novamente.",
            "Add at least one task.": "Adicione pelo menos uma tarefa.",
            "User list export has been requested.": "A exportação da lista de usuários foi solicitada.",
            "Failed to export the user list.": "Falha ao exportar a lista de usuários.",
            "This setting may take some time to take effect after being changed, and the status cannot be changed again while it is being applied.": "Esta configuração pode levar algum tempo para entrar em vigor após ser alterada, e o status não pode ser alterado novamente enquanto estiver sendo aplicado.",
            "This setting is currently being applied. You can change it again after it takes effect.": "Esta configuração está sendo aplicada no momento. Você poderá alterá-la novamente após ela entrar em vigor.",
            "Please select {{type}}.": "Selecione {{type}}.",
            "Please select a step.": "Selecione uma etapa.",
            "Select a step node.": "Selecione um nó de etapa.",
            "No available step": "Nenhuma etapa disponível",
            "Up to 5 parallel steps.": "Até 5 etapas paralelas.",
            "Drag anywhere to move the canvas.": "Arraste em qualquer lugar para mover o canvas.",
            "The step tree for workflow \"{{name}}\" has been updated.": "A árvore de etapas do workflow \"{{name}}\" foi atualizada.",
            "Input conditions are not satisfied by upstream steps.": "As condições de entrada não são satisfeitas pelas etapas anteriores.",
            "This may take some time to apply, depending on the amount of data.": "Isso pode levar algum tempo para ser aplicado, dependendo da quantidade de dados.",
            "You have no permission to view this page.": "Você não tem permissão para visualizar esta página.",
            "Attribution cannot be empty.<0/>Please enter a valid attribution.": "\"Atribuição\" não pode estar vazia.<0/>Por favor, insira uma atribuição válida.",
            "\"Tags\" can be up to 30.": "\"Tags\" podem ser no máximo 30.",
            "\"Tags\" can be up to {{count}}.": "\"Tags\" podem ser no máximo {{count}}.",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n \n ㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n \n ㆍseparar por novas linhas",
            "Add file by drag and drop or double-clicking in the select sources.": "Adicione arquivos arrastando e soltando ou dando duplo clique nas fontes selecionadas.",
            "A maximum of 2 streams can be selected.": "É possível selecionar no máximo 2 streams.",
            "A one schedules can be selected.": "É possível selecionar um agendamento.",
            "Access denied.": "Acesso negado.",
            "An error occured while trying to analyze the asset": "Ocorreu um erro ao tentar analisar o ativo",
            "An attempt to 'Archive' failed. Please try again.": "Tentativa de 'Arquivar' falhou. Por favor, tente novamente.",
            "An attempts to change the status from 'Active' to 'Inactive' failed. Please try again.": "Tentativa de alterar o status de 'Ativo' para 'Inativo' falhou. Por favor, tente novamente.",
            "Analyzed automatically labels objects, concepts and scenes in video.": "Analisa automaticamente e rotula objetos, conceitos e cenas em vídeo.",
            "And {{count}} Other - Total {{total}}": "E {{count}} outro(s) - Total {{total}}",
            "Approve the channel after creation": "Aprovar o canal após a criação",
            "Are you sure ? You won't be able to revert this!": "Tem certeza? Você não poderá reverter isso!",
            "Are you sure you delete the selected lineups?": "Tem certeza de que deseja excluir os lineups selecionados?",
            "Are you sure you want to approve the selected?": "Tem certeza de que deseja aprovar o(s) selecionado(s)?",
            "Are you sure you want to cancel the request the selected?": "Tem certeza de que deseja cancelar a solicitação do(s) selecionado(s)?",
            "Are you sure you want to cancel the return the selected?": "Tem certeza de que deseja cancelar a devolução do(s) selecionado(s)?",
            "Are you sure you want to delete": "Tem certeza de que deseja excluir",
            "Are you sure you want to delete <0>{{name}} ({{id}})</0>?": "Tem certeza de que deseja excluir <0>{{name}} ({{id}})</0>?",
            "Are you sure you want to delete <0>{{name}}</0>?": "Tem certeza de que deseja excluir <0>{{name}}</0>?",
            "Are you sure you want to reclaim the selected?": "Tem certeza de que deseja recuperar o(s) selecionado(s)?",
            "Are you sure you want to reject the request?": "Tem certeza de que deseja rejeitar a solicitação?",
            "Are you sure you want to request the selected?": "Tem certeza de que deseja solicitar o(s) selecionado(s)?",
            "Are you sure you want to return the selected?": "Tem certeza de que deseja devolver o(s) selecionado(s)?",
            "Automatically detects explicit adult content in video.": "Detecta automaticamente conteúdo adulto explícito em vídeo.",
            "Automatically recognizes celebrities in video.": "Reconhece automaticamente celebridades em vídeo.",
            "Base video file can be set only for english without special characters and spaces.": "O arquivo de vídeo base pode ser definido apenas em inglês, sem caracteres especiais e espaços.",
            "Base video file to be used for the channel can be set only for English without special characters and spaces. (Allowed special characters: ~! () _-.)": "O arquivo de vídeo base a ser usado para o canal pode ser definido apenas em inglês, sem caracteres especiais e espaços. (Caracteres especiais permitidos: ~! () _-.)",
            "Bucket name must be between 3 and 63 letters and start with alphabet or number with allowed special characters of -, _, and .)": "O nome do Bucket deve ter entre 3 e 63 caracteres e começar com uma letra ou número, com os caracteres especiais permitidos: -, _ e .)",
            "Cannot apply because no schema is set": "Não é possível aplicar porque nenhum esquema está definido",
            "Cannot apply because the schema is different": "Não é possível aplicar porque o esquema é diferente",
            "Cannot create a job": "Não é possível criar uma tarefa",
            "CloudPlex Media subtitle editor works with the platform to provide flexible workflows from subtitle registration to publishing.<0/>Quickly create subtitles with user experience-based UI.": "O editor de legendas CloudPlex Media trabalha com a plataforma para oferecer workflows flexíveis, desde o registro até a publicação de legendas.<0/>Crie legendas rapidamente com uma UI baseada na experiência do usuário.",
            "Deleted output assets will be kept for the specified days": "Os ativos de saída excluídos serão mantidos pelos dias especificados",
            "Do not have an account yet?": "Ainda não tem uma conta?",
            "Do you really want to change?": "Tem certeza de que deseja alterar?",
            "Do you really want to delete it?": "Tem certeza de que deseja excluir?",
            "Drag and drop a file here": "Arraste e solte um arquivo aqui",
            "Drag your files to upload": "Arraste seus arquivos para fazer Upload",
            "Duplicate key. The key must be unique.": "Chave duplicada. A chave deve ser única.",
            "Duplicate values. This field must be unique.": "Valores duplicados. Este campo deve ser único.",
            "Every month on the": "Todo mês no dia",
            "Every month on the {{interval}} days": "Todo mês nos dias {{interval}}",
            "Every months on": "Todos os meses em",
            "Every weeks on": "Todas as semanas em",
            "Failed to get file information from the url.": "Falha ao obter informações do arquivo a partir da URL.",
            "Reindexing has been requested.": "A reindexação foi solicitada.",
            "AI search indexing failed.": "A indexação da busca por IA falhou.",
            "AI search indexing is not supported for this asset.": "Este ativo não oferece suporte à indexação da busca por IA.",
            "This is an unsupported media type.": "Este é um tipo de mídia não suportado.",
            "This is an unsupported source format.": "Este é um formato de fonte não suportado.",
            "This image is smaller than the minimum size (128x128 pixels).": "Esta imagem é menor que o tamanho mínimo (128x128 pixels).",
            "This image exceeds the maximum file size (5 MiB).": "Esta imagem excede o tamanho máximo de arquivo (5 MiB).",
            "This video exceeds the maximum file size (6 GB).": "Este vídeo excede o tamanho máximo de arquivo (6 GB).",
            "This video exceeds the maximum duration (4 hours).": "Este vídeo excede a duração máxima (4 horas).",
            "Failed to prepare indexing.": "Falha ao preparar a indexação.",
            "Failed to extract metadata.": "Falha ao extrair os metadados.",
            "Failed to create the source.": "Falha ao criar a fonte.",
            "Failed to check source support.": "Falha ao verificar o suporte da fonte.",
            "Failed to analyze the source.": "Falha ao analisar a fonte.",
            "Failed to analyze metadata.": "Falha ao analisar os metadados.",
            "Failed to create the search index.": "Falha ao criar o índice de busca.",
            "An internal error occurred.": "Ocorreu um erro interno.",
            "AI search indexing is in progress.": "A indexação da busca por IA está em andamento.",
            "This analysis failed.": "Esta análise falhou.",
            "This analysis is outside the supported range.": "Esta análise está fora do escopo suportado.",
            "This analysis was only partially indexed.": "Esta análise foi apenas parcialmente indexada.",
            "Only part of the source was analyzed.": "Apenas parte da fonte foi analisada.",
            "Only some index entries were created.": "Apenas alguns itens de índice foram criados.",
            "Some parts were not indexed, so this asset may not appear in all AI search results.": "Algumas partes não foram indexadas, portanto este ativo pode não aparecer em todos os resultados da busca com IA.",
            "Click the button on the badge to retry.": "Clique no botão do selo para tentar novamente.",
            "You can find this asset in AI search.": "Você pode encontrar este ativo na busca por IA.",
            "Assets that have not finished indexing may not appear in AI search results.": "Ativos que não concluíram a indexação podem não aparecer nos resultados da busca com IA.",
            "No results for \"{{keyword}}\".": "Nenhum resultado para \"{{keyword}}\".",
            "Depending on indexing status, some assets may not appear in AI search results.": "Dependendo do status de indexação, alguns ativos podem não aparecer nos resultados da busca.",
            "The index is already up to date.": "O índice já está atualizado.",
            "Failed to request reindexing.": "Falha ao solicitar a reindexação.",
            "Granted roles will be deleted.": "As funções concedidas serão excluídas.",
            "Has scheduled lineups.": "Possui lineups agendados.",
            "Hi, {{name}}": "Olá, {{name}}",
            "http(s)://~ or s3://~": "http(s)://~ ou s3://~",
            "Hyper Browser is an enterprise cloud storage client.<0/>Accelerate a variety of workloads with a multi-CDN integration environment and powerful features such as multi-part upload/download, purge and pre-patch.": "Hyper Browser é um cliente de armazenamento em nuvem empresarial.<0/>Acelere uma variedade de cargas de trabalho com um ambiente de integração multi-CDN e recursos poderosos como upload/download multipart, purge e pré-patch.",
            "If \\\"program duration\\\" is more than \\\"24 hours\\\", you can not repeat the schedule.": "Se a \\\"duração do programa\\\" for superior a \\\"24 horas\\\", você não pode repetir o agendamento.",
            "If it is not the scheduled time, it automatically changes the state of the channel to 'Idle'.": "Se não for o horário agendado, o estado do canal é alterado automaticamente para 'Ocioso'.",
            "If the value is the same, next event has the highest priority": "Se o valor for o mesmo, o próximo evento tem a maior prioridade",
            "If you are not a member yet, please sign up and use.": "Se ainda não for membro, por favor cadastre-se e use.",
            "If you delete <0>{{name}}</0>, it will also be removed from Related the videos.": "Se você excluir <0>{{name}}</0>, ele também será removido dos Vídeos Relacionados.",
            "If you delete <0>{{deleteLineupTargetName}}</0>, only future events including this one will be deleted.": "Se você excluir <0>{{deleteLineupTargetName}}</0>, somente os eventos futuros, incluindo este, serão excluídos.",
            "If you delete <0>{{name}}</0>, only future events including this one will be deleted.<1/>Are you sure you want to delete <0>{{name}}</0>?": "Se você excluir <0>{{name}}</0>, somente os eventos futuros, incluindo este, serão excluídos.<1/>Tem certeza de que deseja excluir <0>{{name}}</0>?",
            "If you delete <0>{{name}}</0>, the scheduled lineups will be deleted together.<1/>Are you sure you want to delete <0>{{name}}</0>?": "Se você excluir <0>{{name}}</0>, os lineups agendados também serão excluídos.<1/>Tem certeza de que deseja excluir <0>{{name}}</0>?",
            "If you delete a lineup that is set to repeat, all future schedule will be deleted.": "Se você excluir um lineup definido para repetição, todos os agendamentos futuros serão excluídos.",
            "If you have a problem with your account, or would like to use the cloud <0/>Platform, please contact our sales team. We'll assist you with more details.": "Se você tiver algum problema com sua conta ou quiser usar a <0/>Plataforma em nuvem, entre em contato com nossa equipe de vendas. Teremos prazer em ajudá-lo com mais detalhes.",
            "If you have any problem using the stage,<0/> please contact Megazone.": "Se você tiver algum problema ao usar o stage,<0/> entre em contato com a Megazone.",
            "If you have any problem using this space,<0/> please contact Megazone Cloud.": "Se você tiver algum problema ao usar este espaço,<0/> entre em contato com a Megazone Cloud.",
            "If you want to access this page, please contact your administrator.": "Se você deseja acessar esta página, entre em contato com o administrador.",
            "Indexing faces and get a complete analysis of facial attributes, <0/>including confidence scores.": "Indexa rostos e obtém uma análise completa dos atributos faciais, <0/>incluindo pontuações de confiança.",
            "Ingest path setting for pipeline is required. Please contact your manager.": "A configuração do caminho de ingestão para o pipeline é necessária. Entre em contato com seu gerente.",
            "Input assets will be automatically deleted after specified days": "Os ativos de entrada serão automaticamente excluídos após os dias especificados",
            "Input name is required.": "O nome de entrada é obrigatório.",
            "Internal server error": "Erro interno do servidor",
            "Invalid CIDR. It must be in pattern of xxx.xxx.xxx.xxx/zz.": "CIDR inválido. Deve estar no padrão xxx.xxx.xxx.xxx/zz.",
            "Invalid upload path": "Caminho de Upload inválido",
            "Multiple image files can be selected.": "Múltiplos arquivos de imagem podem ser selecionados.",
            "No {{name}} is set.<0/>Please set the {{name}} and try again.": "Nenhum {{name}} está configurado.<0/>Por favor, configure o {{name}} e tente novamente.",
            "No {{name}} searched.": "Nenhum {{name}} encontrado.",
            "No members is granted": "Nenhum membro foi concedido",
            "No aduits is granted.": "Nenhum auditor foi concedido.",
            "No role is granted": "Nenhuma função foi concedida",
            "One stream can be selected.": "Um stream pode ser selecionado.",
            "Page not found": "Página não encontrada",
            "This page is not supported on mobile.": "Esta página não é suportada em dispositivos móveis.",
            "Please use the button below to go back to the previous page.": "Por favor, use o botão abaixo para voltar à página anterior.",
            "Path was not created. Please set again.": "O caminho não foi criado. Por favor, configure novamente.",
            "Pending to upload...": "Aguardando Upload...",
            "Please add a caption to use.": "Por favor, adicione uma legenda para usar.",
            "Please add a custom field to use.": "Por favor, adicione um campo personalizado para usar.",
            "Please add a poster assets to use.": "Por favor, adicione um ativo de pôster para usar.",
            "Please add images to use.": "Por favor, adicione imagens para usar.",
            "Please add people images.": "Por favor, adicione imagens de pessoas.",
            "Please check and try again": "Por favor, verifique e tente novamente",
            "Please check the support format and try again.": "Por favor, verifique o formato suportado e tente novamente.",
            "Please check valid single IP, IP range or CIDR.": "Por favor, verifique se é um IP único, intervalo de IP ou CIDR válido.",
            "Please contact your stage administrator to access the project.": "Entre em contato com o administrador do stage para acessar o projeto.",
            "Please go back to the main with the button below.": "Por favor, volte para a página principal usando o botão abaixo.",
            "Please select a file to add": "Por favor, selecione um arquivo para adicionar",
            "Please select a file to add.": "Por favor, selecione um arquivo para adicionar.",
            "Please select a valid file.": "Por favor, selecione um arquivo válido.",
            "Please select the project of the stage you want to access.": "Por favor, selecione o projeto do stage ao qual deseja acessar.",
            "Please try again.": "Por favor, tente novamente.",
            "Prefix cannot be empty": "O prefixo não pode estar vazio",
            "Prefix must begin with s3://": "O prefixo deve começar com s3://",
            "Remove connected medialive input.": "Excluir a entrada medialive conectada.",
            "Request a channel approval after creation": "Solicitar aprovação do canal após a criação",
            "Save the origin source as an asset": "Salvar a fonte de origem como um ativo",
            "Schedule repeat can not be modified after setting. (Repeated lineups can only be deleted)": "A repetição do agendamento não pode ser modificada após a configuração. (Lineups repetidos só podem ser excluídos)",
            "Search for faces in the video using saved face information.": "Buscar rostos no vídeo usando informações de rostos salvas.",
            "Select a metadata": "Selecionar um metadado",
            "Select AI analysis item": "Selecionar item de análise de IA",
            "Select an face to analyze <0/>From the list of registered images on the left.": "Selecione um rosto para analisar <0/>na lista de imagens registradas à esquerda.",
            "Select an face to index <0/>From the list of registered images on the left.": "Selecione um rosto para indexar <0/>na lista de imagens registradas à esquerda.",
            "Select files from the image type of assets.": "Selecione arquivos do tipo imagem dos ativos.",
            "Select one caption file.": "Selecione um arquivo de legenda.",
            "Source must be selected in order to request a channel approval.": "A fonte deve ser selecionada para solicitar a aprovação do canal.",
            "Source selection is done after channel creation": "A seleção da fonte é feita após a criação do canal",
            "Special chacters are not allowed": "Caracteres especiais não são permitidos",
            "Special chacters can not be entered.": "Caracteres especiais não podem ser inseridos.",
            "The \\\"End time\\\" must be later than \\\"Start time\\\"": "O \\\"Horário de término\\\" deve ser posterior ao \\\"Horário de início\\\"",
            "The \\\"Loop To Fill Lineup Duration\\\" setting applies only when the duration of the video is more than \\\"1 minute\\\".": "A configuração \\\"Loop para preencher duração do lineup\\\" se aplica somente quando a duração do vídeo for superior a \\\"1 minuto\\\".",
            "The asset list is missing.": "A lista de ativos está ausente.",
            "The asset is only MP4 type video.": "O ativo é somente vídeo do tipo MP4.",
            "The base video is applied only when the source type is schedules": "O vídeo base é aplicado somente quando o tipo de fonte são agendamentos",
            "The begin date time can not be past time.": "A data e hora de início não podem ser no passado.",
            "The begin date time must be registered after 2 minutes on the current time basis.": "A data e hora de início devem ser registradas pelo menos 2 minutos após a hora atual.",
            "The changed roles will be applied to users below.": "As funções alteradas serão aplicadas aos usuários abaixo.",
            "The comment field can be up to {{byte}} byte long.": "O campo de comentário pode ter até {{byte}} bytes.",
            "The description can be up to {{byte}} byte": "A descrição pode ter até {{byte}} bytes",
            "The description field can be up to {{limit}} byte long.": "O campo de descrição pode ter até {{limit}} bytes.",
            "The file is not valid.": "O arquivo não é válido.",
            "The file source list is missing.": "A lista de fontes de arquivo está ausente.",
            "The lineup Name field be up to {{name}} byte long.": "O campo Nome do lineup pode ter até {{name}} bytes.",
            "The lineup priority field is greater than 0 and less than 100.": "O campo de prioridade do lineup deve ser maior que 0 e menor que 100.",
            "The name field be up to {{title}} byte long.": "O campo de nome pode ter até {{title}} bytes.",
            "The name field can be up to {{limit}} byte long.": "O campo de nome pode ter até {{limit}} bytes.",
            "The name field is required": "O campo de nome é obrigatório",
            "The page you requested could not be found.": "A página solicitada não pôde ser encontrada.",
            "The same file could not be found": "O mesmo arquivo não pôde ser encontrado",
            "The selected Whitelist rules can be modified.": "As regras de Whitelist selecionadas podem ser modificadas.",
            "The team has no members.": "A equipe não tem membros.",
            "The value field be up to {{tag}} byte long.": "O campo de valor pode ter até {{tag}} bytes.",
            "There is an event in the listing or a linked channel, so you can not delete that stream": "Há um evento na listagem ou um canal vinculado, portanto não é possível excluir esse stream",
            "There is no analyzable item. Only non-DRM MP4 types are supported for analysis.": "Não há item analisável. Apenas tipos MP4 sem DRM são suportados para análise.",
            "There is no input to select.": "Não há entrada para selecionar.",
            "There is no schedules to select.": "Não há agendamentos para selecionar.",
            "There is no project available to access.": "Não há projeto disponível para acessar.",
            "There is work in progress. Would you really go out?": "Há trabalho em andamento. Deseja realmente sair?",
            "{{count}} upload(s) transferring — do not close or reload this page": "{{count}} envio(s) em transferência — não feche nem recarregue esta página",
            "Processing continues on the server.": "O processamento continua no servidor.",
            "Moving between menus or closing this panel is fine.": "Navegar entre menus ou fechar este painel não causa problemas.",
            "{{count}} upload(s) transferred — you can close this page": "{{count}} envio(s) transferido(s) — já pode fechar esta página",
            "Uploading. Do not close or refresh this page.": "Envio em andamento. Não feche nem atualize esta página.",
            "There is work in progress. Would you really leave the page?": "Há trabalho em andamento. Deseja realmente sair da página?",
            "There was either CORS or network error.": "Ocorreu um erro de CORS ou de rede.",
            "This field can be up to {{maxByte}} bytes.": "Este campo pode ter até {{maxByte}} bytes.",
            "This field must pass today's datetime.": "Este campo deve ser posterior à data e hora de hoje.",
            "This file format is not supported.": "Este formato de arquivo não é suportado.",
            "This is not a valid URL pattern.": "Este não é um padrão de URL válido.",
            "This schedules has updated information.<0/>Please refresh and try again. Do you want to refresh now?": "Este agendamento tem informações atualizadas.<0/>Por favor, atualize e tente novamente. Deseja atualizar agora?",
            "This stage is not accessible.": "Este stage não está acessível.",
            "This space is not accessible.": "Este espaço não está acessível.",
            "This whitelist field is required.": "Este campo de whitelist é obrigatório.",
            "To request a channel approval, you must select a source.": "Para solicitar a aprovação do canal, você deve selecionar uma fonte.",
            "View only <0>requested channels</0>": "Visualizar apenas <0>canais solicitados</0>",
            "We're sorry!": "Sentimos muito!",
            "You can enter up to {{count}} whitelist rules": "Você pode inserir até {{count}} regras de whitelist",
            "You can only enter {{count}} whitelist rules": "Você só pode inserir {{count}} regras de whitelist",
            "You can upload files up to 500KB in size.": "Você pode fazer Upload de arquivos de até 500KB.",
            "You can watch preview for 1 minute": "Você pode assistir à pré-visualização por 1 minuto",
            "You do not have permission to access.": "Você não tem permissão para acessar.",
            "You don't have any {{name}} to select.": "Você não tem nenhum {{name}} para selecionar.",
            "You don't have permission to view this page.": "Você não tem permissão para visualizar esta página.",
            "You need to sign in a Megazone Accounts account to get started.": "Você precisa fazer Login com uma conta Megazone Accounts para começar.",
            "Inactivated by error": "Inativado por erro",
            "Error while inactivating": "Erro ao inativar",
            "Error while activating": "Erro ao ativar",
            "An attempt to 'Archive' failed.": "Tentativa de 'Arquivar' falhou.",
            "An attempt to 'Restore' failed. Please try again.": "Tentativa de 'Restaurar' falhou. Por favor, tente novamente.",
            "Please select a project you want to access.": "Por favor, selecione um projeto ao qual deseja acessar.",
            "You have no site access.": "Você não tem acesso ao site.",
            "There is already a folder with the same name. Please change it to a different name.": "Já existe uma pasta com o mesmo nome. Por favor, altere para um nome diferente.",
            "{{target}} names can’t contain “/”.": "Nomes de {{target}} não podem conter \"/\".",
            "There is already a {{target}} with the same name. Please change it to a different name.": "Já existe um {{target}} com o mesmo nome. Por favor, altere para um nome diferente.",
            "deleteModalReferenceNesting1": "$t(common::msg::deleteModalReferenceKey1)<1/>$t(common::msg::deleteModalReferenceKey3)",
            "deleteModalReferenceNesting2": "$t(common::msg::deleteModalReferenceKey2)<1/>$t(common::msg::deleteModalReferenceKey3)",
            "deleteModalReferenceKey1": "Se você excluir <0>{{name}}</0>, ele também será removido de Referência e você não poderá reverter isso{{dot}}",
            "deleteModalReferenceKey2": "Se você excluir <0>{{name}}</0>, você não poderá reverter isso{{dot}}",
            "deleteModalReferenceKey3": "Tem certeza de que deseja excluir <0>{{name}}</0>?",
            "Don’t ask again": "Não perguntar novamente",
            "Deleting {{currentIndex}} of {{deleteItemLength}}": "Excluindo {{currentIndex}} de {{deleteItemLength}}",
            "You have selected <0>{{name}}</0>": "Você selecionou <0>{{name}}</0>",
            "Remove from category <0>{{name}}</0>": "Excluir da categoria <0>{{name}}</0>",
            "Delete completely from Assets": "Excluir completamente dos Ativos",
            "It will also be removed from Reference and you won’t be able to revert this.": "Ele também será removido de Referência e você não poderá reverter isso.",
            "If you archive the asset, you will be charged <0>the 90-day</0> archive amount immediately.": "Se você arquivar o ativo, você será cobrado imediatamente pelo valor de arquivamento de <0>90 dias</0>.",
            "Are you sure you want to archive?": "Tem certeza de que deseja arquivar?",
            "If you restore the Archived Asset, You will be charged for the <0>remaining {{remainingDays}} days.</0>": "Se você restaurar o Ativo Arquivado, você será cobrado pelos <0>{{remainingDays}} dias restantes.</0>",
            "Are you sure you want to restore?": "Tem certeza de que deseja restaurar?",
            "Of the <0>{{currentDate}}</0> schedule, <0>only {{lineupCount}}</0> excluding the repeat lineup will be a all Copy to. Lineups with repeat lineups are excluded from the all copy to.": "Do agendamento de <0>{{currentDate}}</0>, <0>somente {{lineupCount}}</0> excluindo o lineup repetido será copiado para todos. Lineups com lineups repetidos são excluídos da cópia total.",
            "Are you sure you all copy to?": "Tem certeza de que deseja copiar tudo?",
            "There is a schedule on that date and it cannot be selected.<0/>Please delete the schedule for the selected date or select a different date.": "Há um agendamento nessa data e ele não pode ser selecionado.<0/>Por favor, exclua o agendamento da data selecionada ou escolha uma data diferente.",
            "The <0> {{lineupCount}} lineups </0> included in the <0>{{currentDate}}</0> schedule will be all Copy to. <1/>However, the repeat lineups of the selected lineup will stop repeating this and future schedules.": "Os <0>{{lineupCount}} lineups</0> incluídos no agendamento de <0>{{currentDate}}</0> serão todos copiados. <1/>No entanto, os lineups repetidos do lineup selecionado pararão de repetir neste e nos agendamentos futuros.",
            "<0>{{x}}</0> day(s) remaining": "<0>{{x}}</0> dia(s) restante(s)",
            "Past broadcast lineup cannot be deleted.": "Lineups de transmissão passada não podem ser excluídos.",
            "Lineup currently being broadcast cannot be delete.": "O lineup atualmente em transmissão não pode ser excluído.",
            "Schedules within 1 minute from the current time cannot be deleted.": "Agendamentos dentro de 1 minuto do horário atual não podem ser excluídos.",
            "If you want All Copy to, lineups with the repeat schedule will stop repeating this and future schedules.": "Se você quiser copiar tudo, os lineups com agendamento repetido pararão de repetir neste e nos agendamentos futuros.",
            "If you want to delete lineups with repeat schedule, you cannot delete the past lineup that was broadcast, but you can delete future Lineups including this one will be deleted.": "Se você quiser excluir lineups com agendamento repetido, não é possível excluir lineups passados que foram transmitidos, mas você pode excluir os Lineups futuros, incluindo este.",
            "Set up a YouTube account to publish.": "Configure uma conta do YouTube para publicar.",
            "To add the channels of the account you want to publish, sign in to Youtube with that account.": "Para adicionar os canais da conta que deseja publicar, faça Login no Youtube com essa conta.",
            "Duplicate login status.": "Status de Login duplicado.",
            "You are currently logged in from another web browser with your information, the connection is terminated and you are directed to the welcome page.": "Você está atualmente conectado a partir de outro navegador web com suas informações, a conexão foi encerrada e você será direcionado para a página de boas-vindas.",
            "Your account has been expired.": "Sua conta expirou.",
            "Your account has been inactivated.": "Sua conta foi inativada.",
            "Your account has been deleted.": "Sua conta foi excluída.",
            "You cannot access the project.<0/>The connection is terminated and you are directed to the welcome page.": "Você não pode acessar o projeto.<0/>A conexão foi encerrada e você será direcionado para a página de boas-vindas.",
            "After starting the channel, you can watch past broadcasts by changing the playback position for up to 14 days.": "Após iniciar o canal, você pode assistir às transmissões passadas alterando a posição de reprodução por até 14 dias.",
            "Find objects by prefix": "Buscar objetos por prefixo",
            "A total of <0>{{type}}</0> participants can be invited per account, and participants must be divided into the schedule of the channels to be created.": "Um total de <0>{{type}}</0> participantes podem ser convidados por conta, e os participantes devem ser divididos no agendamento dos canais a serem criados.",
            "Megazone Accounts members, please sign in through the button below.": "Membros do Megazone Accounts, por favor faça Login pelo botão abaixo.",
            "Megazone Login users, please sign in through the button below.": "Usuários do Megazone Login, por favor faça Login pelo botão abaixo.",
            "If you do not have an account yet, please sign up through": "Se ainda não tiver uma conta, por favor cadastre-se através de.",
            "If you don’t have an account yet, please ask your Organization Administrator.": "Se ainda não tiver uma conta, por favor solicite ao Administrador da Organização.",
            "Go to log in with": "Ir para fazer Login com",
            "You need to sign in a {{Megazone Accounts}} {{or}} {{Megazone Login}} account to get started.": "Você precisa fazer Login com uma conta {{Megazone Accounts}} {{or}} {{Megazone Login}} para começar.",
            "You do not have permission to Show Hidden Metadata.": "Você não tem permissão para visualizar Metadados Ocultos.",
            "If you to Show Hidden Metadata, please ask your administration.": "Se você quiser visualizar Metadados Ocultos, por favor solicite ao administrador.",
            "Select a one file from the audio type of assets.": "Selecione um arquivo do tipo áudio dos ativos.",
            "Select a one file from the image type of assets.": "Selecione um arquivo do tipo imagem dos ativos.",
            "The key field be up to {{tag}} byte long.": "O campo de chave pode ter até {{tag}} bytes.",
            "Please add a {{name}} assets to use.": "Por favor, adicione ativos de {{name}} para usar.",
            "You can't access the space.": "Você não pode acessar o espaço.",
            "The space is inaccessible because your account has expired or has been deleted.": "O espaço está inacessível porque sua conta expirou ou foi excluída.",
            "Please contact your space manager.": "Entre em contato com o gerente do espaço.",
            "If you have issues with Space approval, please contact Megazone Cloud.": "Se você tiver problemas com a aprovação do Espaço, entre em contato com a Megazone Cloud.",
            "If you want to site access, please contact your space manager.": "Se você quiser acesso ao site, entre em contato com o gerente do espaço.",
            "You need access": "Você precisa de acesso",
            "If you want to check the assets you have selected, <0/> please ask for access.": "Se você quiser verificar os ativos selecionados, <0/> solicite acesso.",
            "Request sent": "Solicitação enviada",
            "You will receive an email letting you know that <0/> the asset has been shared with you.": "Você receberá um e-mail informando que <0/> o ativo foi compartilhado com você.",
            "Enter Display Name or Username": "Insira o Nome de Exibição ou Nome de Usuário",
            "This asset has been deleted.": "Este ativo foi excluído.",
            "The deleted asset is removed from the Requested to Share.": "O ativo excluído é removido de Solicitado para Compartilhamento.",
            "If necessary, contact the administrator.": "Se necessário, entre em contato com o administrador.",
            "Are you sure you want to reject sharing request for <0>{{name}}</0>?": "Tem certeza de que deseja rejeitar a solicitação de compartilhamento de <0>{{name}}</0>?",
            "Reason for rejection of sharing request (optional)": "Motivo da rejeição da solicitação de compartilhamento (opcional)",
            "There is no analytics data.": "Não há dados analíticos.",
            "Detailed view of <0> {{number}} </0> tasks": "Visualização detalhada de <0> {{number}} </0> tarefas",
            "files to the <0>{{name}}</0>": "arquivos para o <0>{{name}}</0>",
            "An item with the name '<0>{{name}}</0>' is already in this location.": "Um item com o nome '<0>{{name}}</0>' já existe neste local.",
            "Do you want to overwrite it with the target file?": "Deseja substituí-lo pelo arquivo de destino?",
            "Renaming in <0>{{name}}</0>": "Renomeando em <0>{{name}}</0>",
            "Moving <0>{{totalCount}}</0> files from the <0>{{sourceFolderName}}</0> to the <0>{{distFolderName}}</0>": "Movendo <0>{{totalCount}}</0> arquivos de <0>{{sourceFolderName}}</0> para <0>{{distFolderName}}</0>",
            "Copying <0>{{totalCount}}</0> files from the <0>{{sourceFolderName}}</0> to the <0>{{distFolderName}}</0>": "Copiando <0>{{totalCount}}</0> arquivos de <0>{{sourceFolderName}}</0> para <0>{{distFolderName}}</0>",
            "All linked video source assets have been deleted, <0/> so the video preview cannot be seen.": "Todos os ativos de origem de vídeo vinculados foram excluídos, <0/> portanto a pré-visualização do vídeo não pode ser exibida.",
            "There are no items for video AI analysis.": "Não há itens para análise de IA de vídeo.",
            "Please add music file.": "Por favor, adicione um arquivo de música.",
            "Select files from the Audio type of assets.": "Selecione arquivos do tipo Áudio dos ativos.",
            "Cannot change settings from Project Settings.": "Não é possível alterar as configurações em Configurações do Projeto.",
            "Cannot change settings from Console.": "Não é possível alterar as configurações no Console.",
            "Add one caption asset to use.<0/>The kind of caption can only select subtitles.": "Adicione um ativo de legenda para usar.<0/>O tipo de legenda só pode selecionar legendas.",
            "Select files from the video type of assets.": "Selecione arquivos do tipo vídeo dos ativos.",
            "Please add itemSet for metadata.": "Por favor, adicione um conjunto de itens para metadados.",
            "There is no ItemSet to select. Please add a ItemSet.": "Não há conjunto de itens para selecionar. Por favor, adicione um conjunto de itens.",
            "The caption of the program can be edited in the caption of the <0> {{number}} </0>": "A legenda do programa pode ser editada na legenda do <0> {{number}} </0>",
            "There is a duplicate language among the captions applied to the <0> {{name}} </0>": "Existe um idioma duplicado entre as legendas aplicadas ao <0> {{name}} </0>",
            "Please create a lineup after editing in the video as it is difficult to create a lineup if there are duplicate languages.": "Crie uma fila após editar no vídeo, pois é difícil criar uma fila se houver idiomas duplicados.",
            "Changed data exists. Are you sure you want to escape?": "Existem dados alterados. Tem certeza de que deseja sair?",
            "Add attendees to join the Group Chatting": "Adicione participantes para entrar no Chat em Grupo",
            "Enter Email Address": "Insira o endereço de e-mail",
            "Saving of changes to '{{tab}}' failed.": "Falha ao salvar as alterações de '{{tab}}'.",
            "Changes to the '{{tab}}' have been saved.": "As alterações em '{{tab}}' foram salvas.",
            "File upload failed.": "Falha no Upload do arquivo.",
            "An invalid input file was selected.": "Um arquivo de entrada inválido foi selecionado.",
            "Asset creation failed.": "Falha na criação do ativo.",
            "The input file is in an unsupported format.": "O arquivo de entrada está em um formato não suportado.",
            "The transcoding operation failed due to an unexpected problem.": "A operação de transcodificação falhou devido a um problema inesperado.",
            "If the problem persists, please contact the management.": "Se o problema persistir, entre em contato com o gerenciamento.",
            "Please use a different file after checking the file upload rules.": "Por favor, use um arquivo diferente após verificar as regras de Upload de arquivo.",
            "Please use a different file after checking the 'Supported File Formats' of the file upload rules.": "Por favor, use um arquivo diferente após verificar os 'Formatos de Arquivo Suportados' das regras de Upload de arquivo.",
            "The media information may not be queried, or an invalid file may have been entered.": "As informações de mídia podem não ser consultáveis, ou um arquivo inválido pode ter sido inserido.",
            "Use streaming software to send live streams to Amazon IVS, providing users with low-latency live stream services and interactive video experiences.": "Use software de transmissão para enviar transmissões ao vivo para o Amazon IVS, fornecendo aos usuários serviços de transmissão ao vivo de baixa latência e experiências de vídeo interativas.",
            "Provides real-time communication components such as online conferencing services by leveraging messaging, audio, video and screen sharing capabilities to web or mobile applications.": "Fornece componentes de comunicação em tempo real, como serviços de conferência online, aproveitando recursos de mensagens, áudio, vídeo e compartilhamento de tela para aplicativos web ou móveis.",
            "Broadcast and deliver live video in up to Full HD.": "Transmita e entregue vídeo ao vivo em até Full HD.",
            "Broadcast and deliver live video in up to SD.": "Transmita e entregue vídeo ao vivo em até SD.",
            "Best for near real-time interactions with viewers.": "Melhor para interações quase em tempo real com espectadores.",
            "Enable if real-time interactivity with viewers is not required. May improve reliability in certain regions.": "Ative se a interatividade em tempo real com espectadores não for necessária. Pode melhorar a confiabilidade em determinadas regiões.",
            "Enable token-authorization requirement for video playback.": "Ative o requisito de autorização por token para reprodução de vídeo.",
            "Channel’s live stream is automatically recorded and created as Videos and Assets.": "A transmissão ao vivo do canal é gravada automaticamente e criada como Vídeos e Ativos.",
            "A chat where all attendees on the channel can join the chat.": "Um chat onde todos os participantes do canal podem entrar.",
            "A chat that allows for close interaction between invited attendees.": "Um chat que permite interação próxima entre participantes convidados.",
            "If the chat type is modified after channel creation, all previously set values are initialized.": "Se o tipo de chat for modificado após a criação do canal, todos os valores definidos anteriormente serão inicializados.",
            "Failed to save changes": "Falha ao salvar alterações",
            "Search for files in Assets.": "Buscar arquivos em Ativos.",
            "You are about to revoke site access for <0>{{name}}</0>.<1/>This user won’t be able to use your space. You can give them access at any time.<1/>Are you sure you want to revoke site access for this user?": "Você está prestes a revogar o acesso ao site para <0>{{name}}</0>.<1/>Este usuário não poderá usar seu espaço. Você pode conceder acesso a qualquer momento.<1/>Tem certeza de que deseja revogar o acesso ao site para este usuário?",
            "You are about to remove  <0>{{name}}</0> from space.<1/>This user will no longer have access to the space. Your space will still keep all of this user’s contributions.<1/>Are you sure you want to remove user from space?": "Você está prestes a remover <0>{{name}}</0> do espaço.<1/>Este usuário não terá mais acesso ao espaço. Seu espaço ainda manterá todas as contribuições deste usuário.<1/>Tem certeza de que deseja remover o usuário do espaço?",
            "Bucket names must be between 3 and 63 characters long.": "Os nomes de bucket devem ter entre 3 e 63 caracteres.",
            "Bucket names can consist only of lowercase letters, numbers, dots (.), and hyphens (-).": "Os nomes de bucket podem consistir apenas de letras minúsculas, números, pontos (.) e hífens (-).",
            "Bucket names must begin and end with a letter or number.": "Os nomes de bucket devem começar e terminar com uma letra ou número.",
            "Bucket names must not be formatted as an IP address (for example, 192.168.5.4).": "Os nomes de bucket não devem ser formatados como um endereço IP (por exemplo, 192.168.5.4).",
            "Bucket names must not start with the prefix xn--.": "Os nomes de bucket não devem começar com o prefixo xn--.",
            "Bucket names must not end with the suffix -s3alias.": "Os nomes de bucket não devem terminar com o sufixo -s3alias.",
            "Bucket names cannot have consecutive periods.": "Os nomes de bucket não podem ter pontos consecutivos.",
            "You can enter up to 10 users.": "Você pode inserir até 10 usuários.",
            "Of the selected assets, {{createItemLength}} out of {{selectedItemLength}} can be created as photos. <1/>Choose whether you want <0>the {{createItemLength}} assets</0> to be multiple photos or a single photo.": "Dos ativos selecionados, {{createItemLength}} de {{selectedItemLength}} podem ser criados como fotos. <1/>Escolha se deseja que <0>os {{createItemLength}} ativos</0> sejam múltiplas fotos ou uma única foto.",
            "The {{createItemLength}} selected assets have been selected to be created as multiple photos.<0/>Would you like to create a photo now?": "Os {{createItemLength}} ativos selecionados foram selecionados para serem criados como múltiplas fotos.<0/>Deseja criar uma foto agora?",
            "The photo name is applied to the name being used in the asset, and metadata can be edited in the created photo.": "O nome da foto é aplicado ao nome usado no ativo, e os metadados podem ser editados na foto criada.",
            "Would you like to log out from the account service as well?": "Deseja também fazer Logout do serviço de conta?",
            "Conveniently apply to asset types through the Apply All Over option.": "Aplique convenientemente a tipos de ativos através da opção Aplicar a Todos.",
            "There is a history of individual modification of some metadata among assets of this asset type.": "Há um histórico de modificação individual de alguns metadados entre ativos deste tipo de ativo.",
            "If you save, all the changed metadata will be applied.": "Se você salvar, todos os metadados alterados serão aplicados.",
            "Are you sure you want to fix it though?": "Tem certeza de que deseja corrigir mesmo assim?",
            "When applied, all default metadata is applied.": "Quando aplicado, todos os metadados padrão são aplicados.",
            "Do you still want to apply?": "Ainda deseja aplicar?",
            "Changes made to files in the storage list are not updated here.": "As alterações feitas nos arquivos na lista de armazenamento não são atualizadas aqui.",
            "If you want to change the file, you must close the ‘Create Asset Bulk’ screen and re-enter after making changes in the storage list.": "Se você quiser alterar o arquivo, deve fechar a tela 'Criar Ativo em Massa' e reentrar após fazer alterações na lista de armazenamento.",
            "If the asset contains only one single file": "Se o ativo contiver apenas um único arquivo",
            "If the asset contains multiple files": "Se o ativo contiver vários arquivos",
            "If the language code for the file is appended after the file name (_), the language and label are automatically applied.": "Se o código de idioma do arquivo for acrescentado após o nome do arquivo (_), o idioma e o rótulo serão aplicados automaticamente.",
            "If the language code is not applied after the file name (_), the language and label are applied in English (United States).": "Se o código de idioma não for aplicado após o nome do arquivo (_), o idioma e o rótulo serão aplicados em Inglês (Estados Unidos).",
            "Add files in the first step, Add Files to Bulk.": "Adicione arquivos na primeira etapa, Adicionar Arquivos em Massa.",
            "Language and label are automatically applied language and label.": "O idioma e o rótulo são aplicados automaticamente.",
            "Language and labels apply in English (United States).": "O idioma e os rótulos são aplicados em Inglês (Estados Unidos).",
            "Kind default is applied as caption type.": "O padrão de tipo é aplicado como tipo de legenda.",
            "Creation for {{count}} assets requested.": "Criação de {{count}} ativos solicitada.",
            "It may take some time for stable processing because it is downloading a file from a location far away from the current location (overseas) or a large file.": "Pode levar algum tempo para um processamento estável porque está baixando um arquivo de um local distante do local atual (exterior) ou um arquivo grande.",
            "If you want to check the file you have selected, <0/> Please contact your space administrator.": "Se você quiser verificar o arquivo selecionado, <0/> entre em contato com o administrador do seu espaço.",
            "If it is an item in the 'Current Project', all functions can be used.": "Se for um item do 'Projeto Atual', todas as funções podem ser usadas.",
            "If it is an accessible 'Not Accessible' item, all functions cannot be used.": "Se for um item 'Não Acessível', todas as funções não podem ser usadas.",
            "If it is an accessible 'other project' item, you can use the download function.": "Se for um item de 'outro projeto' acessível, você pode usar a função de Download.",
            "To check the folder, select the project to which the bucket the folder<0/>belongs to, and then switch the site to the selected project.": "Para verificar a pasta, selecione o projeto ao qual o bucket ao qual a pasta<0/>pertence, e então mude o site para o projeto selecionado.",
            "Are you sure you want to check the folder<0/>after switching to the selected project?": "Tem certeza de que deseja verificar a pasta<0/>após mudar para o projeto selecionado?",
            "Download period is up to <0>{{totalCount}}</0> days, and the number of downloads is up to <0>{{sourceFolderName}}</0> times.": "O período de Download é de até <0>{{totalCount}}</0> dias, e o número de downloads é de até <0>{{sourceFolderName}}</0> vezes.",
            "The download period is up to <0> {{number}} </0> days.": "O período de Download é de até <0> {{number}} </0> dias.",
            "The number of downloads is up to <0/> times.": "O número de downloads é de até <0/> vezes.",
            "The download period is up to <0>{{period}}</0> days,<1/>and the number of downloads is up to <0>{{count}}</0> times left.": "O período de Download é de até <0>{{period}}</0> dias,<1/>e o número de downloads restantes é de até <0>{{count}}</0> vezes.",
            "The password is wrong <0>{{count}}</0> times. Please check the password.": "A senha está errada <0>{{count}}</0> vezes. Por favor, verifique a senha.",
            "In case of error <0>{{count}}</0> times, the download link URL is no longer available.": "Em caso de erro <0>{{count}}</0> vezes, o URL do link de Download não estará mais disponível.",
            "If you want to continue downloading,<0/>please get the download link URL back.": "Se você quiser continuar o Download,<0/>por favor, obtenha novamente o URL do link de Download.",
            "The requested page may have disappeared or the path may be incorrect.<0/>Please check and try again.": "A página solicitada pode ter desaparecido ou o caminho pode estar incorreto.<0/>Por favor, verifique e tente novamente.",
            "The download period is up to <0>{{period}}</0> days.": "O período de Download é de até <0>{{period}}</0> dias.",
            "up to <0/> times.": "até <0/> vezes.",
            "Are you sure you want to approval the selected<0/><1>{{name}}</1>?": "Tem certeza de que deseja aprovar o(a) <0/><1>{{name}}</1> selecionado(a)?",
            "Are you sure you want to reject the selected<0/><1>{{name}}</1>?": "Tem certeza de que deseja rejeitar o(a) <0/><1>{{name}}</1> selecionado(a)?",
            "If you remove <0>{{name}}</0>, the item is deleted from the view.": "Se você remover <0>{{name}}</0>, o item será excluído da visualização.",
            "Other users will still have access.": "Outros usuários ainda terão acesso.",
            "Are you sure you want to remove the item?": "Tem certeza de que deseja remover o item?",
            "If you remove <0>{{number}}</0> other then <0>{{name}}</0>, the items is deleted from the view.": "Se você remover <0>{{number}}</0> outros além de <0>{{name}}</0>, os itens serão excluídos da visualização.",
            "Are you sure you want to remove the items?": "Tem certeza de que deseja remover os itens?",
            "Also, all shared users will no longer have access and will be removed from the shared list.": "Além disso, todos os usuários com acesso compartilhado não terão mais acesso e serão removidos da lista de compartilhamento.",
            "Select the folder path. If not specified, it is stored in the top-level path.": "Selecione o caminho da pasta. Se não especificado, será armazenado no caminho de nível superior.",
            "The folder path of the asset is a virtual path specified by the user and is different from the actual S3 folder path.": "O caminho da pasta do ativo é um caminho virtual especificado pelo usuário e é diferente do caminho real da pasta S3.",
            "Deleting {{currentIndex}} of <0>{{deleteItemLength}}</0> assets": "Excluindo {{currentIndex}} de <0>{{deleteItemLength}}</0> ativos",
            "If you delete <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to delete?": "Se você excluir <0>{{name}}</0>, não será possível reverter isso.<1/>Tem certeza de que deseja excluir?",
            "If you delete <0>{{name}}</0>,  will also be removed from reference and you won’t be able to revert this.<1/>Are you sure you want to delete?": "Se você excluir <0>{{name}}</0>, também será removido das referências e não será possível reverter isso.<1/>Tem certeza de que deseja excluir?",
            "The download period is up to <0>{{period}}</0> days left.": "O período de Download é de até <0>{{period}}</0> dias restantes.",
            "File {{item}} has been shared": "O arquivo {{item}} foi compartilhado",
            "Asset {{item}} has been shared": "O ativo {{item}} foi compartilhado",
            "There was an error removing file {{item}}": "Houve um erro ao remover o arquivo {{item}}",
            "There was an error removing asset {{item}}": "Houve um erro ao remover o ativo {{item}}",
            "Discard unsaved changes?": "Descartar alterações não salvas?",
            "Asset {{item}} and {{length}} other items have been removed.": "O ativo {{item}} e {{length}} outros itens foram removidos.",
            "File {{item}} and {{length}} other items have been removed.": "O arquivo {{item}} e {{length}} outros itens foram removidos.",
            "Asset {{item}} has been removed.": "O ativo {{item}} foi removido.",
            "File {{item}} has been removed.": "O arquivo {{item}} foi removido.",
            "There was an error removing file {{item}} and {{length}} other items.": "Houve um erro ao remover o arquivo {{item}} e {{length}} outros itens.",
            "There was an error removing asset {{item}} and {{length}} other items.": "Houve um erro ao remover o ativo {{item}} e {{length}} outros itens.",
            "There was an error removing file {{item}}.": "Houve um erro ao remover o arquivo {{item}}.",
            "There was an error removing asset {{item}}.": "Houve um erro ao remover o ativo {{item}}.",
            "There was an error sharing file {{item}}.": "Houve um erro ao compartilhar o arquivo {{item}}.",
            "There was an error sharing asset {{item}}.": "Houve um erro ao compartilhar o ativo {{item}}.",
            "Since this is a category group that is not used in assets, you can check the created assets in 'categories not classified in assets'.": "Como este é um grupo de categorias não utilizado em ativos, você pode verificar os ativos criados em 'categorias não classificadas em ativos'.",
            "There was an error deleting folder {{item}}.": "Houve um erro ao excluir a pasta {{item}}.",
            "Deletion of folder {{item}} has been completed.": "A exclusão da pasta {{item}} foi concluída.",
            "Creation of new folder {{item}} is completed.": "A criação da nova pasta {{item}} foi concluída.",
            "There was an error creating the new folder {{item}}.": "Houve um erro ao criar a nova pasta {{item}}.",
            "If you delete <0>{{name}}</0>, you won't be able to revert this.": "Se você excluir <0>{{name}}</0>, não será possível reverter isso.",
            "Sync requested.": "Sincronização solicitada.",
            "If you archive the asset, you will be charged the <0>90-day</0> archive<1/> amount immediately.<1/>Are you sure you want to archive?": "Se você arquivar o ativo, será cobrado o valor de arquivamento de <0>90 dias</0><1/> imediatamente.<1/>Tem certeza de que deseja arquivar?",
            "Move completed from {{item1}} to {{item2}}.": "Movimentação concluída de {{item1}} para {{item2}}.",
            "Moved '{{item1}}' into '{{item2}}'.": "'{{item1}}' foi movido para dentro de '{{item2}}'.",
            "Failed to save the folder order change. Reverted to the original state.": "Falha ao salvar a alteração da ordem das pastas. O estado original foi restaurado.",
            "Failed to save the folder move. Reverted to the original state.": "Falha ao salvar a movimentação da pasta. O estado original foi restaurado.",
            "Refreshing the folder tree. Please try again.": "Atualizando a árvore de pastas. Tente novamente.",
            "Error moving from {{item1}} to {{item2}}.": "Erro ao mover de {{item1}} para {{item2}}.",
            "Error renaming from {{item1}} to {{item2}}.": "Erro ao renomear de {{item1}} para {{item2}}.",
            "This folder contains assets.": "Esta pasta contém ativos.",
            "Rename completed from {{item1}} to {{item2}}.": "Renomeação concluída de {{item1}} para {{item2}}.",
            "The sharing period for this file has expired. <0/> If you want to check the file you have selected, <0/> Please ask the sharer to share.": "O período de compartilhamento deste arquivo expirou. <0/> Se você quiser verificar o arquivo selecionado, <0/> solicite ao compartilhador que compartilhe novamente.",
            "There was an error creating event trigger.": "Houve um erro ao criar o gatilho de evento.",
            "Error deleting asset '{{name}}'. {{line}} Please refresh the page and try again.": "Erro ao excluir o ativo '{{name}}'. {{line}} Atualize a página e tente novamente.",
            "Asset '{{name}}' has been deleted.": "O ativo '{{name}}' foi excluído.",
            "Error deleting asset '{{name}}' and {{count}} others. {{line}} Please refresh the page and try again.": "Erro ao excluir o ativo '{{name}}' e {{count}} outros. {{line}} Atualize a página e tente novamente.",
            "Asset '{{name}}' and {{count}} other assets have been deleted.": "O ativo '{{name}}' e {{count}} outros ativos foram excluídos.",
            "Error archiving asset '{{name}}'. {{line}} Please refresh the page and try again.": "Erro ao arquivar o ativo '{{name}}'. {{line}} Atualize a página e tente novamente.",
            "Asset '{{name}}' has been restored.": "O ativo '{{name}}' foi restaurado.",
            "Error restoring asset '{{name}}'. {{line}} Please refresh the page and try again.": "Erro ao restaurar o ativo '{{name}}'. {{line}} Atualize a página e tente novamente.",
            "Error saving changes to {{resource}} settings. {{line}} Please refresh the page and try again.": "Erro ao salvar as alterações nas configurações de {{resource}}. {{line}} Atualize a página e tente novamente.",
            "Changes to your {{resource}} settings have been saved.": "As alterações nas configurações de {{resource}} foram salvas.",
            "Event trigger '{{name}}' has been added.": "O gatilho de evento '{{name}}' foi adicionado.",
            "You don't have access. {{line}} Please contact the manager.": "Você não tem acesso. {{line}} Entre em contato com o gerente.",
            "Error adding asset '{{name}}'. {{line}} Please refresh the page and try again.": "Erro ao adicionar o ativo '{{name}}'. {{line}} Atualize a página e tente novamente.",
            "Error adding asset '{{name}}' and {{count}} others. {{line}} Please refresh the page and try again.": "Erro ao adicionar o ativo '{{name}}' e {{count}} outros. {{line}} Atualize a página e tente novamente.",
            "Asset '{{name}}' has been added.": "O ativo '{{name}}' foi adicionado.",
            "Asset '{{name}}' and {{count}} other assets have been added.": "O ativo '{{name}}' e {{count}} outros ativos foram adicionados.",
            "The access of asset '{{name}}' has been updated to private.": "O acesso do ativo '{{name}}' foi atualizado para privado.",
            "The access of asset '{{name}}' has been updated to public.": "O acesso do ativo '{{name}}' foi atualizado para público.",
            "Error updating asset '{{name}}' with access to private. {{line}} Please refresh the page and try again.": "Erro ao atualizar o ativo '{{name}}' com acesso privado. {{line}} Atualize a página e tente novamente.",
            "Error updating asset '{{name}}' with access to public. {{line}} Please refresh the page and try again.": "Erro ao atualizar o ativo '{{name}}' com acesso público. {{line}} Atualize a página e tente novamente.",
            "Event trigger '{{name}}' has been deleted.": "O gatilho de evento '{{name}}' foi excluído.",
            "Error deleting event trigger '{{name}}'. {{line}} Please refresh the page and try again.": "Erro ao excluir o gatilho de evento '{{name}}'. {{line}} Atualize a página e tente novamente.",
            "The name has been updated.": "O nome foi atualizado.",
            "Attributions has been updated.": "As atribuições foram atualizadas.",
            "Tags has been updated.": "As Tags foram atualizadas.",
            "Error updating the name. {{line}} Please refresh the page and try again.": "Erro ao atualizar o nome. {{line}} Atualize a página e tente novamente.",
            "Error updating the description. {{line}} Please refresh the page and try again.": "Erro ao atualizar a descrição. {{line}} Atualize a página e tente novamente.",
            "Error updating attributions. {{line}} Please refresh the page and try again.": "Erro ao atualizar as atribuições. {{line}} Atualize a página e tente novamente.",
            "Error updating Tags. {{line}} Please refresh the page and try again.": "Erro ao atualizar as Tags. {{line}} Atualize a página e tente novamente.",
            "Error updating status to active. {{line}} Please refresh the page and try again.": "Erro ao atualizar o status para ativo. {{line}} Atualize a página e tente novamente.",
            "Error updating status to inactive. {{line}} Please refresh the page and try again.": "Erro ao atualizar o status para inativo. {{line}} Atualize a página e tente novamente.",
            "Error updating conditions. {{line}} Please refresh the page and try again.": "Erro ao atualizar as condições. {{line}} Atualize a página e tente novamente.",
            "Error updating Actions. {{line}} Please refresh the page and try again.": "Erro ao atualizar as ações. {{line}} Atualize a página e tente novamente.",
            "Status updated to active.": "Status atualizado para ativo.",
            "Status updated to inactive.": "Status atualizado para inativo.",
            "Conditions has been updated.": "As condições foram atualizadas.",
            "Actions has been updated.": "As ações foram atualizadas.",
            "You don't have permission to access this item.": "Você não tem permissão para acessar este item.",
            "Page not found. {{line}} The page you are looking for doesn't exist or an other error occurred.": "Página não encontrada. {{line}} A página que você está procurando não existe ou ocorreu outro erro.",
            "That's an error. {{line}} Please try again later.": "Isso é um erro. {{line}} Por favor, tente novamente mais tarde.",
            "Your request resulted in an error. {{line}} please try again.": "Sua solicitação resultou em um erro. {{line}} por favor, tente novamente.",
            "The download of asset '{{name}}' has been requested.": "O Download do ativo '{{name}}' foi solicitado.",
            "Error requesting download of asset '{{name}}'. {{line}} Please refresh the page and try again.": "Erro ao solicitar o Download do ativo '{{name}}'. {{line}} Atualize a página e tente novamente.",
            "The file has been updated.": "O arquivo foi atualizado.",
            "Error updating the file. {{line}} Please refresh the page and try again.": "Erro ao atualizar o arquivo. {{line}} Atualize a página e tente novamente.",
            "Error adding event trigger '{{name}}'. {{line}} Please refresh the page and try again.": "Erro ao adicionar o gatilho de evento '{{name}}'. {{line}} Atualize a página e tente novamente.",
            "If you delete \"<0>{{name}}</0>\", you won’t be able to revert this.<1/>Are you sure you want to delete?": "Se você excluir \"<0>{{name}}</0>\", não será possível reverter isso.<1/>Tem certeza de que deseja excluir?",
            "Deleting <0>{{currentIndex}}</0>  of <0>{{deleteItemLength}}</0> assets": "Excluindo <0>{{currentIndex}}</0> de <0>{{deleteItemLength}}</0> ativos",
            "\"<0>{{name}}</0>\" will be deleted forever and you won’t be abled to restore it.": "“<0>{{name}}</0>” será excluído permanentemente e não será possível restaurá-lo.",
            "If you navigate away from this page,<1/>your changes cannot be saved.": "Se você sair desta página,<1/>suas alterações não poderão ser salvas.",
            "“{{name}}” will be deleted forever and you won’t be abled to restore it.": "“{{name}}” será excluído permanentemente e não será possível restaurá-lo.",
            "It can only be deleted if there are no assets in the folder.": "Só é possível excluir se não houver ativos na pasta.",
            "Specify the folder location?": "Especificar o local da pasta?",
            "Asset '{{name}}' has been moved from '{{fromFolder}}' to Folder '{{toFolder}}'.": "O ativo '{{name}}' foi movido de '{{fromFolder}}' para a Pasta '{{toFolder}}'.",
            "Asset '{{name}}' and {{count}} other has been moved from '{{fromFolder}}' to Folder '{{toFolder}}'.": "O ativo '{{name}}' e {{count}} outros foram movidos de '{{fromFolder}}' para a Pasta '{{toFolder}}'.",
            "It may take time to send mail when there are {{count}} or more shared files or folders. (Approximately 3 minutes per 1GB)": "Pode levar algum tempo para enviar o e-mail quando houver {{count}} ou mais arquivos ou pastas compartilhados. (Aproximadamente 3 minutos por 1GB)",
            "Depending on the size of the shared file, it may take time to send the email. (Approximately 3 minutes per 1GB)": "Dependendo do tamanho do arquivo compartilhado, pode levar algum tempo para enviar o e-mail. (Aproximadamente 3 minutos por 1GB)",
            "If you restore this item now, you will also be charged for the <NewLine>remaining <Strong>{{n}} days.</Strong></NewLine>": "Se você restaurar este item agora, também será cobrado pelos <NewLine>dias restantes <Strong>{{n}} dias.</Strong></NewLine>",
            "No search results found.": "Nenhum resultado de busca encontrado.",
            "Search for the owner of the asset.": "Buscar o proprietário do ativo.",
            "Enter after typing": "Digite e pressione Enter",
            "Enter the extension in lowercase without a dot. (e.g. mp4)": "Digite a extensão em minúsculas e sem ponto. (ex.: mp4)",
            "The download of asset '{{name}}' and {{count}} other have been requested.": "O Download do ativo '{{name}}' e {{count}} outros foi solicitado.",
            "Please select the project you wish to access.": "Por favor, selecione o projeto ao qual deseja acessar.",
            "Please search by asset name.": "Por favor, busque pelo nome do ativo.",
            "Please enter the name.": "Por favor, insira o nome.",
            "Please enter the description.": "Por favor, insira a descrição.",
            "Error saving changes to project details. {{line}} Please refresh the page and try again.": "Erro ao salvar as alterações nos detalhes do projeto. {{line}} Atualize a página e tente novamente.",
            "Changes to your project details settings have been saved.": "As alterações nas configurações de detalhes do projeto foram salvas.",
            "Error adding project '{{name}}'. {{line}} Please refresh the page and try again.": "Erro ao adicionar o projeto '{{name}}'. {{line}} Atualize a página e tente novamente.",
            "Project '{{name}}' has been added.": "O projeto '{{name}}' foi adicionado.",
            "The project lead has been updated.": "O responsável pelo projeto foi atualizado.",
            "Error updating the project lead. {{line}} Please refresh the page and try again.": "Erro ao atualizar o responsável pelo projeto. {{line}} Atualize a página e tente novamente.",
            "Asset '{{name}}' has been archived.": "O ativo '{{name}}' foi arquivado.",
            "This setting can lock the bucket so that other users cannot use the storage’s features (Copy, Move, Rename, Delete).": "Esta configuração pode bloquear o bucket para que outros usuários não possam usar os recursos do armazenamento (Copiar, Mover, Renomear, Excluir).",
            "This bucket is locked by another user and can only be downloaded.": "Este bucket está bloqueado por outro usuário e só pode ser baixado.",
            "Bucket '{{name}}' is feature locked for other users.": "O bucket '{{name}}' está com recursos bloqueados para outros usuários.",
            "Bucket '{{name}}' is feature unlocked for another user.": "O bucket '{{name}}' está com recursos desbloqueados para outro usuário.",
            "Error occurred while feature-locking bucket '{{name}}' for another user. {{line}} Please refresh the page and try again.": "Ocorreu um erro ao bloquear recursos do bucket '{{name}}' para outro usuário. {{line}} Atualize a página e tente novamente.",
            "Error occurred while attempting to feature unlock bucket '{{name}}' for another user. {{line}} Please refresh the page and try again.": "Ocorreu um erro ao tentar desbloquear recursos do bucket '{{name}}' para outro usuário. {{line}} Atualize a página e tente novamente.",
            "No items match this filter": "Nenhum item corresponde a este filtro",
            "None of achives matched this search": "Nenhum arquivo arquivado corresponde a esta busca",
            "Find items using another filter option.": "Encontre itens usando outra opção de filtro.",
            "Try another search, <br/> or use the search option to find an asset.": "Tente outra busca, <br/> ou use a opção de busca para encontrar um ativo.",
            "You can archive by selecting the items you want to <br/> archive under “Assets”.": "Você pode arquivar selecionando os itens que deseja <br/> arquivar em “Ativos”.",
            "No items have been archived yet.": "Nenhum item foi arquivado ainda.",
            "Enter Asset Name": "Inserir Nome do Ativo",
            "Enter Archived ID": "Inserir ID Arquivado",
            "Enter Asset ID": "Inserir ID do Ativo",
            "Enter Archived by": "Inserir Arquivado por",
            "Enter Owner": "Inserir Proprietário",
            "Welcome": "Bem-vindo",
            "You need to log in to your Megazone account to start CloudPlex.": "Você precisa fazer Login na sua conta Megazone para iniciar o CloudPlex.",
            "Login with your Megazone account": "Login com sua conta Megazone",
            "Size of files Option : Number of files option is required. <NewLine/> Number of files option : Can be set without checking size of files.": "Opção de tamanho de arquivos: A opção de número de arquivos é obrigatória. <NewLine/> Opção de número de arquivos: Pode ser definida sem verificar o tamanho dos arquivos.",
            "If you archive the assets, you will be charged the <0>{{n}}-day</0> archive<1/> amount immediately.": "Se você arquivar os ativos, será cobrado o valor de arquivamento de <0>{{n}} dias</0><1/> imediatamente.",
            "If you archive the asset, you will be charged the <0>{{n}}-day</0> archive<1/> amount immediately.": "Se você arquivar o ativo, será cobrado o valor de arquivamento de <0>{{n}} dias</0><1/> imediatamente.",
            "If you restore this item now, you will also be charged for the <NewLine/>remaining days per asset.": "Se você restaurar este item agora, também será cobrado pelos <NewLine/>dias restantes por ativo.",
            "Getting Access Token...": "Obtendo Access Token...",
            "Get Access Token": "Obter Access Token",
            "To use CloudPlex Delivery's CDN, an Access Token must be issued.": "Para usar o CDN do CloudPlex Delivery, um Access Token deve ser emitido.",
            "Please search by asset name or ID.": "Por favor, busque pelo nome ou ID do ativo.",
            "No Collection items yet.": "Ainda não há itens de Coleção.",
            "Add it using the “Create” button.": "Adicione usando o botão “Criar”.",
            "No linked collection yet.": "Ainda não há coleção vinculada.",
            "No assets yet.": "Ainda não há ativos.",
            "Add it using the “+” button.": "Adicione usando o botão “+”.",
            "Please search by collection name.": "Por favor, busque pelo nome da coleção.",
            "Selected assets can be archived by selecting the storage <NewLine/> class to be archived.": "Os ativos selecionados podem ser arquivados selecionando a classe de armazenamento <NewLine/> a ser arquivada.",
            "Selected assets can be restored by selecting a restore <NewLine/>option based on how they were archived.": "Os ativos selecionados podem ser restaurados selecionando uma opção de restauração <NewLine/>com base em como foram arquivados.",
            "“{{name}}” and {{count}} others will be deleted forever and you won’t be abled to restore it.": "“{{name}}” e {{count}} outros serão excluídos permanentemente e não será possível restaurá-los.",
            "However, assets included in the collection are not deleted.": "No entanto, os ativos incluídos na coleção não são excluídos.",
            "Deletion of collection {{item}} has been completed.": "A exclusão parcial da coleção {{item}} foi concluída.",
            "Partial deletion of collection {{item}} and {{count}} others have been completed.": "A exclusão parcial da coleção {{item}} e mais {{count}} outros foi concluída.",
            "Deletion of collection {{item}} and {{count}} others have been completed.": "A exclusão da coleção {{item}} e mais {{count}} outros foi concluída.",
            "There was an error deleting collection": "Ocorreu um erro ao excluir a coleção",
            "There was an error deleting collections": "Ocorreu um erro ao excluir as coleções",
            "Size of files Option : If you choose your own assets, you can have up to {{maxAssets}}. <NewLine/> Keep the number of selected assets under {{maxAssets}}.": "Opção de tamanho dos arquivos: Se você escolher seus próprios ativos, poderá ter até {{maxAssets}}. <NewLine/> Mantenha o número de ativos selecionados abaixo de {{maxAssets}}.",
            "Select assets through search to put them in your collection.": "Selecione ativos por meio de busca para adicioná-los à sua coleção.",
            "Select the folder containing the assets you want to put in your collection.": "Selecione a pasta que contém os ativos que deseja adicionar à sua coleção.",
            "Select collections through search to put them in your collection.": "Selecione coleções por meio de busca para adicioná-las à sua coleção.",
            "The maximum number of tags, {{maxCount}}, has been exceeded.": "O número máximo de tags, {{maxCount}}, foi excedido.",
            "Please search by collection name or ID.": "Busque pelo nome ou ID da coleção.",
            "Deletion of content schema {{item}} has been completed.": "A exclusão do esquema de conteúdo {{item}} foi concluída.",
            "There was an error deleting content schema.": "Ocorreu um erro ao excluir o esquema de conteúdo.",
            "Content schema '{{name}}' has been added.": "O esquema de conteúdo '{{name}}' foi adicionado.",
            "Up to 50 {{referenceType}} can be registered": "É possível registrar até 50 {{referenceType}}",
            "You can activate a fortress field right away, and you can additionally turn the field into a user camp.": "Você pode ativar um campo de fortaleza imediatamente e, adicionalmente, transformar o campo em um campo de usuário.",
            "No projects are in use yet.": "Nenhum projeto está em uso ainda.",
            "You must add at least 1 field for “Reference Fields”.<NewLine/> Only then can the schema status be changed to “active” and used in the project.": "Você deve adicionar pelo menos 1 campo em \"Campos de Referência\".<NewLine/> Somente assim o status do esquema poderá ser alterado para \"ativo\" e utilizado no projeto.",
            "After opening the Fields panel via the “Add Fields” button,<NewLine/> add fields by dragging them to the “{{isReference}} Fields” layout.": "Após abrir o painel de Campos pelo botão \"Adicionar Campos\",<NewLine/> adicione campos arrastando-os para o layout de \"Campos {{isReference}}\".",
            "The name starts with English, contains at least 2 letters, and can only contain English, spaces, and numbers.": "O nome começa com letra em inglês, contém pelo menos 2 letras e pode conter apenas inglês, espaços e números.",
            "No items yet.": "Nenhum item ainda.",
            "Add it using the “Add {{name}}” button.": "Adicione usando o botão \"Adicionar {{name}}\".",
            "“{{name}}” will be removed.": "“{{name}}” será removido.",
            "“{{name}}” and {{count}} others will be removed.": "“{{name}}” e mais {{count}} outros serão removidos.",
            "None of collection matched this search. {{line}} Try another search.": "Nenhuma coleção correspondeu a esta busca. {{line}} Tente outra busca.",
            "Delete the item?": "Excluir o item?",
            "Delete these items?": "Excluir estes itens?",
            "However, assets and content contained in {{schemaName}} are not deleted.": "No entanto, os ativos e conteúdos contidos em {{schemaName}} não serão excluídos.",
            "Select preview image through search to put them in your content.": "Selecione a imagem de Pré-visualização por meio de busca para adicioná-la ao seu conteúdo.",
            "Deletion of custom content {{item}} and {{count}} others has been completed.": "A exclusão do conteúdo personalizado {{item}} e mais {{count}} outros foi concluída.",
            "Deletion of custom content {{item}} has been completed.": "A exclusão do conteúdo personalizado {{item}} foi concluída.",
            "Please search by name or ID.": "Busque pelo nome ou ID.",
            "Please search by {{resourceType}} name or ID.": "Busque pelo nome ou ID de {{resourceType}}.",
            "Try another search to find an content.": "Tente outra busca para encontrar um conteúdo.",
            "You must enter your authentication information to use the engine.": "Você deve inserir suas informações de autenticação para usar o mecanismo.",
            "Delete message?": "Excluir mensagem?",
            "Deleting a message cannot be canceled.": "A exclusão de uma mensagem não pode ser cancelada.",
            "This message was deleted.": "Esta mensagem foi excluída.",
            "Please enter your message.": "Por favor, insira sua mensagem.",
            "Would you like to make a private comment?": "Deseja criar um comentário privado?",
            "Please enter a private comment name.": "Por favor, insira um nome para o comentário privado.",
            "Add users to participate in private comments.": "Adicione usuários para participar dos comentários privados.",
            "you can add users of the project to communicate with them.": "Você pode adicionar usuários do projeto para se comunicar com eles.",
            "Would you like to change your private comment name?": "Deseja alterar o nome do seu comentário privado?",
            "Are you sure you want to delete the private comment?": "Tem certeza de que deseja excluir o comentário privado?",
            "If you delete <0>\"{{name}}\"</0>, all messages will be deleted and cannot be restored after deletion.": "Se você excluir <0>“{{name}}”</0>, todas as mensagens serão excluídas e não poderão ser restauradas após a exclusão.",
            "This is a message window where all the basics of the project can be seen.": "Esta é uma janela de mensagens onde todos os fundamentos do projeto podem ser visualizados.",
            "By entering @mention, you can send a comment to the designated member.": "Ao inserir @menção, você pode enviar um comentário para o membro designado.",
            "This is a message window that only added members can see.": "Esta é uma janela de mensagens que apenas os membros adicionados podem visualizar.",
            "Please enter your user email.": "Insira o e-mail do usuário e pressione Enter.",
            "Projects you want to allow access to": "Projetos aos quais você deseja permitir acesso",
            "Select the project you want to allow access to.": "Selecione o projeto ao qual deseja permitir acesso.",
            "Select the role you want to grant.": "Selecione a função que deseja conceder.",
            "Search by user email.": "Buscar por e-mail do usuário.",
            "Delete this role?": "Excluir esta função?",
            "Deletion of {{domain}} {{item}} has been completed.": "A exclusão de {{domain}} {{item}} foi concluída.",
            "Duplication of {{domain}} {{item}} has been completed.": "A duplicação de {{domain}} {{item}} foi concluída.",
            "Creation of {{domain}} {{item}} has been completed.": "A criação de {{domain}} {{item}} foi concluída.",
            "There is no custom metadata yet.": "Não há metadados personalizados ainda.",
            "To enter metadata, select one of the custom metadata options.": "Para inserir metadados, selecione uma das opções de metadados personalizados.",
            "Please enter a message. (Optional)": "Insira uma mensagem. (Opcional)",
            "Please enter user's name.": "Insira o nome do usuário.",
            "Select assets.": "Selecionar ativos.",
            "If you change the applied custom metadata, all data entered will be lost.": "Se você alterar os metadados personalizados aplicados, todos os dados inseridos serão perdidos.",
            "After AI analyzes the content, the field values of the selected content schema are automatically filled in. Only one schema can be selected.": "Após a IA analisar o conteúdo, os valores dos campos do esquema de conteúdo selecionado são preenchidos automaticamente. Apenas um esquema pode ser selecionado.",
            "Search by custom metadata name.": "Busque pelo nome dos metadados personalizados.",
            "There are no private comments.": "Não há comentários privados.",
            "Use the \"Create private comment\" button Make it.": "Use o botão \"Criar comentário privado\" para criá-lo.",
            "Enter name or email": "Inserir nome ou e-mail",
            "Please enter a message for your request (Optional)": "Insira uma mensagem para a sua solicitação (Opcional)",
            "Folder can only be deleted if there are no assets in the folder.": "A pasta só pode ser excluída se não houver ativos nela.",
            "Select collections in a specific folder?": "Selecionar coleções em uma pasta específica?",
            "This field is required.": "Este campo é obrigatório.",
            "Invalid invitation code or Your invitation link may have expired.": "Código de convite inválido ou seu link de convite pode ter expirado.",
            "Please contact your administrator to request a new invitation link.": "Entre em contato com o administrador para solicitar um novo link de convite.",
            "Hello,<NewLine/>Welcome to LX Hausys Design Library.": "Olá,<NewLine/>Bem-vindo à LX Hausys Design Library.",
            "Up to <strong>{{number}}</strong> attachments are allowed.": "São permitidos até <strong>{{number}}</strong> anexos.",
            "Please select up to <strong>{{number}}</strong> files and try again.": "Selecione até <strong>{{number}}</strong> arquivos e tente novamente.",
            "You are currently planning to upload <strong>{{added}}</strong> files. If you would like to attach another file, please remove the file and try again.": "Você está planejando fazer Upload de <strong>{{added}}</strong> arquivos. Se desejar anexar outro arquivo, remova um arquivo e tente novamente.",
            "You are currently planning to upload <strong>{{added}}</strong> files. Please select and attach up to <strong>{{remaining}}</strong> additional files.": "Você está planejando fazer Upload de <strong>{{added}}</strong> arquivos. Selecione e anexe até <strong>{{remaining}}</strong> arquivos adicionais.",
            "The maximum capacity per attachment is up to <strong>{{maxSize}}</strong>.": "A capacidade máxima por anexo é de até <strong>{{maxSize}}</strong>.",
            "The current file has exceeded its capacity. Please check the file to attach and try again.": "O arquivo atual excedeu sua capacidade. Verifique o arquivo a ser anexado e tente novamente.",
            "Asset {{item}} duplication completed.": "Duplicação do ativo {{item}} concluída.",
            "\"Custom Metadata\" can be applied to an asset’s custom metadata and is available when its status is enabled.": "“Metadados Personalizados” pode ser aplicado aos metadados personalizados de um ativo e fica disponível quando seu status está ativado.",
            "Enter required fields for “{{name}}” <0>{{count}}</0>/{{total}}": "Preencha os campos obrigatórios para “{{name}}” <0>{{count}}</0>/{{total}}",
            "and <0>{{count}}</0> more": "e mais <0>{{count}}</0>",
            "There is no data for this widget.": "Não há dados para este widget.",
            "There are no jobs yet.": "Não há tarefas ainda.",
            "This operation was not entirely successful.": "Esta operação não foi totalmente bem-sucedida.",
            "Failed to load preview image. Please again.": "Falha ao carregar a imagem de Pré-visualização. Tente novamente.",
            "Preview image Creating...": "Criando imagem de Pré-visualização...",
            "Failed to load preview image. <NewLine/>please try again.": "Falha ao carregar a imagem de Pré-visualização. <NewLine/>Por favor, tente novamente.",
            "Some assets are missing required metadata for electronic payment.<NewLine/> Please change the metadata type to Roll or Artwork and submit.": "Alguns ativos estão com metadados obrigatórios ausentes para pagamento eletrônico.<NewLine/> Altere o tipo de metadados para Roll ou Artwork e envie.",
            "Asset '{{name}}' has been requested.": "O ativo '{{name}}' foi solicitado.",
            "Asset '{{name}}' and {{count}} other assets have been requested.": "O ativo '{{name}}' e mais {{count}} outros ativos foram solicitados.",
            "Are you sure you want to turn off applying custom metadata?": "Tem certeza de que deseja desativar a aplicação de metadados personalizados?",
            "Attribution cannot be empty. Please enter a valid attribution.": "A atribuição não pode estar vazia. Insira uma atribuição válida.",
            "If you turn off Custom Apply All Data, your input data is gone and cannot be recovered.": "Se você desativar Aplicar Todos os Dados Personalizados, os dados inseridos serão perdidos e não poderão ser recuperados.",
            "Please search by role name": "Busque pelo nome da função",
            "Deleting the role “{{roleName}}” removes all permissions for users and groups set by that role.": "Excluir a função “{{roleName}}” remove todas as permissões de usuários e grupos definidas por essa função.",
            "The corresponding menu is selected in the project first entry screen settings above. If you do not want to display the menu, turn off the above settings.": "O menu correspondente é selecionado nas configurações da tela de entrada inicial do projeto acima. Se não quiser exibir o menu, desative as configurações acima.",
            "Creating access token.": "Criando token de acesso.",
            "Sucessfully created access token. Please check from the requested client.": "Token de acesso criado com sucesso. Verifique no cliente solicitado.",
            "Failed to create access token. Please try again from the requested client.": "Falha ao criar o token de acesso. Tente novamente no cliente solicitado.",
            "Please select files to add": "Selecione os arquivos a adicionar",
            "“{{name}}’ is in use in projects.<0/> If you wish to delete it, please disable the schema in the project you are using.": "'{{name}}' está em uso em projetos.<0/> Se desejar excluí-lo, desative o esquema no projeto em que está sendo utilizado.",
            "Select {{resourceType}} through search to put them in your custom content.": "Selecione {{resourceType}} por meio de busca para adicioná-los ao seu conteúdo personalizado.",
            "The selected item is rejected": "O item selecionado foi rejeitado",
            "The selected item is approved": "O item selecionado foi aprovado",
            "The private comment is deleted.": "O comentário privado foi excluído.",
            "There is no data": "Não há dados",
            "The selected item has been requested to be archived.": "O item selecionado teve o arquivamento solicitado.",
            "Please search by name": "Busque pelo nome",
            "Are you sure you want to delete that export file?": "Tem certeza de que deseja excluir este arquivo de exportação?",
            "If you delete a exported metadata, all settings and downloadable files will be deleted.": "Se você excluir os metadados exportados, todas as configurações e arquivos para Download serão excluídos.",
            "Search for a project.": "Buscar um projeto.",
            "Contains an overview of all selected assets.<NewLine/> The contents of hidden fields are revealed in the exported file.": "Contém uma visão geral de todos os ativos selecionados.<NewLine/> O conteúdo dos campos ocultos é revelado no arquivo exportado.",
            "There are no projects selected.": "Nenhum projeto selecionado.",
            "Creation of new Metadata Export {{item}} is completed": "A criação do novo Metadata Export {{item}} foi concluída",
            "No {{name}} items yet.": "Nenhum item de {{name}} ainda.",
            "The selected items have been requested to be archived.": "Os itens selecionados tiveram o arquivamento solicitado.",
            "You can choose a storage class to store your assets.": "Você pode escolher uma classe de armazenamento para guardar seus ativos.",
            "Please search by content schema name": "Busque pelo nome do esquema de conteúdo",
            "Please search by DisplayAs or SoundsLike.": "Busque por DisplayAs ou SoundsLike.",
            "A preview setting of '{{name}}' have been requested.": "Uma configuração de Pré-visualização de '{{name}}' foi solicitada.",
            "This file size can be up to {{maxByte}} bytes.": "O tamanho deste arquivo pode ser de até {{maxByte}} bytes.",
            "Things to keep in mind when entering words": "Informações importantes ao inserir palavras",
            "Words similar to spoken sounds - Only Korean characters can be entered.": "Palavras semelhantes a sons de fala - Apenas caracteres coreanos podem ser inseridos.",
            "If you want to create a URL, please change the status to Published.": "Se desejar criar uma URL, altere o status para Publicado.",
            "The changed options is applied when it is ‘ACTIVE’, and if it is ‘INACTIVE’, the options is reset when the pop-up is closed.": "As opções alteradas são aplicadas quando está 'ATIVO' e, se estiver 'INATIVO', as opções são redefinidas quando o pop-up é fechado.",
            "Please search by audit log resourceId.": "Busque pelo ID do recurso do log de auditoria.",
            "Please search by vocabulary book name.": "Busque pelo nome do vocabulário.",
            "You can enter English, numbers, spaces, and special characters (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?).": "Você pode inserir inglês, números, espaços e caracteres especiais (~!@#$%^&*()-_=+[{]}|;:'”“,<.>/?).",
            "Only English, -(Hyphen) can be entered.": "Apenas inglês e -(Hífen) podem ser inseridos.",
            "You can enter Korean, English, numbers, spaces, and special characters (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?).": "Você pode inserir coreano, inglês, números, espaços e caracteres especiais (~!@#$%^&*()-_=+[{]}|;:'”“,<.>/?).",
            "Only Korean can be entered.": "Apenas coreano pode ser inserido.",
            "An email will be sent to users with space admin permission.": "Um e-mail será enviado aos usuários com permissão de administrador do espaço.",
            "No reports have been sent yet.": "Nenhum relatório foi enviado ainda.",
            "{{action}} completed.": "{{action}} concluído.",
            "When you enable automatic archiving, <0>you will be billed immediately for 90 or 180 days</0>, depending on the storage class option you select.": "Ao ativar o arquivamento automático, <0>você será cobrado imediatamente por 90 ou 180 dias</0>, dependendo da opção de classe de armazenamento selecionada.",
            "This storage class is billed for <0>180 days</0> immediately after archiving.": "Esta classe de armazenamento é cobrada por <0>180 dias</0> imediatamente após o arquivamento.",
            "Video images cannot be captured.": "Não é possível capturar imagens de vídeo.",
            "To capture video images, the original source must contain an <0>mp4 or mov</0> file. <1/> Try capturing from a video or asset that has an mp4 or mov file.": "Para capturar imagens de vídeo, a fonte original deve conter um arquivo <0>mp4 ou mov</0>. <1/> Tente capturar a partir de um vídeo ou ativo que possua um arquivo mp4 ou mov.",
            "Are you sure you want to delete the link??": "Tem certeza de que deseja excluir o link?",
            "Deleted links cannot be restored.": "Links excluídos não podem ser restaurados.",
            "This recipient will no longer be able to download from this link. Revoked access cannot be restored.": "Este destinatário não poderá mais baixar a partir deste link. O acesso revogado não pode ser restaurado.",
            "Access has been revoked.": "O acesso foi revogado.",
            "Revoke this download link?": "Revogar este link de download?",
            "'{{subject}}' shared with {{sharedWith}} will no longer be downloadable.": "'{{subject}}' compartilhado com {{sharedWith}} não poderá mais ser baixado.",
            "A revoked link cannot be restored. Share again to send a new link.": "Um link revogado não pode ser restaurado. Compartilhe novamente para enviar um novo link.",
            "Download link revoked.": "Link de download revogado.",
            "Please add a link.": "Por favor, adicione um link.",
            "This field must be in URL format.": "Este campo deve estar no formato URL.",
            "Are you sure you want to delete this group?": "Tem certeza de que deseja excluir este grupo?",
            "Deleting the {{groupName}} group removes all permissions from users and roles set by that group.": "Excluir o grupo {{groupName}} remove todas as permissões de usuários e funções definidas por esse grupo.",
            "If the problem persists, <0/> please contact the administrator.": "Se o problema persistir, <0/> entre em contato com o administrador.",
            "Up to {{limit}} {{referenceType}} can be registered": "É possível registrar até {{limit}} {{referenceType}}",
            "Select Category Group": "Selecionar Grupo de Categoria",
            "Each menu (e.g. Assets) can be categorized into one category group.": "Cada menu (ex.: Ativos) pode ser categorizado em um grupo de categoria.",
            "Make sure the category group is in use <label>In use</label> status.": "Certifique-se de que o grupo de categoria está com o status <label>Em uso</label>.",
            "If you apply a different category group, you can check the items in the <strong>'Uncategorized'</strong> in the category view.": "Se você aplicar um grupo de categoria diferente, poderá verificar os itens em <strong>'Sem categoria'</strong> na visualização de categoria.",
            "No collection items yet.": "Nenhum item de coleção ainda.",
            "There are no assets selected.": "Nenhum ativo selecionado.",
            "Please select an item to enter the menu": "Selecione um item para entrar no menu",
            "Search by category name": "Buscar por nome de categoria",
            "There are no menus configured.": "Nenhum menu configurado.",
            "Use the \"Add Menu\" button to add it.": "Use o botão \"Adicionar Menu\" para adicionar.",
            "'{{item}}' has been created.": "'{{item}}' foi criado.",
            "This menu is set as the first entry screen of the project and cannot be hidden.": "Este menu está definido como a tela de entrada inicial do projeto e não pode ser ocultado.",
            "Please enter the menu name.": "Insira o nome do menu.",
            "Menu name can be up to {{maxByte}} bytes.": "O nome do menu pode ter até {{maxByte}} bytes.",
            "Please search by name.": "Busque pelo nome.",
            "Deletion of vocabulary book {{item}} has been completed.": "A exclusão do vocabulário {{item}} foi concluída.",
            "Deletion of vocabulary book {{item}} and {{count}} others has been completed.": "A exclusão do vocabulário {{item}} e mais {{count}} outros foi concluída.",
            "Content schema '{{name}}' has been created.": "O esquema de conteúdo '{{name}}' foi criado.",
            "Content schema '{{name}}' has been updated.": "O esquema de conteúdo '{{name}}' foi atualizado.",
            "Enter last name": "Inserir sobrenome",
            "Enter first name": "Inserir nome",
            "It's not possible to proceed as the archived menu isn't being used.": "Não é possível continuar, pois o menu arquivado não está em uso.",
            "Asset lock has been disabled.": "O bloqueio do ativo foi desativado.",
            "Asset lock has been enabled.": "O bloqueio do ativo foi ativado.",
            "Lock this asset": "Bloquear este ativo",
            "Select a category from the category group.": "Selecione uma categoria do grupo de categorias.",
            "Sharing Period and Number of Downloads have expired. You can reset it.": "O Período de Compartilhamento e o Número de Downloads expiraram. Você pode redefinir.",
            "Number of Downloads has expired. You can reset it.": "O Número de Downloads expirou. Você pode redefinir.",
            "Sharing Period has expired. You can reset it.": "O Período de Compartilhamento expirou. Você pode redefinir.",
            "There are no shared users.": "Não há usuários compartilhados.",
            "Processing download request...": "Processando solicitação de Download...",
            "If you delete “{{name}}”, this property will be removed from all assets using this content schema, and it cannot be recovered.": "Se você excluir “{{name}}”, esta propriedade será removida de todos os ativos que utilizam este esquema de conteúdo e não poderá ser recuperada.",
            "Drag and drop your file here, or upload a file from your PC or cloud.": "Arraste e solte seu arquivo aqui, ou faça Upload de um arquivo do seu PC ou nuvem.",
            "Go to the start page and select a project you have access to.": "Vá para a página inicial e selecione um projeto ao qual você tem acesso.",
            "If you don’t have access to any projects, please contact your administrator.": "Se você não tiver acesso a nenhum projeto, entre em contato com o administrador.",
            "Please use the button below to go to the start page.": "Use o botão abaixo para ir à página inicial.",
            "There is no page available for this comment.": "Não há página disponível para este comentário.",
            "You do not have permission to access the page.": "Você não tem permissão para acessar a página.",
            "The custom metadata used in the asset is disabled.": "Os metadados personalizados utilizados no ativo estão desativados.",
            "Selecting Use will make your project assets visible in the full asset search results. This may take some time to apply, depending on the amount of data.": "Ao selecionar Usar, os ativos do seu projeto ficarão visíveis nos resultados da busca completa de ativos. Isso pode levar algum tempo para ser aplicado, dependendo da quantidade de dados.",
            "Data accessed through expedited retrieval for all objects except the largest archive objects (250MB or larger) is typically available within 1-5 minutes.": "Os dados acessados por recuperação acelerada para todos os objetos, exceto os maiores objetos de arquivo (250MB ou mais), geralmente ficam disponíveis em 1-5 minutos.",
            "When restoring, Deep Archive storage will be charged for a minimum of 180 days, and other storage classes will be charged for a minimum of 90 days.": "Ao restaurar, o armazenamento Deep Archive será cobrado por um mínimo de 180 dias, e outras classes de armazenamento serão cobradas por um mínimo de 90 dias.",
            "You will be charged when restoring an asset.": "Você será cobrado ao restaurar um ativo.",
            "AI analysis identifies people, actions, and risk factors in videos and can automatically generate subtitles and text.": "A análise de IA identifica pessoas, ações e fatores de risco em vídeos e pode gerar automaticamente legendas e texto.",
            "Please save or cancel your changes before adding a new task.": "Salve ou cancele suas alterações antes de adicionar uma nova tarefa.",
            "Please set the Input Path.": "Defina o Caminho de Entrada.",
            "Are you sure you want to delete the task?": "Tem certeza de que deseja excluir a tarefa?",
            "Deleting a task will cause all entered information to disappear and cannot be recovered.": "A exclusão de uma tarefa fará com que todas as informações inseridas desapareçam e não possam ser recuperadas.",
            "Please enter your email address and press Enter.": "Insira seu endereço de e-mail e pressione Enter.",
            "Share request to {{userName}}": "Solicitação de compartilhamento para {{userName}}",
            "Changed share options to {{permission}} permission": "Opções de compartilhamento alteradas para permissão {{permission}}",
            "Changed share options to {{permission}} permission until {{expireDate}}": "Opções de compartilhamento alteradas para permissão {{permission}} até {{expireDate}}",
            "Changed share options to {{permission}} permission until {{expireDate}} with max {{maxDownloads}} downloads": "Opções de compartilhamento alteradas para permissão {{permission}} até {{expireDate}} com máximo de {{maxDownloads}} downloads",
            "Changed share options to {{permission}} permission with max {{maxDownloads}} downloads": "Opções de compartilhamento alteradas para permissão {{permission}} com máximo de {{maxDownloads}} downloads",
            "Sharing with {{user}} was updated": "O compartilhamento com {{user}} foi atualizado",
            "Sharing with {{user}} was removed": "O compartilhamento com {{user}} foi removido",
            "Shared with {{user}}": "Compartilhado com {{user}}",
            "Shared with {{grantees}} permission": "Compartilhado com permissão {{grantees}}",
            "Shared with {{grantees}} permission until {{expireDate}}": "Compartilhado com permissão {{grantees}} até {{expireDate}}",
            "Shared with {{grantees}} permission until {{expireDate}} with max {{maxDownloads}} downloads": "Compartilhado com permissão {{grantees}} até {{expireDate}} com máximo de {{maxDownloads}} downloads",
            "Shared with {{grantees}} permission with max {{maxDownloads}} downloads": "Compartilhado com permissão {{grantees}} com máximo de {{maxDownloads}} downloads",
            "Shared link to {{names}}": "Link compartilhado com {{names}}",
            "It's not possible to proceed as the {{menuName}} menu isn't being used.": "Não é possível continuar, pois o menu {{menuName}} não está em uso.",
            "No users have been registered yet.": "Nenhum usuário registrado ainda.",
            "Click the User invitation button at the top to add a user.": "Clique no botão de convite de usuário no topo para adicionar um usuário.",
            "Please search by name or email": "Busque pelo nome ou e-mail",
            "Search by project name": "Buscar por nome do projeto",
            "Search by bucket name": "Buscar por nome do bucket",
            "\"{{name}}\" will be deleted forever and you won't be abled to restore it.": "“{{name}}” será excluído permanentemente e não poderá ser restaurado.",
            "\"{{name}}\" and {{count}} others will be deleted forever and you won't be abled to restore it.": "“{{name}}” e mais {{count}} outros serão excluídos permanentemente e não poderão ser restaurados.",
            "The service is located in {{region}}.": "O serviço está localizado em {{region}}.",
            "Please select a region.": "Selecione uma região.",
            "Please copy the JSON below to create an IAM Permission.": "Copie o JSON abaixo para criar uma Permissão IAM.",
            "Please apply the role trust relationship by replacing {REPLACE_WITH_YOUR_EXTERNAL_ACCOUNT_ID} in the JSON below with the account ID you want to use.": "Aplique o relacionamento de confiança de função substituindo {REPLACE_WITH_YOUR_EXTERNAL_ACCOUNT_ID} no JSON abaixo pelo ID da conta que deseja usar.",
            "Please copy the Role ARN and paste it into the external account input field for <0>AWS account connection</0>.": "Copie o Role ARN e cole-o no campo de entrada de conta externa para <0>conexão de conta AWS</0>.",
            "Please enter the AWS Role ARN.": "Insira o AWS Role ARN.",
            "Please search by user name.": "Busque pelo nome do usuário.",
            "Please search by group name.": "Busque pelo nome do grupo.",
            "Please select a new owner": "Selecione um novo proprietário",
            "Changing the owner may result in the existing owner losing permissions and some features being restricted.": "Alterar o proprietário pode resultar na perda de permissões do proprietário atual e na restrição de alguns recursos.",
            "Are you sure you want to delete this?": "Tem certeza de que deseja excluir isto?",
            "Please click Add roles button to grant roles to this user.": "Clique no botão Adicionar funções para conceder funções a este usuário.",
            "No group is granted": "Nenhum grupo concedido",
            "There are no groups yet.": "Não há grupos ainda.",
            "Please click Manage Access button to add group to this project.": "Clique no botão Gerenciar Acesso para adicionar um grupo a este projeto.",
            "There are no users yet.": "Não há usuários ainda.",
            "Please click Manage Access button to add user to this project.": "Clique no botão Gerenciar Acesso para adicionar um usuário a este projeto.",
            "You can create up to {{n}} tags.": "Você pode criar até {{n}} tags.",
            "Update owner to {{name}}": "Atualizar proprietário para {{name}}",
            "URL not found": "URL não encontrada",
            "The URL has been deleted or the menu does not exist.": "A URL foi excluída ou o menu não existe.",
            "You must enter your credentials to use the engine.": "Você deve inserir suas credenciais para usar o mecanismo.",
            "When uploading via pop-up, empty folders are excluded.<NewLine/> To upload empty folders as well, please drag the folders directly into the asset list.": "Ao fazer Upload via pop-up, pastas vazias são excluídas.<NewLine/> Para fazer Upload de pastas vazias também, arraste as pastas diretamente para a lista de ativos.",
            "If the capacity is more than {{limit}}, the print file will be automatically extracted and automatic captions will be generated.": "Se a capacidade for superior a {{limit}}, o arquivo de impressão será extraído automaticamente e as legendas automáticas serão geradas.",
            "It is only available at the all project level.": "Disponível apenas no nível de todos os projetos.",
            "There is no data available.": "Não há dados disponíveis.",
            "The maximum upload size is {{size}}.": "O tamanho máximo de Upload é {{size}}.",
            "Please select a repository.": "Por favor, selecione um repositório.",
            "Remove user from role?": "Remover usuário da função?",
            "If you remove the user {{userName}}, assigned permission will be removed.": "Se você remover o usuário {{userName}}, a permissão atribuída será removida.",
            "Remove group from role?": "Remover grupo da função?",
            "If you remove the group {{groupName}}, assigned permission will be removed.": "Se você remover o grupo {{groupName}}, a permissão atribuída será removida.",
            "There is no file.": "Não há arquivo.",
            "mentioned you in a comment": "mencionou você em um comentário",
            "replied to your comment": "respondeu ao seu comentário",
            "invited you to a private comment": "convidou você para um comentário privado",
            "There are no notifications yet.": "Ainda não há notificações.",
            "Notifications will be deleted after 7 days.": "As notificações serão excluídas após 7 dias.",
            "The item does not exist": "O item não existe",
            "Analysis completed, but there are no results for {{name}}.": "Análise concluída, mas não há resultados para {{name}}.",
            "An error occurred during analysis and the operation could not be completed.": "Ocorreu um erro durante a análise e a operação não pôde ser concluída.",
            "Analyzing now uses the proxy video.": "A análise agora usará o vídeo proxy.",
            "The proxy video is still being created, so analyzing now uses the original and takes longer.": "O vídeo proxy ainda está sendo criado, portanto analisar agora usará o original e levará mais tempo.",
            "The proxy video could not be created, so it is analyzed with the original.": "Não foi possível criar o vídeo proxy, então a análise usa o original.",
            "There is no proxy video, so it is analyzed with the original.": "Não há vídeo proxy, então a análise usa o original.",
            "Proxy videos are only created for assets registered after auto generation is turned on.": "Vídeos proxy são criados apenas para ativos registrados após a geração automática ser ativada.",
            "There was a problem for a moment.": "Houve um problema por um momento.",
            "There was a problem processing your request. Please try again later.": "Houve um problema ao processar sua solicitação. Por favor, tente novamente mais tarde.",
            "AI usage quota has been exceeded.": "A cota de uso de IA foi excedida.",
            "You have reached the AI usage limit. Please contact your administrator to increase the quota.": "Você atingiu o limite de uso de IA. Entre em contato com seu administrador para aumentar a cota.",
            "No values were extracted.": "Nenhum valor foi extraído.",
            "The analysis finished, but no values matching the schema fields were returned. Retrying may produce the same result.": "A análise foi concluída, mas nenhum valor correspondente aos campos do esquema foi retornado. Tentar novamente pode produzir o mesmo resultado.",
            "I recommend the video highlights.": "Recomendo os destaques do vídeo.",
            "Enter a prompt for AI": "Insira um prompt para IA",
            "What can I help with?": "Como posso ajudar?",
            "Please enter the prompt.": "Por favor, insira o prompt.",
            "Preset status has been updated.": "O status do preset foi atualizado.",
            "Deletion of preset {{item}} has been completed.": "A exclusão do preset {{item}} foi concluída.",
            "Preset has been duplicated successfully.": "O preset foi duplicado com sucesso.",
            "Failed to send the prompt preset.": "Falha ao enviar a predefinição de prompt.",
            "'{{name}}' will be deleted forever and you won't be able to restore it.": "'{{name}}' será excluído permanentemente e não será possível restaurá-lo.",
            "No preset items yet.": "Nenhum item de preset ainda.",
            "No content schema items yet.": "Nenhum item de esquema de conteúdo ainda.",
            "Create it using the “Create” button.": "Crie usando o botão \"Criar\".",
            "To use the AI-Workspace, the original source must contain an <0>mp4 or mov</0> file.": "Para usar o AI-Workspace, a fonte original deve conter um arquivo <0>mp4 ou mov</0>.",
            "Name is required.": "O nome é obrigatório.",
            "Prompt is required.": "O prompt é obrigatório.",
            "The selected tags have been saved to the metadata.": "As tags selecionadas foram salvas nos metadados.",
            "Please select the required items from the recommended tags.": "Por favor, selecione os itens necessários entre as tags recomendadas.",
            "Please select a template.": "Por favor, selecione um modelo.",
            "Your session has expired. Please start a new conversation.": "Sua sessão expirou. Por favor, inicie uma nova conversa.",
            "Generating results": "Gerando resultados",
            "There is no description yet. Bring an AI description or enter it directly.": "Ainda não há descrição. Traga uma descrição de IA ou insira diretamente.",
            "Please write a description.": "Por favor, escreva uma descrição.",
            "To capture video images, it must be an <0>mp4 or mov</0> file. <1/> Try capturing from mp4 or mov assets.": "Para capturar imagens de vídeo, deve ser um arquivo <0>mp4 ou mov</0>. <1/> Tente capturar de ativos mp4 ou mov.",
            "The video cannot be edited.": "O vídeo não pode ser editado.",
            "To edit a video, it must be an <0>mp4 or mov</0> file. <1/> Edit in mp4 or mov assets.": "Para editar um vídeo, deve ser um arquivo <0>mp4 ou mov</0>. <1/> Edite em ativos mp4 ou mov.",
            "To edit a video, the original source must contain an <0>mp4 or mov</0> file. <1/> Edit videos or assets that contain mp4 or mov files.": "Para editar um vídeo, a fonte original deve conter um arquivo <0>mp4 ou mov</0>. <1/> Edite vídeos ou ativos que contenham arquivos mp4 ou mov.",
            "You can play it directly on mobile with the QR code.": "Você pode reproduzir diretamente no celular com o código QR.",
            "Analyze videos with AI": "Analise vídeos com IA",
            "to easily manage your videos.": "para gerenciar seus vídeos facilmente.",
            "Video AI analysis can extract labels for specific people, objects, patterns, and actions in videos, and manage inappropriate or dangerous content.": "A análise de vídeo por IA pode extrair rótulos de pessoas específicas, objetos, padrões e ações em vídeos, e gerenciar conteúdo inapropriado ou perigoso.",
            "Additionally, it can automatically convert video audio to text and automatically generate captions to easily manage videos.": "Além disso, pode converter automaticamente o áudio do vídeo em texto e gerar legendas automaticamente para gerenciar vídeos facilmente.",
            "{{resourceName}} '{{name}}' has been added.": "{{resourceName}} '{{name}}' foi adicionado.",
            "{{resourceName}} '{{name}}' and {{count}} others have been added.": "{{resourceName}} '{{name}}' e mais {{count}} foram adicionados.",
            "This field can be up to {{maxLength}} characters.": "Este campo pode ter até {{maxLength}} caracteres.",
            "The description can be up to {{maxLength}} characters long.": "A descrição pode ter até {{maxLength}} caracteres.",
            "The comment field can be up to {{maxLength}} characters long.": "O campo de comentário pode ter até {{maxLength}} caracteres.",
            "Menu name can be up to {{maxLength}} bytes.": "O nome do menu pode ter até {{maxLength}} bytes.",
            "The description can be up to {{maxLength}} characters": "A descrição pode ter até {{maxLength}} caracteres",
            "Request to create download link successfully": "Solicitação de criação de link de Download realizada com sucesso",
            "Auto set by {{name}}": "Definido automaticamente por {{name}}",
            "request completed": "solicitação concluída",
            "Each menu (e.g. Asset) can categorize items by setting one category group.": "Cada menu (ex.: Ativo) pode categorizar itens definindo um grupo de categoria.",
            "Make sure the category group is currently <InUse>In Use</InUse> for the target menu (e.g. Asset).": "Certifique-se de que o grupo de categoria está atualmente <InUse>Em Uso</InUse> para o menu de destino (ex.: Ativo).",
            "If you apply a different category group, those items can be found under '<NotClassified>Categories Not Classified into Assets</NotClassified>' in the category view.": "Se você aplicar um grupo de categoria diferente, esses itens poderão ser encontrados em '<NotClassified>Categorias Não Classificadas em Ativos</NotClassified>' na visualização de categorias.",
            "Category groups allow you to classify and manage items conveniently.": "Os grupos de categoria permitem classificar e gerenciar itens de forma conveniente.",
            "Assets can be created successfully only when no values are empty. If not used, please delete.": "Os ativos podem ser criados com sucesso somente quando nenhum valor estiver vazio. Se não for usado, exclua.",
            "The name field be up to {{title}} characters long.": "O campo de nome pode ter até {{title}} caracteres.",
            "The selected {{type}} has been saved to the metadata.": "O {{type}} selecionado foi salvo nos metadados.",
            "ㆍSingle IP : xxx.xxx.xxx.xxx\n ㆍIP Range : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\n ㆍCIDR : xxx.xxx.xxx.xxx/yy\n ㆍSeparate by newlines": "ㆍIP Único: xxx.xxx.xxx.xxx\n ㆍIntervalo de IP: xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\n ㆍCIDR: xxx.xxx.xxx.xxx/yy\n ㆍSepare por linhas",
            "Add it using the “Add Collection” button.": "Adicione usando o botão \"Adicionar Coleção\".",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n ㆍseparate by newlines": "ㆍCIDR: xxx.xxx.xxx.xxx/yy\n \n ㆍsepare por linhas",
            "This is not a valid URL pattern": "Este não é um padrão de URL válido",
            "If you delete <0>{{name}}</0>, You won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "Se você excluir <0>{{name}}</0>, não será possível reverter isso.<1/>Tem certeza de que deseja excluir <0>{{name}}</0>?",
            "If you archive the asset, you will be charged <0>the {{n}}-day</0> archive amount immediately.": "Se você arquivar o ativo, será cobrado imediatamente <0>o valor de arquivamento de {{n}} dias</0>.",
            "up to <0> {{number}} </0> days.": "até <0> {{number}} </0> dias.",
            "Creation of event trigger has been completed.": "A criação do gatilho de evento foi concluída.",
            "Please search by folder name": "Busque pelo nome da pasta",
            "Folder": "Pasta",
            "invited you to a thread": "convidou você para um tópico",
            "You will be notified by email <0/> whether the asset has been shared.": "Você será notificado por e-mail <0/> se o ativo foi compartilhado.",
            "The description has been updated.": "A descrição foi atualizada.",
            "Up to 50 {{referenceType}}s can be registered": "Até 50 {{referenceType}}s podem ser registrados",
            "The status has been changed.": "O status foi alterado.",
            "Are you sure you want to delete this workflow?": "Tem certeza de que deseja excluir este fluxo de trabalho?",
            "If you delete this workflow, it cannot be recovered.": "Se você excluir este fluxo de trabalho, ele não poderá ser recuperado.",
            "An event that triggers the workflow to run.": "Um evento que aciona a execução do fluxo de trabalho.",
            "Branches the workflow based on conditions.": "Ramifica o fluxo de trabalho com base em condições.",
            "Proceeds to the next step when the task is completed.": "Prossegue para a próxima etapa quando a tarefa é concluída.",
            "When the created asset's media type is {{values}}": "Quando o tipo de mídia do ativo criado for {{values}}",
            "When the file extension is {{values}}": "Quando a extensão do arquivo for {{values}}",
            "Branch files based on file extension": "Ramificar arquivos com base na extensão do arquivo",
            "Branch files based on file size": "Ramificar arquivos com base no tamanho do arquivo",
            "Branch files based on media type": "Ramificar arquivos com base no tipo de mídia",
            "Branch files based on asset size": "Ramificar arquivos com base no tamanho do ativo",
            "When an object is created in the S3 bucket": "Quando um objeto é criado no bucket S3",
            "When an asset is created in the current project": "Quando um ativo é criado no projeto atual",
            "Submit transcode task to pipeline": "Enviar tarefa de transcodificação para o pipeline",
            "Create an asset from a file (waits until preview extraction completes)": "Criar um ativo a partir de um arquivo (aguarda até a extração da pré-visualização ser concluída)",
            "Attach metadata to asset": "Anexar metadados ao ativo",
            "System preset-based single type job": "Tarefa de tipo único baseada em preset do sistema",
            "Archive to the specified storage class": "Arquivar na classe de armazenamento especificada",
            "Publish a video to SNS": "Publicar um vídeo no SNS",
            "This trigger has no additional conditions.": "Este gatilho não tem condições adicionais.",
            "Exactly one of {{keys}} is required": "Exatamente um de {{keys}} é obrigatório",
            "One of {{keys}} is required": "Um de {{keys}} é obrigatório",
            "{{keys}} cannot be used together": "{{keys}} não podem ser usados juntos",
            "Use AI workspace metadata.": "Use os metadados do espaço de trabalho de IA.",
            "Enter manually.": "Insira manualmente.",
            "Describe the scene or features in the video you are looking for!": "Descreva a cena ou as características do vídeo que você procura!",
            "Data updated at {{timestamp}} ({{offset}})": "Dados atualizados em {{timestamp}} ({{offset}})",
            "Based on {{start}} ~ {{end}} ({{offset}})": "Com base em {{start}} ~ {{end}} ({{offset}})",
            "{{month}} settlement confirmed": "Fechamento de {{month}} confirmado",
            "{{percent}}% in use": "{{percent}}% em uso",
            "Concurrent session limit {{max}}": "Limite de sessões simultâneas {{max}}",
            "Monthly base fee {{fee}}": "Taxa base mensal {{fee}}",
            "Monthly base fee none": "Sem taxa base mensal",
            "Base fee : {{fee}}": "Taxa base mensal : {{fee}}",
            "Base fee : none": "Taxa base mensal : nenhuma",
            "Usage fee : {{minutes}} min × {{rate}}": "Taxa de uso : {{minutes}} min × {{rate}}",
            "Usage fee : {{minutes}} min": "Taxa de uso : {{minutes}} min",
            "{{days}} days": "{{days}} dias",
            "Failed to load billing information.": "Falha ao carregar as informações de cobrança.",
            "There is no active subscription for this tenant.": "Não há assinatura ativa para este locatário.",
            "ㆍSingle IP : xxx.xxx.xxx.xxx\nㆍIP Range : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\nㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍSeparate by newlines": "ㆍIP único : xxx.xxx.xxx.xxx\nㆍIntervalo de IP : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\nㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍSeparar por novas linhas",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍSeparar por novas linhas",
            "Clicking apply replaces the matching field of the custom metadata below the video with the extracted value.": "Ao clicar em aplicar, o campo correspondente dos metadados personalizados abaixo do vídeo é substituído pelo valor extraído.",
            "This segment has no duration, so it cannot be added.": "Este segmento não tem duração, portanto não pode ser adicionado.",
            "Replaces the current metadata with the selected preset schema's metadata and saves it. Changes cannot be undone.": "Substitui os metadados atuais pelos metadados do esquema da predefinição selecionada e os salva. As alterações não podem ser desfeitas.",
            "The current metadata is replaced with the metadata from the selected preset schema. You can revert to the previous state until the metadata is saved.": "Os metadados atuais são substituídos pelos metadados do esquema de preset selecionado. Você pode reverter ao estado anterior até que os metadados sejam salvos.",
            "Replaces the current metadata with the selected preset schema's metadata. You cannot save if required fields are empty. Enter the required values and then save.": "Substitui os metadados atuais pelos metadados do esquema da predefinição selecionada. Não é possível salvar se os campos obrigatórios estiverem vazios. Insira os valores obrigatórios e salve.",
            "Saving deletes the existing custom metadata and replaces it with the AI-extracted metadata. Changes cannot be undone. Do you want to continue?": "Ao salvar, os metadados personalizados existentes são excluídos e substituídos pelos metadados extraídos pela IA. As alterações não podem ser desfeitas. Deseja continuar?",
            "Saving deletes the existing custom metadata and replaces it with the current settings. Changes cannot be undone. Do you want to continue?": "Ao salvar, os metadados personalizados existentes são excluídos e substituídos pelas configurações atuais. As alterações não podem ser desfeitas. Deseja continuar?",
            "Select the items to save as custom metadata from the extracted values. You can edit the values before saving.": "Selecione entre os valores extraídos os itens que deseja salvar como metadados personalizados. Você pode editar os valores antes de salvar.",
            "The metadata has been saved.": "Os metadados foram salvos.",
            "This asset uses the <0>'{{current}}'</0> schema, which differs from the preset schema({{preset}}). Field-level replacement is not available; replacing the schema applies all extracted values and clears the existing input data.": "Este ativo usa o esquema <0>'{{current}}'</0>, que difere do esquema da predefinição({{preset}}). A substituição por campo não está disponível; substituir o esquema aplica todos os valores extraídos e apaga os dados já inseridos.",
            "Setting the preset schema({{preset}}) applies all extracted values.": "Definir o esquema da predefinição({{preset}}) aplica todos os valores extraídos.",
            "Set the preset schema to show it here.": "Defina o esquema da predefinição para exibi-lo aqui.",
            "Do you want to unpublish the public URL?": "Deseja cancelar a publicação da URL pública?",
            "Due to CDN cache, it may take up to a few minutes to actually block access.": "Devido ao cache do CDN, o bloqueio efetivo do acesso pode levar até alguns minutos.",
            "Each URL stays the same even if you update the file.": "Cada URL permanece a mesma mesmo se você atualizar o arquivo.",
            "Failed to copy the URL.": "Falha ao copiar a URL.",
            "Failed to open the URL.": "Falha ao abrir a URL.",
            "Failed to publish. Please try again later.": "Falha ao publicar. Tente novamente mais tarde.",
            "Failed to publish. Unpublish and try publishing again.": "Falha ao publicar. Cancele a publicação e tente publicar novamente.",
            "Failed to unpublish. Please try again later.": "Falha ao cancelar a publicação. Tente novamente mais tarde.",
            "Publishing the public URL has been requested.": "A publicação da URL pública foi solicitada.",
            "Publishing {{count}} captions has been requested.": "A publicação de {{count}} legendas foi solicitada.",
            "Publishing {{count}} images has been requested.": "A publicação de {{count}} imagens foi solicitada.",
            "The public URL has been copied.": "A URL pública foi copiada.",
            "The public URL has been unpublished.": "A publicação da URL pública foi cancelada.",
            "The public URL of <0>{{target}}</0> will no longer be accessible.": "A URL pública de <0>{{target}}</0> deixará de ser acessível.",
            "There is no published asset.": "Não há ativo publicado.",
            "This asset is published via CDN. The issued URL stays the same even if you update the file.": "Este ativo é publicado via CDN. A URL emitida permanece a mesma mesmo se você atualizar o arquivo.",
            "To share privately with specific users, use <0>Actions → Share link</0>.": "Para compartilhar de forma privada com usuários específicos, use <0>Ações → Compartilhar link</0>.",
            "Failed to load the public URL list.": "Falha ao carregar a lista de URLs públicas.",
            "You do not have permission to publish this asset.": "Você não tem permissão para publicar este ativo.",
            "{{count}} captions have been unpublished.": "A publicação de {{count}} legendas foi cancelada.",
            "{{count}} images have been unpublished.": "A publicação de {{count}} imagens foi cancelada.",
            "Invalid pattern.": "O formato não é válido.",
            "This field should be a number.": "Este campo deve ser um número.",
            "This field can be from {{min}} characters.": "Este campo aceita a partir de {{min}} caracteres.",
            "This field can be up to {{max}}.": "Este campo aceita até {{max}}.",
            "This field can be at least {{min}}.": "Este campo deve ser no mínimo {{min}}.",
            "Duplicate value.": "Valor duplicado.",
            "Already exists. Try something else.": "Já existe. Use outro valor.",
            "If you detach <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to detach <0>{{name}}</0>?": "Se você desanexar <0>{{name}}</0>, não será possível reverter.<1/>Tem certeza de que deseja desanexar <0>{{name}}</0>?",
            "The asset has <0>{{count}}</0> elements attached.<1/>If the asset is detached, the elements are also detached.": "Este ativo tem <0>{{count}}</0> elementos anexados.<1/>Se o ativo for desanexado, os elementos também serão desanexados.",
            "Remove connected MediaLive input.": "Remove a entrada do MediaLive conectada.",
            "<0>{{name}}</0> is in use.<1/> If you delete this template, you won’t be able to revert this.<1/> Are you sure you want to delete?": "<0>{{name}}</0> está em uso.<1/> Se você excluir este modelo, não será possível reverter.<1/> Tem certeza de que deseja excluir?",
            "Empty values must be filled in when actually used.": "Ao usar de fato, os valores vazios devem ser preenchidos obrigatoriamente.",
            "If you delete <0>{{count}}</0> other than <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{count}}</0> other than <0>{{name}}</0>?": "Se você excluir <0>{{count}}</0> itens além de <0>{{name}}</0>, não será possível reverter.<1/>Tem certeza de que deseja excluir <0>{{count}}</0> itens além de <0>{{name}}</0>?",
            "If you remove all shares on <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to remove all shares on <0>{{name}}</0>?": "Se você remover todos os compartilhamentos de <0>{{name}}</0>, não será possível reverter.<1/>Tem certeza de que deseja remover todos os compartilhamentos de <0>{{name}}</0>?",
            "If you remove all shares on <0>{{count}}</0> other than <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to remove all shares on <0>{{count}}</0> other than <0>{{name}}</0>?": "Se você remover todos os compartilhamentos de <0>{{count}}</0> itens além de <0>{{name}}</0>, não será possível reverter.<1/>Tem certeza de que deseja remover todos os compartilhamentos de <0>{{count}}</0> itens além de <0>{{name}}</0>?",
            "If you remove <0>{{name}}</0>, the item is deleted from the view.<1/>Other users will still have access.<1/>Are you sure you want to remove the item?": "Se você remover <0>{{name}}</0>, o item é excluído da lista.<1/>Outros usuários continuarão tendo acesso.<1/>Tem certeza de que deseja remover o item?",
            "If you remove <0>{{count}}</0> other than <0>{{name}}</0>, the item is deleted from the view.<1/>Other users will still have access.<1/>Are you sure you want to remove the item?": "Se você remover <0>{{count}}</0> itens além de <0>{{name}}</0>, o item é excluído da lista.<1/>Outros usuários continuarão tendo acesso.<1/>Tem certeza de que deseja remover o item?",
            "Share request completed": "A solicitação de compartilhamento foi concluída.",
            "The selected item is restored": "O item selecionado foi restaurado.",
            "Error occurs!": "Ocorreu um erro.",
            "Create Completed.": "A criação foi concluída.",
            "Overlap other processing": "Sobrepõe-se a outro processamento.",
            "Users and teams added.": "Usuários e equipes foram adicionados.",
            "Please enter the subject.": "Insira o assunto.",
            "Lineups still exist on date": "Ainda existem lineups nessa data.",
            "Approval completed.": "A aprovação foi concluída.",
            "Rejection completed.": "A rejeição foi concluída.",
            "The Shared with list is Changed": "A lista de compartilhamento foi alterada.",
            "The selected item is Approved": "O item selecionado foi aprovado.",
            "The selected item is Rejected": "O item selecionado foi rejeitado.",
            "The selected item is Deleted": "O item selecionado foi excluído.",
            "This page isn't working. {{line}} Please contact the manager.": "Esta página não está funcionando. {{line}} Entre em contato com o administrador.",
            "Select {{resourceType}} through search to put them in your content.": "Selecione {{resourceType}} por meio da busca para inseri-los no seu conteúdo.",
            "Words to display - You can enter English, numbers, spaces, and special characters (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).": "Palavras a exibir - É possível inserir letras em inglês, números, espaços e caracteres especiais (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).",
            "Words similar to spoken sounds - Only English, -(Hyphen) can be entered.": "Palavras semelhantes ao som falado - Só é possível inserir letras em inglês e -(hífen).",
            "Words to display - You can enter Korean, English, numbers, spaces, and special characters (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).": "Palavras a exibir - É possível inserir coreano, letras em inglês, números, espaços e caracteres especiais (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).",
            "Deletion of vocabulary phrase {{item}} has been completed.": "A exclusão da palavra {{item}} foi concluída.",
            "Deletion of vocabulary phrase {{item}} and {{count}} others has been completed.": "A exclusão da palavra {{item}} e de outros {{count}} itens foi concluída.",
            "Failed to load analysis results.": "Falha ao carregar os resultados da análise.",
            "There are no video segments to edit for the selected labels.": "Não há segmentos de vídeo para editar nos rótulos selecionados.",
            "Imported {{segmentCount}} segments of {{labels}} selected in {{engine}} as edit segments.": "Importados <0>{{segmentCount}}</0> segmentos de <1>{{labels}}</1> selecionados em <2>{{engine}}</2> como segmentos de edição.",
            "You can select up to {{max}} labels.": "Você pode selecionar até {{max}} rótulos.",
            "All {{max}} timestamps selected. Deselect one to add another.": "Todos os {{max}} timestamps selecionados. Desmarque um para adicionar outro.",
            "AI analysis uses the proxy video.": "A Análise de IA usa o vídeo proxy.",
            "Creating a proxy video. Analyzing now uses the original and takes longer.": "Criando o vídeo proxy. Se analisar agora, o original será usado e levará mais tempo.",
            "The proxy video could not be created. AI analysis will use the original.": "Não foi possível criar o vídeo proxy. A Análise de IA usará o original.",
            "The proxy video is used by AI Analysis, AI Workspace, and the Adobe plugin.": "O vídeo proxy é usado pela Análise de IA, pelo AI Workspace e pelo plugin da Adobe.",
            "Without it, AI Analysis runs on the original and can be slow or fail on size limits, and the Adobe plugin downloads the original file. This choice applies to assets created from now on.": "Sem ele, a Análise de IA é executada no original, podendo ficar lenta ou falhar por limites de tamanho, e o plugin da Adobe baixa o arquivo original. Esta escolha se aplica aos ativos criados a partir de agora.",
            "No proxy video. Proxy auto-generation applies only to videos registered after it was selected.": "Não há vídeo proxy. A geração automática de proxy se aplica apenas aos vídeos registrados depois que ela foi ativada.",
            "Proxy video - a small copy used for AI analysis and preview.": "Vídeo proxy — uma cópia leve usada na Análise de IA e na pré-visualização.",
            "The start date must be on or before the end date.": "A data de início deve ser anterior ou igual à data de término.",
            "Finish or cancel the field being edited before saving.": "Conclua ou cancele o campo em edição antes de salvar.",
            "This value is not one of the allowed options.": "Este valor não está entre as opções permitidas.",
            "Assets closer to the top <0>match your search more accurately</0>.": "Os ativos mais próximos do topo <0>correspondem à sua busca com mais precisão</0>.",
            "Requests that failed. The file may have been deleted or the URL may have been unpublished.": "Solicitações que falharam. O arquivo pode ter sido excluído ou a URL pode ter sido despublicada."
        },
        "code": {
            "WORKFLOW_EMPTY_TREE_INCOMPLETE": "O fluxo de trabalho está vazio.",
            "WORKFLOW_MISSING_TRIGGER_INCOMPLETE": "Uma etapa TRIGGER é obrigatória.",
            "WORKFLOW_MISSING_END_INCOMPLETE": "Uma etapa END é obrigatória.",
            "WORKFLOW_MISSING_TASK_INCOMPLETE": "Pelo menos uma etapa de tarefa é obrigatória.",
            "WORKFLOW_START_NO_NEXT_INCOMPLETE": "A etapa START deve estar conectada a uma próxima etapa.",
            "WORKFLOW_UNTERMINATED_PATH_INCOMPLETE": "Todo caminho deve terminar em uma etapa END.",
            "WORKFLOW_CHOICE_NO_NEXT_INCOMPLETE": "A etapa de condição (CHOICE) deve ter uma próxima etapa.",
            "WORKFLOW_BRANCH_COUNT_INCOMPLETE": "Um bloco paralelo requer de 2 a 5 ramificações. Adicione mais ramificações.",
            "WORKFLOW_BRANCH_COUNT_FATAL": "Um bloco paralelo permite apenas de 2 a 5 ramificações.",
            "WORKFLOW_SHAPE_UNKNOWN_KEY_FATAL": "A etapa contém propriedades desconhecidas.",
            "WORKFLOW_SHAPE_NAME_FATAL": "O nome da etapa é inválido.",
            "WORKFLOW_SHAPE_SCHEMA_FATAL": "As informações de esquema da etapa são inválidas.",
            "WORKFLOW_SHAPE_CONDITION_FATAL": "O formato de condição da etapa é inválido.",
            "WORKFLOW_SHAPE_NEXT_FATAL": "A estrutura de próxima conexão da etapa é inválida.",
            "WORKFLOW_SHAPE_STEP_FATAL": "Uma etapa conectada tem uma estrutura inválida.",
            "WORKFLOW_NODE_CAP_FATAL": "O fluxo de trabalho excede o número máximo de etapas permitidas.",
            "WORKFLOW_BRANCH_NODE_CAP_FATAL": "Uma ramificação paralela excede o número máximo de etapas permitidas.",
            "WORKFLOW_ROOT_NOT_START_FATAL": "O fluxo de trabalho deve começar com uma etapa START.",
            "WORKFLOW_DUPLICATE_START_FATAL": "Só pode haver uma etapa START.",
            "WORKFLOW_DUPLICATE_TRIGGER_FATAL": "Só pode haver uma etapa TRIGGER.",
            "WORKFLOW_DUPLICATE_END_FATAL": "Só pode haver uma etapa END.",
            "WORKFLOW_TRIGGER_NOT_AFTER_START_FATAL": "Uma etapa TRIGGER deve vir imediatamente após a etapa START.",
            "WORKFLOW_DUPLICATE_NAME_FATAL": "Os nomes das etapas devem ser únicos.",
            "WORKFLOW_MULTIPLE_PARALLEL_FATAL": "Apenas um bloco paralelo é permitido.",
            "WORKFLOW_NAME_CHARSET_FATAL": "O nome da etapa contém caracteres inválidos.",
            "WORKFLOW_NAME_RESERVED_PREFIX_FATAL": "O nome da etapa não pode começar com um prefixo reservado (\"__\").",
            "WORKFLOW_UNKNOWN_SCHEMA_FATAL": "O esquema da etapa não existe no catálogo.",
            "WORKFLOW_CONDITION_SPEC_DEFERRED": "A condição da etapa não atende à especificação necessária.",
            "WORKFLOW_END_HAS_NEXT_FATAL": "A etapa END não pode ter uma próxima etapa.",
            "WORKFLOW_START_BRANCHES_FATAL": "A etapa START não pode se conectar diretamente a um bloco paralelo.",
            "WORKFLOW_NEXT_IS_START_FATAL": "Uma etapa não pode fazer transição para a etapa START.",
            "WORKFLOW_NESTED_PARALLEL_FATAL": "Blocos paralelos aninhados não são permitidos.",
            "WORKFLOW_NOT_PARALLELIZABLE_FATAL": "Esta etapa não pode ser usada como ramificação paralela.",
            "WORKFLOW_FORBIDDEN_IN_BRANCH_FATAL": "As etapas START, TRIGGER e END não podem ser usadas dentro de uma ramificação paralela.",
            "WORKFLOW_INPUT_NOT_SATISFIED_DEFERRED": "As condições de entrada da etapa não são satisfeitas pelas saídas disponíveis das etapas anteriores.",
            "WORKFLOW_DSL_NOT_BINDABLE_FATAL": "Este campo não permite uma vinculação DSL.",
            "WORKFLOW_DSL_MALFORMED_DEFERRED": "O formato de vinculação DSL é inválido.",
            "WORKFLOW_DSL_TARGET_NOT_FOUND_DEFERRED": "A vinculação DSL refere-se a uma etapa ou saída que não existe.",
            "WORKFLOW_DSL_OUT_OF_SCOPE_DEFERRED": "A vinculação DSL faz referência a uma etapa que está fora do escopo.",
            "OPERATION_ERROR": "A operação de armazenamento falhou.",
            "OPERATION_COMPLETED": "A operação de armazenamento foi bem-sucedida.",
            "OPERATION_PARTIAL_COMPLETED": "A operação solicitada foi parcialmente bem-sucedida.",
            "SUCCESS": "A operação foi bem-sucedida.",
            "S3_OPERATION_FAIL": "A operação falhou no armazenamento.",
            "NOT_EXIST_OBJECT_FROM_S3": "O arquivo não existe no armazenamento.",
            "NOT_EXIST_OBJECT_FROM_SOURCE_DB": "O registro não existe no banco de dados de índice.",
            "OVERLAP_OTHER_PROCESSING": "A operação falhou devido ao processo sobreposto.",
            "FAIL_TO_CHANGE_STATUS": "Ocorreu um erro ao alterar o estado do arquivo.",
            "USER_DECISION_REQUIRED": "Ocorrem arquivos duplicados; o usuário precisa escolher entre sobrescrever ou ignorar.",
            "UNKNOWN_ERROR": "Ocorreu um erro desconhecido.",
            "DOWNLOAD_JOB_REJECTED_BY_SIZE": "A tarefa de Download foi rejeitada devido ao tamanho do arquivo.",
            "DOWNLOAD_JOB_REJECTED_BY_COUNT": "A tarefa de Download foi rejeitada devido à quantidade de arquivos.",
            "DOWNLOAD_JOB_REJECTED_BY_FOLDER": "A tarefa de Download foi rejeitada porque a solicitação continha uma pasta.",
            "RESOURCE_NOT_FOUND": "O arquivo de origem foi excluído.",
            "OPERATION_FAILED": "A operação de armazenamento falhou.",
            "OPERATION_ABORTED": "A operação de armazenamento foi abortada.",
            "INTERNAL_ERROR": "Ocorreu um erro interno.",
            "CPA_INFO_PANEL_ASSETS_DESC_1": "Ativos são quaisquer arquivos de conteúdo que podem ser armazenados digitalmente e contêm metadados sobre os arquivos.",
            "CPA_INFO_PANEL_ASSETS_DESC_2": "Na página de ativos, você pode verificar a lista de ativos registrados, fazer Upload de um arquivo para torná-lo um ativo por meio de \"Adicionar Ativo\" ou editar/gerenciar/baixar as informações de um ativo existente.",
            "CPA_INFO_PANEL_ASSETS_ACTIONS_DESC": "<H4>Ações</H4>\nAo criar e gerenciar arquivos como ativos, você pode realizar as seguintes ações.\n<List>\n<ListItem>Adicionar imagens, documentos, arquivos de áudio e arquivos de vídeo de vários tipos de arquivo</ListItem>\n<ListItem>Adicionar ou editar informações de metadados para arquivos</ListItem>\n<ListItem>Agrupar e gerenciar ativos por meio de tags ou pastas</ListItem>\n<ListItem>Buscar por nome do ativo, ID, extensão, tipo de arquivo, proprietário, data de criação e tags</ListItem>\n</List>",
            "CPA_INFO_PANEL_ASSETS_GRID_DESC": "<H4>Layout em Grade/Lista</H4>\nA lista de ativos pode ser verificada em layout de grade ou lista e, quando definida para layout de lista, o usuário pode especificar se deve ou não expor a coluna da tabela.\n(Nome, Tipo, Tamanho, Acesso, Proprietário, Criado, Última Atualização)",
            "CPA_INFO_PANEL_ASSETS_ADD_DESC": "<H4>Adicionar Ativo</H4>\nVocê pode transformar arquivos em ativos clicando no botão \"Adicionar Ativos\" ou arrastando e soltando arquivos na lista.",
            "CPA_INFO_PANEL_ASSET_DETAIL_DESC": "Detalhes do Ativo permite verificar as informações detalhadas de um ativo.",
            "CPA_INFO_PANEL_ASSET_DETAIL_OVERVIEW_DESC": "<H4>Visão Geral</H4>\nA visão geral permite visualizar os detalhes básicos de um ativo, modificar seu acesso e localização de pasta.",
            "CPA_INFO_PANEL_ASSET_DETAIL_METADATA_DESC": "<H4>Metadados</H4>\nOs metadados permitem visualizar e editar informações de Atribuições e Tags.",
            "CPA_INFO_PANEL_ASSET_DETAIL_ACTION_DESC": "<H4>Ação</H4>\nVocê pode 'Download/Arquivar/Excluir' esses ativos.",
            "CPA_INFO_PANEL_ASSET_DETAIL_ARCHIVE_DESC": "<H4>Arquivar</H4>\nAs opções de arquivamento podem ser definidas pelo gerente do projeto nas configurações do projeto, podendo selecionar e usar S3 Glacier Flexible Retrieval / S3 Glacier Deep Archive.<NewLine/>\nOs arquivos arquivados são mais baratos, mas a recuperação leva tempo.",
            "CPA_INFO_PANEL_ASSET_SEARCH_DESC": "Você pode verificar os resultados da busca na lista de ativos.<NewLine/>\nVocê pode buscar pelo nome do ativo na barra de busca ou abrindo a janela de opções de busca e aplicando condições de busca detalhadas.",
            "CPA_INFO_PANEL_ASSET_SEARCH_OPTIONS_DESC": "<H4>Opções de Busca</H4>\nAs opções de busca incluem Nome do Ativo, ID, Extensão, Tipo, Proprietário, Criado e Tag. Você pode realizar uma busca detalhada de um ativo aplicando a opção detalhada desejada.",
            "CPA_INFO_PANEL_ASSET_SEARCH_GO_TO_DESC": "<H4>Ir para a Lista</H4>\nPara retornar à lista de ativos, basta clicar no botão 'Ir para a lista (←)'.",
            "CPA_INFO_PANEL_ADD_ASSETS_DESC": "Muitos tipos de arquivo diferentes podem ser transformados em ativos.",
            "CPA_INFO_PANEL_ADD_ASSETS_DETAILS_DESC": "<H4>Detalhes do Ativo</H4>\nVocê pode navegar pelos arquivos diretamente ou arrastar e soltar para ver os arquivos selecionados, e renomear os arquivos selecionados com o nome do ativo desejado.<NewLine/>\nAlém disso, você pode registrar como ativo selecionando se concede ou não acesso ao ativo e criando metadados.",
            "CPA_INFO_PANEL_ADD_ASSETS_ACCESS_DESC": "<H4>Acesso</H4>\nOs direitos de acesso podem ser selecionados como PÚBLICO/PRIVADO.<NewLine/>\nSe PÚBLICO for selecionado, fica aberto a todos; se PRIVADO for selecionado, fica privado para todos.",
            "Project:Assets:Archive": "Permissão de Arquivamento de Ativos.",
            "Project:Assets:Edit": "Permissão de Edição de Ativos.",
            "Project:Assets:Read": "Permissão de Leitura de Ativos.",
            "Project:Categories:Edit": "Permissão de Edição de Categorias.",
            "Project:Categories:Read": "Permissão de Leitura de Categorias.",
            "Project:Channels:Edit": "Permissão de Edição de Canais.",
            "Project:Channels:Read": "Permissão de Leitura de Canais.",
            "Project:Comments:Edit": "Permissão de Edição de Comentários.",
            "Project:Comments:Read": "Permissão de Leitura de Comentários.",
            "Project:CustomContents:Edit": "Permissão de Edição de Conteúdos Personalizados.",
            "Project:CustomContents:Read": "Permissão de Leitura de Conteúdos Personalizados.",
            "Project:Dashboard:Edit": "Permissão de Edição do Dashboard.",
            "Project:Dashboard:Read": "Permissão de Leitura do Dashboard.",
            "Project:Download:Download": "Permissão de Download.",
            "Project:Folders:Edit": "Permissão de Edição de Pastas.",
            "Project:Folders:Read": "Permissão de Leitura de Pastas.",
            "Project:IntegratedSearch:Read": "Permissão de Leitura de Busca Integrada.",
            "Project:InteractiveVideos:Edit": "Permissão de Edição de Vídeos Interativos.",
            "Project:InteractiveVideos:Read": "Permissão de Leitura de Vídeos Interativos.",
            "Project:Music:Edit": "Permissão de Edição de Música.",
            "Project:Music:Read": "Permissão de Leitura de Música.",
            "Project:People:Edit": "Permissão de Edição de Pessoas.",
            "Project:People:Read": "Permissão de Leitura de Pessoas.",
            "Project:Photo:Edit": "Permissão de Edição de Fotos.",
            "Project:Photo:Read": "Permissão de Leitura de Fotos.",
            "Project:Shares:External": "Permissão de Compartilhamentos Externos.",
            "Project:Shares:Internal": "Permissão de Compartilhamentos Internos.",
            "Project:Statistics:Edit": "Permissão de Edição de Estatísticas.",
            "Project:Statistics:Read": "Permissão de Leitura de Estatísticas.",
            "Project:Storages:Edit": "Permissão de Edição de Armazenamentos.",
            "Project:Storages:Read": "Permissão de Leitura de Armazenamentos.",
            "Project:Users&Groups:Read": "Permissão de Leitura de Usuários e Grupos.",
            "Project:Videos:Edit": "Permissão de Edição de Vídeos.",
            "Project:Videos:Publish": "Permissão de Publicação de Vídeos.",
            "Project:Videos:Read": "Permissão de Leitura de Vídeos.",
            "Project:Shares:InternalRequest": "Permissão de Solicitação Interna."
        },
        "audit": {
            "Retrieve list of Actions": "Recuperar lista de Ações",
            "Retrieve list of AI Face collections": "Recuperar lista de coleções de Face de IA",
            "Delete AI Face collection": "Excluir coleção de Face de IA",
            "Update AI Face collection": "Atualizar coleção de Face de IA",
            "Retrieve list of archived assets": "Recuperar lista de ativos arquivados",
            "Retrieve archived asset details": "Recuperar detalhes do ativo arquivado",
            "Restore archived asset": "Restaurar ativo arquivado",
            "Retrieve list of assets": "Recuperar lista de ativos",
            "Create asset": "Criar ativo",
            "Retrieve asset details": "Recuperar detalhes do ativo",
            "Update asset": "Atualizar ativo",
            "Delete asset": "Excluir ativo",
            "Activate asset": "Ativar ativo",
            "Archive asset": "Arquivar ativo",
            "Create file in asset": "Criar arquivo no ativo",
            "Add files to asset": "Adicionar arquivos ao ativo",
            "Delete file from asset": "Excluir arquivo do ativo",
            "Update file in asset": "Atualizar arquivo no ativo",
            "Update tags of asset": "Atualizar tags do ativo",
            "Delete tag from asset": "Excluir tag do ativo",
            "Inactivate asset": "Inativar ativo",
            "Attach People to asset": "Anexar Pessoas ao ativo",
            "Detach People from asset": "Desanexar Pessoas do ativo",
            "Retrieve asset status": "Recuperar status do ativo",
            "Retrieve upload URL for asset": "Recuperar URL de Upload para ativo",
            "Retrieve list of audit logs": "Recuperar lista de logs de auditoria",
            "Retrieve audit log details": "Recuperar detalhes do log de auditoria",
            "Send HEAD request to storage file": "Enviar solicitação HEAD para arquivo de armazenamento",
            "Retrieve list of category groups": "Recuperar lista de grupos de categoria",
            "Retrieve category group details": "Recuperar detalhes do grupo de categoria",
            "Update category group": "Atualizar grupo de categoria",
            "Delete category group": "Excluir grupo de categoria",
            "Retrieve list of categories": "Recuperar lista de categorias",
            "Create category": "Criar categoria",
            "Delete categories in bulk": "Excluir categorias em massa",
            "Retrieve category details": "Recuperar detalhes da categoria",
            "Update category": "Atualizar categoria",
            "Delete category": "Excluir categoria",
            "Retrieve list of CDNs": "Recuperar lista de CDNs",
            "Create CDN": "Criar CDN",
            "Retrieve CDN details": "Recuperar detalhes do CDN",
            "Update CDN": "Atualizar CDN",
            "Delete CDN": "Excluir CDN",
            "Retrieve list of channels": "Recuperar lista de canais",
            "Create channel": "Criar canal",
            "Retrieve channel details": "Recuperar detalhes do canal",
            "Update channel": "Atualizar canal",
            "Delete channel": "Excluir canal",
            "Update channel case": "Atualizar caso do canal",
            "Retrieve list of channel inputs": "Recuperar lista de entradas do canal",
            "Retrieve channel input details": "Recuperar detalhes da entrada do canal",
            "Retrieve channel encoder details": "Recuperar detalhes do encoder do canal",
            "Reclaim channel": "Recuperar canal",
            "Request channel approval": "Solicitar aprovação do canal",
            "Retrieve list of channel schedules": "Recuperar lista de agendamentos do canal",
            "Update channel schedules in bulk": "Atualizar agendamentos do canal em massa",
            "Delete channel schedules in bulk": "Excluir agendamentos do canal em massa",
            "Delete channel schedule": "Excluir agendamento do canal",
            "Retrieve channel schedule details": "Recuperar detalhes do agendamento do canal",
            "Update channel schedule": "Atualizar agendamento do canal",
            "Start channel": "Iniciar canal",
            "Retrieve channel state": "Recuperar estado do canal",
            "Stop channel": "Parar canal",
            "Request DRM token for video": "Solicitar token DRM para vídeo",
            "Retrieve Presigned URL of Master file for container format video": "Recuperar URL Presignada do arquivo Master para vídeo em formato de contêiner",
            "Retrieve Presigned URL of Daughter file for container format video": "Recuperar URL Presignada do arquivo Daughter para vídeo em formato de contêiner",
            "Retrieve list of transcode jobs": "Recuperar lista de tarefas de transcodificação",
            "Create transcode job": "Criar tarefa de transcodificação",
            "Create and start transcode job": "Criar e iniciar tarefa de transcodificação",
            "Retrieve upload URL for transcode job": "Recuperar URL de Upload para tarefa de transcodificação",
            "Retrieve transcode job details": "Recuperar detalhes da tarefa de transcodificação",
            "Update transcode job": "Atualizar tarefa de transcodificação",
            "Delete transcode job": "Excluir tarefa de transcodificação",
            "Cancel transcode job": "Cancelar tarefa de transcodificação",
            "Retrieve transcode job status": "Recuperar status da tarefa de transcodificação",
            "Correct transcode job status": "Corrigir status da tarefa de transcodificação",
            "Start transcode job": "Iniciar tarefa de transcodificação",
            "Retrieve list of listings": "Recuperar lista de listagens",
            "Create listing": "Criar listagem",
            "Retrieve listing details": "Recuperar detalhes da listagem",
            "Update listing": "Atualizar listagem",
            "Delete listing": "Excluir listagem",
            "Retrieve list of lineups": "Recuperar lista de lineups",
            "Create lineup": "Criar lineup",
            "Delete lineups in bulk": "Excluir lineups em massa",
            "Create lineups in bulk": "Criar lineups em massa",
            "Retrieve lineup details": "Recuperar detalhes do lineup",
            "Update lineup": "Atualizar lineup",
            "Delete lineup": "Excluir lineup",
            "Retrieve list of scheduled lineups after current time": "Recuperar lista de lineups agendados após o horário atual",
            "Retrieve list of localization resources": "Recuperar lista de recursos de localização",
            "Retrieve localization resource details": "Recuperar detalhes do recurso de localização",
            "Retrieve current user information": "Recuperar informações do usuário atual",
            "Retrieve list of Actions allowed for current user in project": "Recuperar lista de Ações permitidas para o usuário atual no projeto",
            "Retrieve list of Actions allowed for current user in space": "Recuperar lista de Ações permitidas para o usuário atual no espaço",
            "Request PoPs user synchronization": "Solicitar sincronização de usuários PoPs",
            "Retrieve list of metadata fields": "Recuperar lista de campos de metadados",
            "Create metadata field": "Criar campo de metadados",
            "Retrieve metadata field details": "Recuperar detalhes do campo de metadados",
            "Update metadata field": "Atualizar campo de metadados",
            "Delete metadata field": "Excluir campo de metadados",
            "Retrieve list of metadata schemas": "Recuperar lista de schemas de metadados",
            "Create metadata schema": "Criar schema de metadados",
            "Register metadata schema": "Registrar schema de metadados",
            "Retrieve metadata schema details": "Recuperar detalhes do schema de metadados",
            "Update metadata schema": "Atualizar schema de metadados",
            "Delete metadata schema": "Excluir schema de metadados",
            "Retrieve list of People": "Recuperar lista de Pessoas",
            "Create People": "Criar Pessoas",
            "Update People": "Atualizar Pessoas",
            "Delete People": "Excluir Pessoas",
            "Retrieve People details": "Recuperar detalhes de Pessoas",
            "Retrieve list of transcode pipelines": "Recuperar lista de pipelines de transcodificação",
            "Retrieve transcode pipeline details": "Recuperar detalhes do pipeline de transcodificação",
            "Retrieve embed URL": "Recuperar URL de incorporação",
            "Retrieve shared URL": "Recuperar URL compartilhada",
            "Retrieve list of SNS accounts": "Recuperar lista de contas SNS",
            "Create SNS account": "Criar conta SNS",
            "Retrieve SNS account details": "Recuperar detalhes da conta SNS",
            "Delete SNS account": "Excluir conta SNS",
            "Update SNS account": "Atualizar conta SNS",
            "Retrieve SNS posting history": "Recuperar histórico de publicações no SNS",
            "Retrieve list of videos posted to SNS": "Recuperar lista de vídeos publicados no SNS",
            "Post video to SNS": "Publicar vídeo no SNS",
            "Retrieve SNS video details": "Recuperar detalhes do vídeo no SNS",
            "Retrieve transcode profile details": "Recuperar detalhes do perfil de transcodificação",
            "Retrieve list of programmes": "Recuperar lista de programas",
            "Create programme": "Criar programa",
            "Retrieve programme details": "Recuperar detalhes do programa",
            "Update programme": "Atualizar programa",
            "Delete programme": "Excluir programa",
            "Retrieve list of projects": "Recuperar lista de projetos",
            "Create project": "Criar projeto",
            "Delete project": "Excluir projeto",
            "Retrieve project details": "Recuperar detalhes do projeto",
            "Update project": "Atualizar projeto",
            "Retrieve list of assignable members to project": "Recuperar lista de membros atribuíveis ao projeto",
            "Retrieve list of assignable teams to project": "Recuperar lista de equipes atribuíveis ao projeto",
            "Retrieve list of assigned project members": "Recuperar lista de membros atribuídos ao projeto",
            "Retrieve list of assigned project teams": "Recuperar lista de equipes atribuídas ao projeto",
            "Retrieve list of project members": "Recuperar lista de membros do projeto",
            "Assign member to project": "Atribuir membro ao projeto",
            "Unassign member from project": "Remover atribuição de membro do projeto",
            "Add storages to project": "Adicionar armazenamentos ao projeto",
            "Update project storages": "Atualizar armazenamentos do projeto",
            "Retrieve list of project teams": "Recuperar lista de equipes do projeto",
            "Assign team to project": "Atribuir equipe ao projeto",
            "Unassign team from project": "Remover atribuição de equipe do projeto",
            "Create player": "Criar Player",
            "Retrieve list of players": "Recuperar lista de Players",
            "Create player profile": "Criar perfil de Player",
            "Retrieve list of player profiles": "Recuperar lista de perfis de Player",
            "Retrieve player profile details": "Recuperar detalhes do perfil de Player",
            "Update player profile": "Atualizar perfil de Player",
            "Delete player profile": "Excluir perfil de Player",
            "Retrieve player details": "Recuperar detalhes do Player",
            "Update player": "Atualizar Player",
            "Delete player": "Excluir Player",
            "Create player resource": "Criar recurso de Player",
            "Retrieve list of player resources": "Recuperar lista de recursos de Player",
            "Retrieve player resource details": "Recuperar detalhes do recurso de Player",
            "Update player resource": "Atualizar recurso de Player",
            "Delete player resource": "Excluir recurso de Player",
            "Retrieve upload URL for resource": "Recuperar URL de Upload para recurso",
            "Create role": "Criar função",
            "Retrieve list of roles": "Recuperar lista de funções",
            "Retrieve role details": "Recuperar detalhes da função",
            "Update role": "Atualizar função",
            "Delete role": "Excluir função",
            "Attach permissions to role": "Anexar permissões à função",
            "Retrieve list of permissions in role": "Recuperar lista de permissões na função",
            "Detach permission from role": "Desanexar permissão da função",
            "Retrieve list of settings": "Recuperar lista de configurações",
            "Create project settings": "Criar configurações do projeto",
            "Delete project settings": "Excluir configurações do projeto",
            "Create space settings": "Criar configurações do espaço",
            "Delete space settings": "Excluir configurações do espaço",
            "Create statistics": "Criar estatísticas",
            "Retrieve list of statistics widget groups": "Recuperar lista de grupos de widgets de estatísticas",
            "Create statistics widget group": "Criar grupo de widgets de estatísticas",
            "Delete statistics widget group": "Excluir grupo de widgets de estatísticas",
            "Retrieve list of widgets in specific statistics widget group": "Recuperar lista de widgets no grupo específico de widgets de estatísticas",
            "Update statistics widgets": "Atualizar widgets de estatísticas",
            "Retrieve list of statistics widgets": "Recuperar lista de widgets de estatísticas",
            "Create statistics Aggregation": "Criar Agregação de estatísticas",
            "Create statistics Feature": "Criar Recurso de estatísticas",
            "Create statistics Resource": "Criar Recurso de estatísticas",
            "Retrieve list of stream inputs": "Recuperar lista de entradas de stream",
            "Create stream input": "Criar entrada de stream",
            "Retrieve list of whitelists": "Recuperar lista de listas de permissões",
            "Retrieve stream input details": "Recuperar detalhes da entrada de stream",
            "Update stream input": "Atualizar entrada de stream",
            "Delete stream input": "Excluir entrada de stream",
            "Retrieve list of teams": "Recuperar lista de equipes",
            "Retrieve team details": "Recuperar detalhes da equipe",
            "Retrieve list of team members": "Recuperar lista de membros da equipe",
            "Retrieve list of event triggers": "Recuperar lista de gatilhos de eventos",
            "Create event trigger": "Criar gatilho de evento",
            "Retrieve event trigger details": "Recuperar detalhes do gatilho de evento",
            "Delete event trigger": "Excluir gatilho de evento",
            "Update event trigger": "Atualizar gatilho de evento",
            "Retrieve upload URL for event trigger": "Recuperar URL de Upload para gatilho de evento",
            "Retrieve list of users": "Recuperar lista de usuários",
            "Retrieve user details": "Recuperar detalhes do usuário",
            "Update user": "Atualizar usuário",
            "Delete user": "Excluir usuário",
            "Retrieve list of videos": "Recuperar lista de vídeos",
            "Create video": "Criar vídeo",
            "Retrieve video details": "Recuperar detalhes do vídeo",
            "Update video": "Atualizar vídeo",
            "Delete video": "Excluir vídeo",
            "Activate video": "Ativar vídeo",
            "Request caption creation via video": "Solicitar criação de legenda via vídeo",
            "Delete caption from video": "Excluir legenda do vídeo",
            "Update caption in video": "Atualizar legenda no vídeo",
            "Inactivate video": "Inativar vídeo",
            "Attach People to video": "Anexar Pessoas ao vídeo",
            "Detach People from video": "Desanexar Pessoas do vídeo",
            "Create posters for video in bulk": "Criar posters para vídeo em massa",
            "Delete poster from video": "Excluir poster do vídeo",
            "Create SNS posting for video": "Criar publicação no SNS para vídeo",
            "Retrieve video status": "Recuperar status do vídeo",
            "Retrieve Thumbnail profiles for video": "Recuperar perfis de Miniatura para vídeo",
            "Create category group": "Criar grupo de categorias",
            "Retrieve list of Resource Buckets": "Recuperar lista de Buckets de Recursos",
            "Create Resource Buckets in bulk": "Criar Buckets de Recursos em massa",
            "Retrieve list of files in asset": "Recuperar lista de arquivos no ativo",
            "Retrieve list of Searchable Buckets": "Recuperar lista de Buckets Pesquisáveis",
            "Create Searchable Bucket": "Criar Bucket Pesquisável",
            "Delete Searchable Bucket": "Excluir Bucket Pesquisável",
            "Retrieve Searchable Bucket details": "Recuperar detalhes do Bucket Pesquisável",
            "Update Searchable Bucket": "Atualizar Bucket Pesquisável",
            "Register Searchable Bucket": "Registrar Bucket Pesquisável",
            "Delete schedule": "Excluir agendamento",
            "Retrieve list of asset types": "Recuperar lista de tipos de ativos",
            "Create asset type": "Criar tipo de ativo",
            "Retrieve list of asset extensions": "Recuperar lista de extensões de ativos",
            "Create asset extension": "Criar extensão de ativo",
            "Retrieve schedule details": "Recuperar detalhes do agendamento",
            "Retrieve list of schedules": "Recuperar lista de agendamentos",
            "Delete schedules in bulk": "Excluir agendamentos em massa",
            "Update schedule": "Atualizar agendamento",
            "Create schedules in bulk": "Criar agendamentos em massa",
            "Start schedule": "Iniciar agendamento",
            "Stop schedule": "Parar agendamento",
            "Lock schedule": "Bloquear agendamento",
            "End schedule": "Encerrar agendamento",
            "Request asset download": "Solicitar Download de ativo",
            "Retrieve asset download details": "Recuperar detalhes do Download de ativo",
            "Retrieve schedule history details": "Recuperar detalhes do histórico de agendamento",
            "Retrieve list of schedule histories": "Recuperar lista de históricos de agendamento",
            "Retrieve hidden metadata field value": "Recuperar valor do campo de metadados oculto",
            "Retrieve list of shared configurations for video": "Recuperar lista de configurações compartilhadas para vídeo",
            "Create shared configuration for video": "Criar configuração compartilhada para vídeo",
            "Retrieve shared configuration details for video": "Recuperar detalhes da configuração compartilhada para vídeo",
            "Update shared configuration for video": "Atualizar configuração compartilhada para vídeo",
            "Delete shared configuration from video": "Excluir configuração compartilhada do vídeo",
            "Retrieve list of content schemas": "Recuperar lista de schemas de conteúdo",
            "Attach teaser images to video in bulk": "Anexar imagens teaser ao vídeo em massa",
            "Detach teaser image from video": "Desanexar imagem teaser do vídeo",
            "Attach teaser videos to video in bulk": "Anexar vídeos teaser ao vídeo em massa",
            "Detach teaser video from video": "Desanexar vídeo teaser do vídeo",
            "Retrieve list of music": "Recuperar lista de músicas",
            "Retrieve music details": "Recuperar detalhes da música",
            "Update music": "Atualizar música",
            "Delete music": "Excluir música",
            "Create music": "Criar música",
            "Add file to music": "Adicionar arquivo à música",
            "Update file in music": "Atualizar arquivo na música",
            "Delete file from music": "Excluir arquivo da música",
            "Retrieve list of photos": "Recuperar lista de fotos",
            "Retrieve photo details": "Recuperar detalhes da foto",
            "Update photo": "Atualizar foto",
            "Delete photo": "Excluir foto",
            "Create photo": "Criar foto",
            "Add file to photo": "Adicionar arquivo à foto",
            "Update file in photo": "Atualizar arquivo na foto",
            "Delete file from photo": "Excluir arquivo da foto",
            "Retrieve asset file download link": "Recuperar link de Download do arquivo de ativo",
            "Retrieve download information": "Recuperar informações de Download",
            "Search": "Buscar",
            "Retrieve list of attributions": "Recuperar lista de atribuições",
            "Create attribution": "Criar atribuição",
            "Retrieve attribution details": "Recuperar detalhes da atribuição",
            "Update attribution": "Atualizar atribuição",
            "Delete attribution": "Excluir atribuição",
            "Retrieve list of asset files": "Recuperar lista de arquivos do ativo",
            "Retrieve list of file versions in asset": "Recuperar lista de versões de arquivo no ativo",
            "Attach categories to asset in bulk": "Associar categorias ao ativo em lote",
            "Detach categories from asset in bulk": "Desassociar categorias do ativo em lote",
            "Retrieve list of attribution keys": "Recuperar lista de chaves de atribuição",
            "Update owner of asset": "Atualizar proprietário do ativo",
            "Retrieve dashboard data": "Recuperar dados do painel",
            "Retrieve list of Actions for role": "Recuperar lista de ações para função",
            "Retrieve list of file meta keys": "Recuperar lista de chaves de metadados de arquivo",
            "Update project member": "Atualizar membro do projeto",
            "Update project team": "Atualizar equipe do projeto",
            "Retrieve list of related contents in asset": "Recuperar lista de conteúdos relacionados no ativo",
            "Retrieve list of asynchronous Jobs": "Recuperar lista de tarefas assíncronas",
            "Create asynchronous Job": "Criar tarefa assíncrona",
            "Update asynchronous Job": "Atualizar tarefa assíncrona",
            "Create asynchronous Job Action": "Criar ação de tarefa assíncrona",
            "Retrieve list of Tasks in asynchronous Job": "Recuperar lista de tarefas em tarefa assíncrona",
            "Create Task in asynchronous Job": "Criar tarefa em tarefa assíncrona",
            "Update Task in asynchronous Job": "Atualizar tarefa em tarefa assíncrona",
            "Request action on specific storage": "Solicitar ação em armazenamento específico",
            "Retrieve asynchronous Job details": "Recuperar detalhes da tarefa assíncrona",
            "Retrieve asynchronous Job Alias": "Recuperar alias da tarefa assíncrona",
            "Create Alias for asynchronous Job": "Criar alias para tarefa assíncrona",
            "Retrieve list of asynchronous Job Types": "Recuperar lista de tipos de tarefa assíncrona",
            "Create asynchronous Job Type": "Criar tipo de tarefa assíncrona",
            "Retrieve asynchronous Job Type details": "Recuperar detalhes do tipo de tarefa assíncrona",
            "Update asynchronous Job Type": "Atualizar tipo de tarefa assíncrona",
            "Delete asynchronous Job Type": "Excluir tipo de tarefa assíncrona",
            "Retrieve list of Actions in asynchronous Job Type": "Recuperar lista de ações no tipo de tarefa assíncrona",
            "Create Action in asynchronous Job Type": "Criar ação no tipo de tarefa assíncrona",
            "Update Action in asynchronous Job Type": "Atualizar ação no tipo de tarefa assíncrona",
            "Delete Action in asynchronous Job Type": "Excluir ação no tipo de tarefa assíncrona",
            "Update music in bulk": "Atualizar músicas em lote",
            "Update photos in bulk": "Atualizar fotos em lote",
            "Retrieve list of hidden metadata": "Recuperar lista de metadados ocultos",
            "Update People in bulk": "Atualizar pessoas em lote",
            "Retrieve list of item sets for metadata": "Recuperar lista de conjuntos de itens para metadados",
            "Create item set for metadata": "Criar conjunto de itens para metadados",
            "Update item set for metadata": "Atualizar conjunto de itens para metadados",
            "Delete item set for metadata": "Excluir conjunto de itens para metadados",
            "Retrieve list of elements in item set": "Recuperar lista de elementos no conjunto de itens",
            "Update videos in bulk": "Atualizar vídeos em lote",
            "Start asynchronous Job": "Iniciar tarefa assíncrona",
            "Complete asynchronous Job": "Concluir tarefa assíncrona",
            "Start Task in asynchronous Job": "Iniciar tarefa em tarefa assíncrona",
            "Complete Task in asynchronous Job": "Concluir tarefa em tarefa assíncrona",
            "Create asynchronous Job Alias": "Criar alias de tarefa assíncrona",
            "Retrieve asynchronous Job Alias details": "Recuperar detalhes do alias de tarefa assíncrona",
            "Request fms action on specific storage": "Solicitar ação fms em armazenamento específico",
            "Retrieve list of Searchable Buckets by admin": "Recuperar lista de buckets pesquisáveis por administrador",
            "Retrieve list of download jobs": "Recuperar lista de tarefas de Download",
            "Request download": "Solicitar Download",
            "Retrieve download job details": "Recuperar detalhes da tarefa de Download",
            "Retrieve list of download job tasks": "Recuperar lista de tarefas da tarefa de Download",
            "Retrieve download job task details": "Recuperar detalhes da tarefa de Download",
            "Retrieve download link": "Recuperar link de Download",
            "Retrieve list of Batch Jobs": "Recuperar lista de tarefas em lote",
            "Create Batch Job": "Criar tarefa em lote",
            "Retrieve Batch Job details": "Recuperar detalhes da tarefa em lote",
            "Retrieve list of Batch Job Tasks": "Recuperar lista de tarefas da tarefa em lote",
            "Retrieve Batch Job Task details": "Recuperar detalhes da tarefa da tarefa em lote",
            "Retrieve Presigned URL for S3 file": "Recuperar URL pré-assinada para arquivo S3",
            "Initiate multipart upload session for S3 file": "Iniciar sessão de upload multipart para arquivo S3",
            "Complete multipart upload for S3 file": "Concluir upload multipart para arquivo S3",
            "Abort multipart upload for S3 file": "Cancelar upload multipart para arquivo S3",
            "Retrieve Presigned URL for part upload in S3 file": "Recuperar URL pré-assinada para upload de parte em arquivo S3",
            "Retrieve Presigned URL for upload in S3 file": "Recuperar URL pré-assinada para upload em arquivo S3",
            "Retrieve integrated search list": "Recuperar lista de busca integrada",
            "Retrieve list of Resource Buckets assigned to me": "Recuperar lista de buckets de recursos atribuídos a mim",
            "Retrieve Task details in asynchronous Job": "Recuperar detalhes da tarefa em tarefa assíncrona",
            "Retrieve list of integrated search domains": "Recuperar lista de domínios de busca integrada",
            "Create integrated search domain": "Criar domínio de busca integrada",
            "Retrieve integrated search domain details": "Recuperar detalhes do domínio de busca integrada",
            "Delete integrated search domain": "Excluir domínio de busca integrada",
            "Retrieve list of shared links": "Recuperar lista de links compartilhados",
            "Share link": "Compartilhar link",
            "Retrieve shared link details": "Recuperar detalhes do link compartilhado",
            "Delete shared link": "Excluir link compartilhado",
            "Retrieve list of AWS S3 buckets": "Recuperar lista de buckets AWS S3",
            "Retrieve list of internal shares": "Recuperar lista de compartilhamentos internos",
            "Create internal share": "Criar compartilhamento interno",
            "Retrieve internal share details": "Recuperar detalhes do compartilhamento interno",
            "Update internal share": "Atualizar compartilhamento interno",
            "Update requester action in internal share": "Atualizar ação do solicitante no compartilhamento interno",
            "Update approver action in internal share": "Atualizar ação do aprovador no compartilhamento interno",
            "Retrieve list of approver candidates for internal share": "Recuperar lista de candidatos a aprovador para compartilhamento interno",
            "Retrieve list of shared resources": "Recuperar lista de recursos compartilhados",
            "Share resource": "Compartilhar recurso",
            "Retrieve shared resource details": "Recuperar detalhes do recurso compartilhado",
            "Delete shared resource": "Excluir recurso compartilhado",
            "Retrieve list of grantees for shared resource": "Recuperar lista de beneficiários do recurso compartilhado",
            "Add grantee to shared resource": "Adicionar beneficiário ao recurso compartilhado",
            "Retrieve grantee details for shared resource": "Recuperar detalhes do beneficiário do recurso compartilhado",
            "Update grantee for shared resource": "Atualizar beneficiário do recurso compartilhado",
            "Remove grantee from shared resource": "Excluir beneficiário do recurso compartilhado",
            "Check share permission": "Verificar permissão de compartilhamento",
            "Retrieve list of resources shared with me": "Recuperar lista de recursos compartilhados comigo",
            "Retrieve details of resource shared with me": "Recuperar detalhes do recurso compartilhado comigo",
            "Delete resource shared with me": "Excluir recurso compartilhado comigo",
            "Retrieve list of drives": "Recuperar lista de drives",
            "Retrieve drive details": "Recuperar detalhes do drive",
            "Update drive": "Atualizar drive",
            "Retrieve list of folders": "Recuperar lista de pastas",
            "Create folder": "Criar pasta",
            "Retrieve folder details": "Recuperar detalhes da pasta",
            "Update folder": "Atualizar pasta",
            "Delete folder": "Excluir pasta",
            "Move folder": "Mover pasta",
            "Retrieve list of metadata templates": "Recuperar lista de modelos de metadados",
            "Create metadata template": "Criar modelo de metadados",
            "Retrieve metadata template details": "Recuperar detalhes do modelo de metadados",
            "Update metadata template": "Atualizar modelo de metadados",
            "Delete metadata template": "Excluir modelo de metadados",
            "Register metadata template": "Registrar modelo de metadados",
            "Retrieve list of dashboard widgets": "Recuperar lista de widgets do painel",
            "Create dashboard widget": "Criar widget do painel",
            "Retrieve dashboard widget details": "Recuperar detalhes do widget do painel",
            "Update dashboard widget": "Atualizar widget do painel",
            "Delete dashboard widget": "Excluir widget do painel",
            "Retrieve list of dashboard widget data": "Recuperar lista de dados do widget do painel",
            "Retrieve list of storage folders": "Recuperar lista de pastas de armazenamento",
            "Retrieve list of storage files": "Recuperar lista de arquivos de armazenamento",
            "Move asset": "Mover ativo",
            "Request storage action": "Solicitar ação de armazenamento",
            "Lock Searchable Bucket": "Bloquear bucket pesquisável",
            "Unlock Searchable Bucket": "Desbloquear bucket pesquisável",
            "Retrieve list of multipart upload jobs": "Recuperar lista de tarefas de upload multipart",
            "Retrieve list of parts in multipart upload job": "Recuperar lista de partes na tarefa de upload multipart",
            "Retrieve list of collections": "Recuperar lista de coleções",
            "Create collection": "Criar coleção",
            "Retrieve collection details": "Recuperar detalhes da coleção",
            "Update collection": "Atualizar coleção",
            "Delete collection": "Excluir coleção",
            "Retrieve list of items in collection": "Recuperar lista de itens na coleção",
            "Update collection tags": "Atualizar tags da coleção",
            "Retrieve list of linked collections": "Recuperar lista de coleções vinculadas",
            "Request collection action": "Solicitar ação de coleção",
            "Retrieve list of content field types": "Recuperar lista de tipos de campo de conteúdo",
            "Create content field type": "Criar tipo de campo de conteúdo",
            "Retrieve content field type details": "Recuperar detalhes do tipo de campo de conteúdo",
            "Update content field type": "Atualizar tipo de campo de conteúdo",
            "Delete content field type": "Excluir tipo de campo de conteúdo",
            "Create content schema": "Criar esquema de conteúdo",
            "Request content schema field action": "Solicitar ação de campo de esquema de conteúdo",
            "Retrieve content schema details": "Recuperar detalhes do esquema de conteúdo",
            "Update content schema": "Atualizar esquema de conteúdo",
            "Delete content schema": "Excluir esquema de conteúdo",
            "Request content schema action": "Solicitar ação de esquema de conteúdo",
            "Retrieve list of projects assigned to content schema": "Recuperar lista de projetos atribuídos ao esquema de conteúdo",
            "Retrieve list of custom contents": "Recuperar lista de conteúdos personalizados",
            "Create custom content": "Criar conteúdo personalizado",
            "Retrieve custom content details": "Recuperar detalhes do conteúdo personalizado",
            "Update custom content": "Atualizar conteúdo personalizado",
            "Delete custom content": "Excluir conteúdo personalizado",
            "Request custom content action": "Solicitar ação de conteúdo personalizado",
            "Retrieve custom content field details": "Recuperar detalhes do campo de conteúdo personalizado",
            "Request custom content action in bulk": "Solicitar ação de conteúdo personalizado em lote",
            "Retrieve list of AI caption jobs": "Recuperar lista de tarefas de legenda de IA",
            "Create AI caption job": "Criar tarefa de legenda de IA",
            "Retrieve AI caption job details": "Recuperar detalhes da tarefa de legenda de IA",
            "Retrieve list of AI analysis jobs": "Recuperar lista de tarefas de análise de IA",
            "Create AI analysis job": "Criar tarefa de análise de IA",
            "Retrieve AI analysis job details": "Recuperar detalhes da tarefa de análise de IA",
            "Delete AI analysis job": "Excluir tarefa de análise de IA",
            "Retrieve list of AI analysis job summaries": "Recuperar lista de resumos da tarefa de análise de IA",
            "Retrieve list of AI analysis job results": "Recuperar lista de resultados da tarefa de análise de IA",
            "Retrieve list of AI analysis job original results": "Recuperar lista de resultados originais da tarefa de análise de IA",
            "Retrieve AI analysis job original result details": "Recuperar detalhes do resultado original da tarefa de análise de IA",
            "Callback for AI analysis job engine": "Callback para motor de tarefa de análise de IA",
            "Retrieve list of dictation vocabularies": "Recuperar lista de vocabulários de ditado",
            "Create dictation vocabulary": "Criar vocabulário de ditado",
            "Retrieve dictation vocabulary details": "Recuperar detalhes do vocabulário de ditado",
            "Delete dictation vocabulary": "Excluir vocabulário de ditado",
            "Update dictation vocabulary": "Atualizar vocabulário de ditado",
            "Retrieve list of phrases in vocabulary": "Recuperar lista de frases no vocabulário",
            "Request vocabulary phrase action": "Solicitar ação de frase no vocabulário",
            "Retrieve list of notifications": "Recuperar lista de notificações",
            "Create notification": "Criar notificação",
            "Retrieve notification details": "Recuperar detalhes da notificação",
            "Update notification": "Atualizar notificação",
            "Delete notification": "Excluir notificação",
            "Retrieve list of notification subscriptions": "Recuperar lista de assinaturas de notificação",
            "Subscribe to notification": "Assinar notificação",
            "Retrieve notification subscription details": "Recuperar detalhes da assinatura de notificação",
            "Unsubscribe from notification": "Cancelar assinatura de notificação",
            "Retrieve list of notification conditions": "Recuperar lista de condições de notificação",
            "Update notification conditions": "Atualizar condições de notificação",
            "Retrieve list of domain events": "Recuperar lista de eventos de domínio",
            "Retrieve download links for AI analysis job": "Recuperar links de Download para tarefa de análise de IA",
            "Retrieve list of asset versions": "Recuperar lista de versões do ativo",
            "Create asset version": "Criar versão do ativo",
            "Retrieve asset version details": "Recuperar detalhes da versão do ativo",
            "Delete asset version": "Excluir versão do ativo",
            "Retrieve list of comment threads": "Recuperar lista de threads de comentários",
            "Create comment thread": "Criar thread de comentário",
            "Retrieve list of comments in thread": "Recuperar lista de comentários no thread",
            "Create comment": "Criar comentário",
            "Update comment": "Atualizar comentário",
            "Delete comment": "Excluir comentário",
            "Request comment action": "Solicitar ação de comentário",
            "Delete comment thread": "Excluir thread de comentário",
            "Retrieve comment details": "Recuperar detalhes do comentário",
            "Update comment thread": "Atualizar thread de comentário",
            "Retrieve list of comments": "Recuperar lista de comentários",
            "Retrieve list of Action Groups": "Recuperar lista de grupos de ações",
            "Retrieve Action Group details": "Recuperar detalhes do grupo de ações",
            "Retrieve list of my space permissions": "Recuperar lista de permissões do meu espaço",
            "Retrieve list of my project permissions": "Recuperar lista de permissões do meu projeto",
            "Request role action": "Solicitar ação de função",
            "Retrieve list of entities by role": "Recuperar lista de entidades por função",
            "Assign role to entity": "Atribuir função à entidade",
            "Remove role from entity": "Remover função da entidade",
            "Create user": "Criar usuário",
            "Create team": "Criar equipe",
            "Update team": "Atualizar equipe",
            "Delete team": "Excluir equipe",
            "Assign member to team": "Atribuir membro à equipe",
            "Retrieve team member details": "Recuperar detalhes do membro da equipe",
            "Remove member from team": "Excluir membro da equipe",
            "Assign project member": "Atribuir membro ao projeto",
            "Retrieve project member details": "Recuperar detalhes do membro do projeto",
            "Remove project member": "Excluir membro do projeto",
            "Assign project team": "Atribuir equipe ao projeto",
            "Retrieve project team details": "Recuperar detalhes da equipe do projeto",
            "Remove project team": "Excluir equipe do projeto",
            "Retrieve list of project team members": "Recuperar lista de membros da equipe do projeto",
            "Retrieve project team member details": "Recuperar detalhes do membro da equipe do projeto",
            "Retrieve list of Resource Types": "Recuperar lista de tipos de recurso",
            "Copy asset": "Copiar ativo",
            "Retrieve list of collections by asset": "Recuperar lista de coleções por ativo",
            "Delete users in bulk": "Excluir usuários em lote",
            "Request team action": "Solicitar ação de equipe",
            "Delete teams in bulk": "Excluir equipes em lote",
            "Remove project members in bulk": "Excluir membros do projeto em lote",
            "Remove project teams in bulk": "Excluir equipes do projeto em lote",
            "Retrieve list of linked assets": "Recuperar lista de ativos vinculados",
            "Add linked asset": "Adicionar ativo vinculado",
            "Remove linked asset": "Excluir ativo vinculado",
            "Create comment attachment": "Criar anexo de comentário",
            "Delete comment attachment": "Excluir anexo de comentário",
            "Request user action": "Solicitar ação de usuário",
            "Retrieve list of project admins": "Recuperar lista de administradores do projeto",
            "Request project action": "Solicitar ação de projeto",
            "Retrieve list of project member's teams": "Recuperar lista de equipes do membro do projeto",
            "Retrieve list of project member's roles": "Recuperar lista de funções do membro do projeto",
            "Retrieve list of project team's roles": "Recuperar lista de funções da equipe do projeto",
            "Retrieve comment thread details": "Recuperar detalhes do thread de comentário",
            "Retrieve list of thread entities": "Recuperar lista de entidades do thread",
            "Create thread entity": "Criar entidade do thread",
            "Retrieve list of pending users for space invitation": "Recuperar lista de usuários pendentes para convite ao espaço de trabalho",
            "Request space user invitation": "Solicitar convite de usuário ao espaço de trabalho",
            "Retrieve list of pending users for project invitation": "Recuperar lista de usuários pendentes para convite ao projeto",
            "Request project user invitation": "Solicitar convite de usuário ao projeto",
            "Retrieve list of assignable members to team": "Recuperar lista de membros atribuíveis à equipe",
            "Create exported metadata job": "Criar tarefa de exportação de metadados",
            "Retrieve list of exported metadata jobs": "Recuperar lista de tarefas de exportação de metadados",
            "Retrieve exported metadata job details": "Recuperar detalhes da tarefa de exportação de metadados",
            "Update exported metadata job": "Atualizar tarefa de exportação de metadados",
            "Delete exported metadata job": "Excluir tarefa de exportação de metadados",
            "Retrieve upload Presigned URL for preview resource": "Recuperar URL Presigned de Upload para recurso de Pré-visualização",
            "Request preview resource action": "Solicitar ação de recurso de pré-visualização",
            "Retrieve list of audit log search keys": "Recuperar lista de chaves de busca do log de auditoria",
            "Retrieve embed URL for posting": "Recuperar URL de incorporação para publicação",
            "Request role management action": "Solicitar ação de gerenciamento de função",
            "Retrieve list of report settings": "Recuperar lista de configurações de relatório",
            "Retrieve report setting details": "Recuperar detalhes da configuração de relatório",
            "Update report setting": "Atualizar configuração de relatório",
            "Retrieve list of reports": "Recuperar lista de relatórios",
            "Retrieve report details": "Recuperar detalhes do relatório",
            "Retrieve list of report subscribers": "Recuperar lista de assinantes do relatório",
            "Capture asset frame": "Capturar quadro do ativo",
            "Retrieve list of links": "Recuperar lista de links",
            "Create link": "Criar link",
            "Update link": "Atualizar link",
            "Delete link": "Excluir link",
            "Create drive": "Criar drive",
            "Delete drive": "Excluir drive",
            "Validate share grantee": "Validar beneficiário de compartilhamento",
            "Apply asset owner lock": "Aplicar bloqueio de proprietário do ativo",
            "Release asset owner lock": "Liberar bloqueio de proprietário do ativo",
            "Create video clip from asset": "Criar clipe de vídeo a partir do ativo",
            "Retrieve list of favorite resources": "Recuperar lista de recursos favoritos",
            "Create favorite resource": "Criar recurso favorito",
            "Delete favorite resource": "Excluir recurso favorito",
            "Retrieve list of custom menu sets": "Recuperar lista de conjuntos de menus personalizados",
            "Create custom menu set": "Criar conjunto de menus personalizado",
            "Retrieve custom menu set details": "Recuperar detalhes do conjunto de menus personalizado",
            "Update custom menu set": "Atualizar conjunto de menus personalizado",
            "Delete custom menu set": "Excluir conjunto de menus personalizado",
            "Request custom menu set action": "Solicitar ação de conjunto de menus personalizado",
            "Retrieve list of custom menus": "Recuperar lista de menus personalizados",
            "Create custom menu": "Criar menu personalizado",
            "Retrieve custom menu details": "Recuperar detalhes do menu personalizado",
            "Update custom menu": "Atualizar menu personalizado",
            "Delete custom menu": "Excluir menu personalizado",
            "Retrieve list of asset histories": "Recuperar lista de históricos do ativo",
            "Retrieve asset history details": "Recuperar detalhes do histórico do ativo",
            "Retrieve integrated search detailed list": "Recuperar lista detalhada de busca integrada",
            "Retrieve list of my requests": "Recuperar lista das minhas solicitações",
            "Retrieve my request details": "Recuperar detalhes da minha solicitação",
            "Update my request": "Atualizar minha solicitação",
            "Delete my request": "Excluir minha solicitação",
            "Create request": "Criar solicitação",
            "Retrieve list of requests": "Recuperar lista de solicitações",
            "Retrieve request details": "Recuperar detalhes da solicitação",
            "Update request": "Atualizar solicitação",
            "Delete request": "Excluir solicitação",
            "Update request status": "Atualizar status da solicitação",
            "Create attachment in my request": "Criar anexo na minha solicitação",
            "Delete attachment from my request": "Excluir anexo da minha solicitação",
            "Create attachment in request": "Criar anexo na solicitação",
            "Delete attachment from request": "Excluir anexo da solicitação",
            "Retrieve list of request categories": "Recuperar lista de categorias de solicitação",
            "Retrieve list of assets shared with me": "Recuperar lista de ativos compartilhados comigo",
            "Share asset": "Compartilhar ativo",
            "Retrieve list of shared assets": "Recuperar lista de ativos compartilhados",
            "Unshare asset": "Cancelar compartilhamento do ativo",
            "Assign request assignee": "Atribuir responsável pela solicitação",
            "Retrieve custom metadata details of asset": "Recuperar detalhes de metadados personalizados do ativo",
            "Retrieve list of projects for asset shared with me": "Recuperar lista de projetos para o ativo compartilhado comigo",
            "Retrieve list of user agreements": "Recuperar lista de acordos do usuário",
            "Retrieve user agreement details": "Recuperar detalhes do acordo do usuário",
            "Update user agreement consent": "Atualizar consentimento do acordo do usuário",
            "Create favorite resources in bulk": "Criar recursos favoritos em massa",
            "Delete favorite resources in bulk": "Excluir recursos favoritos em massa",
            "Retrieve list of supported regions by provider": "Recuperar lista de regiões suportadas por provedor",
            "Update asset share": "Atualizar compartilhamento de ativo",
            "Retrieve list of assets I shared": "Recuperar lista de ativos que compartilhei",
            "Retrieve list of projects for asset shared by me": "Recuperar lista de projetos para o ativo compartilhado por mim",
            "Retrieve list of asset owners": "Recuperar lista de proprietários de ativos",
            "Retrieve list of usage metric tenants": "Recuperar lista de locatários de métricas de uso",
            "Retrieve list of usage metrics": "Recuperar lista de métricas de uso",
            "Retrieve list of usage metric data": "Recuperar lista de dados de métricas de uso",
            "Retrieve assignable storages": "Recuperar armazenamentos atribuíveis",
            "Retrieve assigned storages": "Recuperar armazenamentos atribuídos",
            "Manage project storages": "Gerenciar armazenamentos do projeto",
            "Update owners of assets in bulk": "Atualizar proprietários de ativos em massa",
            "Callback for Gen AI service": "Callback para serviço de Gen AI",
            "Create AI job in request": "Criar tarefa de AI na solicitação",
            "AI Source Synchronization": "Sincronização de Fonte de AI",
            "Delete Gen AI Source": "Excluir Fonte de Gen AI",
            "Create prompt preset": "Criar predefinição de prompt",
            "Update prompt preset": "Atualizar predefinição de prompt",
            "Delete prompt preset": "Excluir predefinição de prompt",
            "Update prompt preset status": "Atualizar status da predefinição de prompt"
        }
    }
}
